import type { SVGProps } from "react";

const WarrantyIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
    >
      <path
        d="M0.253708 5.06776H0.287237C0.26209 5.06776 0.26209 5.07982 0.253708 5.09792L0.270472 5.10999C0.253708 5.10999 0.253708 5.12206 0.245325 5.12809L0.26209 5.14619C0.203413 5.14619 0.136356 5.20652 0.0692967 5.14016L0.0357666 5.06172H0.0441495C0.0357671 5.02552 0.0692967 5.01346 0.0692967 4.98329V4.97123L0.102826 4.98329C0.111208 4.96519 0.111208 4.98932 0.127973 4.98329L0.15312 4.95312C0.161503 4.95916 0.15312 4.96519 0.15312 4.97123C0.15312 4.97726 0.169884 4.97123 0.178266 4.96519C0.186649 4.95916 0.211796 4.98932 0.245325 5.01346L0.26209 5.00139C0.245325 5.00742 0.253708 5.01949 0.245325 5.02553H0.287237C0.278855 5.04966 0.236943 5.04362 0.253708 5.06776Z"
        fill="white"
      />
      <path
        d="M0.110597 6.74511C0.102214 6.73304 0.0854492 6.73304 0.0854492 6.72098C0.0854492 6.70891 0.127361 6.70288 0.144125 6.70891C0.16089 6.71494 0.152508 6.73908 0.110597 6.74511Z"
        fill="white"
      />
      <path
        d="M0.0351939 7.662C0.0268115 7.66803 0.0100474 7.662 0.00166501 7.65596C-0.00671733 7.64993 0.0184292 7.6258 0.0351939 7.61373C0.0519586 7.60166 0.0351946 7.6258 0.068724 7.6258C0.0699416 7.62976 0.0700327 7.63387 0.0689926 7.63786C0.0679526 7.64185 0.0658029 7.64566 0.0626716 7.64904C0.0595403 7.65242 0.0554917 7.65531 0.0507701 7.65754C0.0460485 7.65976 0.0407503 7.66128 0.0351939 7.662Z"
        fill="white"
      />
      <path
        d="M0.253708 5.06776H0.287237C0.26209 5.06776 0.26209 5.07982 0.253708 5.09792L0.270472 5.10999C0.253708 5.10999 0.253708 5.12206 0.245325 5.12809L0.26209 5.14619C0.203413 5.14619 0.136356 5.20652 0.0692967 5.14016L0.0357666 5.06172H0.0441495C0.0357671 5.02552 0.0692967 5.01346 0.0692967 4.98329V4.97123L0.102826 4.98329C0.111208 4.96519 0.111208 4.98932 0.127973 4.98329L0.15312 4.95312C0.161503 4.95916 0.15312 4.96519 0.15312 4.97123C0.15312 4.97726 0.169884 4.97123 0.178266 4.96519C0.186649 4.95916 0.211796 4.98932 0.245325 5.01346L0.26209 5.00139C0.245325 5.00742 0.253708 5.01949 0.245325 5.02553H0.287237C0.278855 5.04966 0.236943 5.04362 0.253708 5.06776Z"
        fill="white"
      />
      <path
        d="M0.110597 6.74511C0.102214 6.73304 0.0854492 6.73304 0.0854492 6.72098C0.0854492 6.70891 0.127361 6.70288 0.144125 6.70891C0.16089 6.71494 0.152508 6.73908 0.110597 6.74511Z"
        fill="white"
      />
      <path
        d="M0.0351939 7.662C0.0268115 7.66803 0.0100474 7.662 0.00166501 7.65596C-0.00671733 7.64993 0.0184292 7.6258 0.0351939 7.61373C0.0519586 7.60166 0.0351946 7.6258 0.068724 7.6258C0.0699416 7.62976 0.0700327 7.63387 0.0689926 7.63786C0.0679526 7.64185 0.0658029 7.64566 0.0626716 7.64904C0.0595403 7.65242 0.0554917 7.65531 0.0507701 7.65754C0.0460485 7.65976 0.0407503 7.66128 0.0351939 7.662Z"
        fill="white"
      />
      <path
        d="M8.29909 2.02466C8.29396 2.03699 8.28882 2.03699 8.27854 2.03699C8.27584 2.03137 8.27441 2.02499 8.27441 2.0185C8.27441 2.012 8.27584 2.00562 8.27854 2C8.28882 2.01233 8.30423 2 8.29909 2.02466Z"
        fill="white"
      />
      <path
        d="M6.9059 2.15126H6.88493C6.86396 2.13239 6.87968 2.10093 6.87968 2.07577C6.87968 2.05061 6.87969 2.05061 6.89541 2.04432C6.91114 2.03802 6.92687 2.11351 6.9059 2.15126Z"
        fill="white"
      />
      <path
        d="M8.29909 2.02466C8.29396 2.03699 8.28882 2.03699 8.27854 2.03699C8.27584 2.03137 8.27441 2.02499 8.27441 2.0185C8.27441 2.012 8.27584 2.00562 8.27854 2C8.28882 2.01233 8.30423 2 8.29909 2.02466Z"
        fill="white"
      />
      <path
        d="M6.9059 2.15126H6.88493C6.86396 2.13239 6.87968 2.10093 6.87968 2.07577C6.87968 2.05061 6.87969 2.05061 6.89541 2.04432C6.91114 2.03802 6.92687 2.11351 6.9059 2.15126Z"
        fill="white"
      />
      <path
        d="M15.1362 20.2144L14.3813 20.4912L13.9975 20.6233C13.9366 20.6376 13.8776 20.6587 13.8214 20.6862C13.7836 20.7113 13.7585 20.7805 13.7333 20.8183C13.4759 21.2273 13.2608 21.6615 13.0916 22.1142L13.1231 22.1016C11.9146 20.5837 11.3479 18.6532 11.5441 16.7229C11.6078 16.1535 11.7323 15.5925 11.9153 15.0496L11.9027 15.0684C12.7996 15.1103 13.6895 15.2474 14.5574 15.4774L14.5385 15.1817C13.9849 16.5594 13.9598 18.1761 14.5574 19.5475C14.7123 19.8923 14.9043 20.2193 15.1299 20.5226C15.155 20.5604 15.1676 20.422 15.1739 20.4157C15.1815 20.3496 15.1729 20.2826 15.1488 20.2207C14.7668 19.7097 14.4905 19.1278 14.3361 18.5089C14.1816 17.89 14.1521 17.2465 14.2492 16.616C14.3138 16.219 14.4235 15.8306 14.5763 15.4585C14.5918 15.399 14.5982 15.3375 14.5952 15.276C14.5889 15.2509 14.5889 15.1691 14.5574 15.1628C13.6895 14.9328 12.7996 14.7958 11.9027 14.7539C11.8901 14.7602 11.8838 14.7665 11.8838 14.7791C11.5328 15.8125 11.3854 16.9042 11.4497 17.9937C11.5074 19.0249 11.7638 20.0353 12.2046 20.9693C12.451 21.4789 12.7527 21.9599 13.1042 22.4036C13.1168 22.4162 13.1231 22.3973 13.1294 22.3847C13.2935 21.9432 13.5022 21.5195 13.7522 21.1202C13.7836 21.0699 13.8088 21.0133 13.8654 20.9881C13.922 20.963 13.9975 20.9441 14.0604 20.9189L14.4064 20.7994L15.1362 20.5289C15.2117 20.5037 15.155 20.2081 15.1362 20.2144Z"
        fill="#00244C"
      />
      <path
        d="M15.1739 20.3092C14.7587 20.4853 14.3309 20.6552 13.9032 20.8061C12.7582 19.202 12.4751 17.0065 13.3496 15.0186C13.7585 15.1192 14.1611 15.2387 14.5511 15.3771C13.7522 17.1197 14.0919 19.0321 15.1739 20.3092Z"
        fill="#00244C"
      />
      <path
        d="M6.28487 19.5351C6.51135 19.6526 6.73782 19.7784 6.96429 19.9126L7.31657 20.1265C7.37626 20.1562 7.43135 20.1943 7.48014 20.2397C7.51525 20.2868 7.54089 20.3402 7.55563 20.397C7.73499 20.8568 7.85957 21.3361 7.92679 21.825C7.93308 21.8376 7.93937 21.9194 7.97082 21.9005C8.66814 21.2361 9.23748 20.4493 9.65048 19.5792C10.0907 18.6391 10.3551 17.6263 10.4305 16.591C10.4788 15.9558 10.464 15.3173 10.3865 14.6849C10.3802 14.666 10.3802 14.6157 10.3551 14.6094C9.41253 14.2379 8.41126 14.0376 7.39836 14.0181C7.34803 14.0181 7.3669 14.2571 7.37319 14.2886C7.58006 15.0031 7.63787 15.7526 7.54304 16.4904C7.45243 17.1577 7.23232 17.801 6.89509 18.3839C6.71897 18.6869 6.51012 18.9695 6.27229 19.2269C6.23455 19.2646 6.24713 19.3716 6.24713 19.4219C6.24713 19.4722 6.266 19.5603 6.29117 19.5289C7.2977 18.4468 7.71919 16.937 7.64999 15.4838C7.62786 15.003 7.55189 14.5261 7.42352 14.0621L7.39836 14.3326C8.41126 14.3522 9.41253 14.5524 10.3551 14.9239L10.3236 14.8485C10.4521 15.8492 10.3902 16.8652 10.1412 17.8429C9.90777 18.7716 9.50698 19.6499 8.95849 20.4347C8.66406 20.8545 8.32673 21.2424 7.95195 21.5922L7.98969 21.6677C7.91487 21.1409 7.78195 20.624 7.59337 20.1265C7.57356 20.0656 7.5483 20.0067 7.51788 19.9503C7.47171 19.9063 7.41857 19.8701 7.36061 19.8434L7.01461 19.6295L6.28487 19.2206C6.25971 19.208 6.24713 19.3653 6.24713 19.3779C6.24713 19.3905 6.24084 19.51 6.28487 19.5351Z"
        fill="#00244C"
      />
      <path
        d="M9.95202 13.4766C11.1724 16.8422 9.98348 20.0757 7.93266 21.6672C7.8762 21.095 7.73192 20.5348 7.50488 20.0065C8.524 18.9685 9.18454 17.3077 8.97065 15.4079C9.38665 14.8133 9.717 14.1631 9.95202 13.4766Z"
        fill="#00244C"
      />
      <path
        d="M17.6461 11.1747C17.8065 11.4655 17.8994 11.7886 17.918 12.1201C17.9365 12.4517 17.8803 12.7831 17.7535 13.09C17.6266 13.3969 17.4324 13.6713 17.1851 13.8929C16.9378 14.1146 16.6439 14.2778 16.325 14.3705C15.9668 14.475 15.6407 14.6681 15.3768 14.932C15.1129 15.1959 14.9198 15.522 14.8152 15.8803C14.7215 16.1992 14.5575 16.493 14.3354 16.7403C14.1132 16.9876 13.8386 17.182 13.5315 17.3093C13.2244 17.4366 12.8928 17.4935 12.5608 17.4759C12.2289 17.4583 11.9051 17.3667 11.6132 17.2076C11.2865 17.0281 10.9197 16.934 10.5469 16.934C10.1741 16.934 9.80732 17.0281 9.48059 17.2076C9.1887 17.3667 8.86491 17.4583 8.53297 17.4759C8.20103 17.4935 7.86936 17.4366 7.56229 17.3093C7.25523 17.182 6.98055 16.9876 6.75841 16.7403C6.53627 16.493 6.37231 16.1992 6.27855 15.8803C6.17298 15.5225 5.9795 15.197 5.71577 14.9332C5.45204 14.6695 5.12646 14.476 4.76875 14.3705C4.45003 14.2775 4.15621 14.1142 3.90891 13.8927C3.66162 13.6712 3.46714 13.397 3.33979 13.0904C3.21244 12.7838 3.15546 12.4526 3.17304 12.121C3.19062 11.7895 3.28231 11.4661 3.44138 11.1747C3.62088 10.8468 3.71497 10.479 3.71497 10.1053C3.71497 9.73146 3.62088 9.36368 3.44138 9.03581C3.28231 8.74439 3.19062 8.42102 3.17304 8.08948C3.15546 7.75794 3.21244 7.42668 3.33979 7.12008C3.46714 6.81347 3.66162 6.53932 3.90891 6.3178C4.15621 6.09628 4.45003 5.93303 4.76875 5.84006C5.127 5.73554 5.45313 5.54241 5.71701 5.27853C5.9809 5.01464 6.17402 4.68851 6.27855 4.33026C6.37231 4.01135 6.53627 3.71747 6.75841 3.47019C6.98055 3.22291 7.25523 3.02849 7.56229 2.9012C7.86936 2.77391 8.20103 2.71697 8.53297 2.73457C8.86491 2.75216 9.1887 2.84385 9.48059 3.00289C9.80732 3.1824 10.1741 3.27653 10.5469 3.27653C10.9197 3.27653 11.2865 3.1824 11.6132 3.00289C11.9051 2.84385 12.2289 2.75216 12.5608 2.73457C12.8928 2.71697 13.2244 2.77391 13.5315 2.9012C13.8386 3.02849 14.1132 3.22291 14.3354 3.47019C14.5575 3.71747 14.7215 4.01135 14.8152 4.33026C14.9187 4.68905 15.1115 5.01574 15.3755 5.27978C15.6396 5.54383 15.9662 5.73659 16.325 5.84006C16.6439 5.93273 16.9378 6.09593 17.1851 6.31757C17.4324 6.53921 17.6266 6.81363 17.7535 7.1205C17.8803 7.42737 17.9365 7.75885 17.918 8.09038C17.8994 8.42192 17.8065 8.74504 17.6461 9.03581C17.4666 9.36368 17.3725 9.73146 17.3725 10.1053C17.3725 10.479 17.4666 10.8468 17.6461 11.1747Z"
        fill="url(#paint0_linear_888_37319)"
      />
      <path
        d="M16.8659 11.2061C17.0208 11.4754 17.0971 11.7827 17.0861 12.0931C17.0572 12.4105 16.9443 12.7146 16.7589 12.9738C16.5669 13.2524 16.3071 13.4776 16.004 13.6281C15.8405 13.7036 15.6706 13.7413 15.5133 13.8042C15.3434 13.8744 15.1829 13.9652 15.0352 14.0747C14.7412 14.3061 14.5152 14.6125 14.381 14.9617C14.3181 15.1253 14.274 15.2889 14.1986 15.4461C14.1168 15.5977 14.0175 15.7391 13.9029 15.8676C13.6767 16.11 13.394 16.2926 13.0801 16.3991C12.7661 16.5056 12.4307 16.5327 12.1037 16.4778C11.9346 16.4445 11.77 16.3917 11.613 16.3206C11.4366 16.2249 11.2512 16.1469 11.0594 16.0878C10.6315 15.9751 10.1784 16.006 9.76979 16.1759C9.60623 16.2451 9.44896 16.3394 9.27282 16.4023C9.11363 16.4545 8.949 16.4883 8.78213 16.503C8.45174 16.5236 8.12133 16.4631 7.81963 16.3269C7.58769 16.2224 7.37875 16.0729 7.20491 15.8872C7.03106 15.7015 6.89576 15.4832 6.8068 15.2448C6.75494 15.0743 6.68973 14.9081 6.61179 14.7479C6.44257 14.4183 6.18571 14.1419 5.86947 13.9489C5.56122 13.7665 5.19635 13.7099 4.89439 13.5148C4.37225 13.1877 3.96963 12.5461 4.00738 11.9296C4.01533 11.772 4.04934 11.6168 4.10803 11.4703C4.17094 11.2942 4.27159 11.1369 4.34079 10.9608C4.50265 10.5266 4.53756 10.0553 4.44145 9.60194C4.39641 9.3934 4.32229 9.19222 4.22127 9.00431C4.13835 8.85205 4.07695 8.68904 4.03883 8.51991C3.98007 8.23395 4.00407 7.93716 4.10803 7.66436C4.22296 7.35439 4.41578 7.07924 4.66792 6.86542C4.79959 6.75246 4.94553 6.65729 5.10198 6.58233C5.25926 6.50684 5.42911 6.4691 5.59267 6.3999C5.93997 6.2592 6.24077 6.02379 6.46081 5.72048C6.56758 5.56873 6.65428 5.4038 6.71873 5.2298C6.78164 5.06624 6.82568 4.90267 6.90117 4.7454C7.14455 4.29956 7.54937 3.96379 8.03252 3.80703C8.51567 3.65027 9.04051 3.6844 9.49929 3.90243C9.67733 3.99924 9.86497 4.07725 10.0592 4.13519C10.4828 4.2366 10.9276 4.20137 11.3299 4.03454C11.4998 3.95905 11.6508 3.86468 11.8269 3.80807C12.1468 3.69968 12.4898 3.67797 12.8209 3.74516C13.1506 3.80722 13.4588 3.95331 13.7155 4.16931C13.9723 4.38531 14.169 4.66391 14.2866 4.97816C14.3495 5.14173 14.3999 5.31158 14.4816 5.47514C14.5697 5.63867 14.6774 5.79079 14.8025 5.92808C15.0609 6.18856 15.3813 6.37906 15.7335 6.48168C16.0544 6.58145 16.3441 6.76246 16.5745 7.00715C16.8048 7.25184 16.9681 7.5519 17.0483 7.87825C17.1158 8.16941 17.0939 8.47417 16.9854 8.75267C16.9162 8.93511 16.8093 9.09867 16.7401 9.27481C16.6657 9.48814 16.6192 9.71014 16.6017 9.93535C16.5715 10.3752 16.6629 10.8148 16.8659 11.2061C16.8847 11.2438 16.9099 11.0992 16.9099 11.0992C16.9206 11.0331 16.9118 10.9653 16.8847 10.9041C16.7779 10.7147 16.71 10.5058 16.6852 10.2897C16.6603 10.0736 16.679 9.85473 16.7401 9.64597C16.803 9.45725 16.9099 9.2874 16.9854 9.10496C17.0547 8.93745 17.1033 8.76211 17.1301 8.58282C17.237 7.88454 17.042 7.13593 16.5325 6.63895C16.2745 6.39361 15.9726 6.24892 15.6392 6.13568C15.2661 6.01724 14.9373 5.78927 14.6955 5.48143C14.5785 5.3275 14.4832 5.15815 14.4124 4.97816C14.3495 4.80831 14.3055 4.64475 14.23 4.48748C14.0739 4.17879 13.8396 3.91637 13.5506 3.72629C13.2669 3.53907 12.9402 3.42701 12.6013 3.4006C12.2624 3.37419 11.9223 3.4343 11.613 3.57531C11.4243 3.66338 11.2481 3.76403 11.0468 3.81436C10.6111 3.92692 10.1501 3.88924 9.73834 3.70741C9.57476 3.62295 9.40677 3.54735 9.23507 3.48094C8.91008 3.38297 8.56564 3.3685 8.23358 3.43887C7.90151 3.50924 7.59255 3.66218 7.33524 3.88356C7.07145 4.10739 6.87356 4.3988 6.76277 4.72653C6.70829 4.90201 6.63883 5.07249 6.55517 5.23609C6.36234 5.57622 6.0735 5.85193 5.72478 6.02874C5.56122 6.11052 5.38507 6.14826 5.21522 6.21746C4.89516 6.34499 4.61346 6.55301 4.39741 6.82138C3.95076 7.37498 3.83123 8.16133 4.01367 8.84075C4.06381 9.01076 4.13127 9.17518 4.21497 9.33143C4.32513 9.53161 4.39361 9.75203 4.41628 9.97939C4.43096 10.1812 4.40748 10.3839 4.34708 10.577C4.28417 10.7657 4.17723 10.9356 4.10174 11.118C3.83123 11.7786 3.88156 12.5901 4.25901 13.194C4.43646 13.4816 4.68581 13.7179 4.98246 13.8797C5.13922 13.9623 5.30353 14.0297 5.47314 14.081C5.65844 14.1448 5.83412 14.2337 5.99529 14.3452C6.31202 14.5732 6.55308 14.891 6.68728 15.2574C6.7353 15.4263 6.79846 15.5905 6.876 15.7481C6.95345 15.8988 7.05078 16.0385 7.16538 16.1633C7.39315 16.4116 7.67927 16.5992 7.99783 16.709C8.31638 16.8189 8.65731 16.8475 8.98973 16.7924C9.16687 16.7606 9.3385 16.7034 9.49929 16.6225C9.68168 16.5256 9.8735 16.4477 10.0718 16.3898C10.5096 16.2826 10.9708 16.327 11.3802 16.5156C11.5412 16.5991 11.7072 16.6727 11.8772 16.7358C12.0407 16.7849 12.2099 16.8124 12.3805 16.8175C12.7192 16.831 13.0555 16.7551 13.3556 16.5974C13.6537 16.4447 13.9089 16.2197 14.0979 15.9431C14.1999 15.7959 14.2804 15.6349 14.3369 15.465C14.3903 15.2891 14.4598 15.1186 14.5445 14.9554C14.7424 14.6179 15.0357 14.3465 15.3875 14.1754C15.5511 14.0936 15.7272 14.0559 15.8971 13.9867C16.0557 13.9214 16.2057 13.8369 16.3437 13.735C16.9162 13.301 17.1804 12.6027 17.1552 11.8918C17.1452 11.5457 17.0524 11.2071 16.8847 10.9041C16.8659 10.8664 16.847 11.0048 16.8407 11.0111C16.8331 11.0772 16.8417 11.1441 16.8659 11.2061Z"
        fill="white"
      />
      <path
        d="M10.9276 7.04166L11.6636 8.53259C11.6952 8.59376 11.7406 8.64668 11.7964 8.68711C11.8521 8.72753 11.9165 8.75433 11.9844 8.76535L13.6326 9.0044C13.7118 9.01556 13.7863 9.04869 13.8476 9.10002C13.9089 9.15135 13.9545 9.21884 13.9794 9.29482C14.0043 9.3708 14.0074 9.45223 13.9884 9.52988C13.9693 9.60754 13.9289 9.6783 13.8717 9.73414L12.6764 10.8917C12.6284 10.9409 12.5926 11.0006 12.5719 11.0662C12.5511 11.1317 12.546 11.2012 12.5569 11.2691L12.8337 12.911C12.8482 12.9894 12.8402 13.0702 12.8106 13.1442C12.781 13.2182 12.7311 13.2823 12.6665 13.3291C12.602 13.3759 12.5255 13.4034 12.446 13.4084C12.3665 13.4135 12.2871 13.3959 12.2172 13.3577L10.7451 12.5902C10.6847 12.556 10.6164 12.538 10.547 12.538C10.4775 12.538 10.4093 12.556 10.3488 12.5902L8.87676 13.3577C8.80639 13.395 8.727 13.412 8.64751 13.4067C8.56802 13.4013 8.4916 13.3739 8.42687 13.3275C8.36213 13.281 8.31164 13.2174 8.28109 13.1439C8.25054 13.0703 8.24115 12.9896 8.25397 12.911L8.53705 11.2691C8.54668 11.2007 8.54032 11.1311 8.51849 11.0656C8.49666 11.0001 8.45995 10.9406 8.41124 10.8917L7.22226 9.73414C7.16504 9.6783 7.12462 9.60754 7.10557 9.52988C7.08653 9.45223 7.08963 9.3708 7.11452 9.29482C7.13941 9.21884 7.18509 9.15135 7.24639 9.10002C7.30769 9.04869 7.38215 9.01556 7.46132 9.0044L9.10323 8.76535C9.17118 8.75433 9.2356 8.72753 9.29131 8.68711C9.34703 8.64668 9.3925 8.59376 9.42406 8.53259L10.1664 7.04166C10.2006 6.96971 10.2545 6.90894 10.3219 6.8664C10.3893 6.82385 10.4673 6.80127 10.547 6.80127C10.6267 6.80127 10.7047 6.82385 10.7721 6.8664C10.8394 6.90894 10.8933 6.96971 10.9276 7.04166Z"
        fill="white"
      />
      <path
        d="M5.58691 3.27317L5.60556 3.26074L5.59313 3.27317H5.58691Z"
        fill="white"
      />
      <path
        d="M5.55518 3.28577L5.56751 3.27344L5.57984 3.28577H5.55518Z"
        fill="white"
      />
      <path
        d="M9.23559 6.95316C9.23559 6.97203 9.21672 6.97832 9.21672 6.99719C9.2042 7.0012 9.19061 7.00016 9.17886 6.99428C9.1671 6.9884 9.15811 6.97816 9.15381 6.96574C9.15458 6.95131 9.15985 6.93749 9.16887 6.92621C9.1779 6.91493 9.19023 6.90675 9.20413 6.90283C9.21471 6.90579 9.2238 6.91259 9.22961 6.9219C9.23543 6.93121 9.23756 6.94236 9.23559 6.95316Z"
        fill="white"
      />
      <path
        d="M9.31759 7.12349C9.29871 7.13607 9.29242 7.1172 9.27984 7.11091C9.27947 7.10168 9.28095 7.09248 9.28419 7.08384C9.28743 7.07519 9.29237 7.06729 9.29871 7.06058C9.33017 7.048 9.36791 7.09832 9.31759 7.12349Z"
        fill="white"
      />
      <path
        d="M8.95823 3.896L8.95201 3.91464L8.9458 3.90843L8.95823 3.896Z"
        fill="white"
      />
      <path
        d="M8.79524 4.09735L8.77637 4.08476C8.77637 4.04702 8.81411 4.02815 8.84557 4.02186C8.87702 4.01557 8.82669 4.09106 8.79524 4.09735Z"
        fill="white"
      />
      <path
        d="M6.63141 7.60147H6.65029V7.63922C6.69432 7.65809 6.63141 7.68955 6.65029 7.70842C6.63681 7.72687 6.61856 7.7413 6.59751 7.75017C6.57645 7.75903 6.55337 7.762 6.53076 7.75874C6.49301 7.73987 6.5056 7.72729 6.46785 7.70213C6.43011 7.67696 6.41123 7.63922 6.47414 7.61406C6.53705 7.58889 6.51818 7.58889 6.53705 7.55115C6.55592 7.5134 6.56221 7.56373 6.5748 7.56373L6.59367 7.55115C6.58738 7.5826 6.61883 7.57631 6.64399 7.57631C6.66916 7.57631 6.63141 7.58889 6.63141 7.60147Z"
        fill="white"
      />
      <path
        d="M10.6185 2.00859C10.6181 2.02187 10.6138 2.03473 10.6062 2.04558C10.5939 2.03325 10.5815 2.03325 10.5815 2.01476C10.5815 1.99626 10.6124 1.99626 10.6185 2.00859Z"
        fill="white"
      />
      <path
        d="M10.978 2.11586C10.9654 2.13473 10.9528 2.17876 10.9276 2.16618C10.9025 2.1536 10.8836 2.14102 10.8899 2.10327C10.8962 2.06553 10.9151 2.07182 10.9213 2.05295C10.9276 2.03407 10.9591 2.0844 10.978 2.11586Z"
        fill="white"
      />
      <path
        d="M10.6944 2.06489C10.6944 2.07722 10.6944 2.08339 10.6882 2.08955C10.6821 2.09572 10.6636 2.08339 10.6636 2.07106C10.6636 2.05872 10.6882 2.04023 10.6944 2.06489Z"
        fill="white"
      />
      <path
        d="M9.97774 2.12849C9.97303 2.14145 9.96419 2.1525 9.95258 2.15994C9.94 2.14736 9.92742 2.15365 9.92112 2.13478C9.91836 2.13026 9.91678 2.12512 9.91654 2.11983C9.91629 2.11454 9.91738 2.10928 9.91971 2.10453C9.92204 2.09977 9.92554 2.09568 9.92987 2.09264C9.9342 2.08959 9.93922 2.08769 9.94448 2.08711C9.94975 2.08652 9.95507 2.08727 9.95996 2.0893C9.96486 2.09132 9.96916 2.09454 9.97248 2.09866C9.97579 2.10279 9.97801 2.10769 9.97893 2.1129C9.97985 2.11811 9.97944 2.12347 9.97774 2.12849Z"
        fill="white"
      />
      <path
        d="M10.5559 2.33588C10.5559 2.36054 10.5374 2.34821 10.5251 2.35437C10.5219 2.34839 10.5208 2.34152 10.5219 2.33483C10.523 2.32815 10.5263 2.32201 10.5313 2.31738C10.5436 2.31738 10.5498 2.32355 10.5559 2.33588Z"
        fill="white"
      />
      <path
        d="M10.002 2.39217C9.99584 2.4045 9.98351 2.39217 9.97735 2.39217C9.97118 2.39217 9.97735 2.37368 9.97735 2.36135C9.97735 2.34902 10.0143 2.36751 10.002 2.39217Z"
        fill="white"
      />
      <path
        d="M10.241 2.47388C10.2286 2.48621 10.2101 2.48621 10.204 2.47388C10.1978 2.46155 10.204 2.44922 10.2225 2.44922C10.241 2.44922 10.2348 2.46155 10.241 2.47388Z"
        fill="white"
      />
      <path
        d="M10.0278 2.44916C10.009 2.46174 10.0215 2.52465 9.98379 2.49949C9.94605 2.47432 9.97121 2.43658 10.0027 2.424C10.0341 2.41141 10.0215 2.43029 10.0278 2.44916Z"
        fill="white"
      />
      <path
        d="M7.77597 5.09736H7.75081C7.74452 5.01558 7.83259 4.95896 7.88921 4.92122L7.93953 4.90234C7.92939 4.94536 7.90931 4.98541 7.8809 5.01927C7.8525 5.05314 7.81657 5.07988 7.77597 5.09736Z"
        fill="white"
      />
      <path
        d="M11.9404 2.94601C11.8837 2.9586 11.9152 2.87052 11.9089 2.82649C11.9026 2.78245 12.0033 2.67551 12.0284 2.58744L12.0536 2.53711C12.0159 2.66293 12.0536 2.86423 11.9404 2.94601Z"
        fill="white"
      />
      <path
        d="M8.83298 2.67591L8.81411 2.68849C8.79524 2.68849 8.77637 2.6822 8.77637 2.65703L8.79524 2.60042H8.80153L8.82669 2.58154C8.85815 2.60671 8.83928 2.64445 8.83298 2.67591Z"
        fill="white"
      />
      <path
        d="M8.93945 2.21005V2.19141L8.94567 2.19762L8.93945 2.21005Z"
        fill="white"
      />
      <path
        d="M8.63098 3.13454V3.14712C8.63727 3.14712 8.63727 3.13454 8.63727 3.12825C8.63727 3.12196 8.64985 3.18487 8.64985 3.22261C8.64985 3.26036 8.61211 3.26036 8.58065 3.25406C8.5492 3.24777 8.56178 3.22261 8.5492 3.20374C8.53662 3.18487 8.59324 3.17228 8.58065 3.14083H8.58695L8.63727 3.10938C8.63727 3.12196 8.63727 3.13454 8.63098 3.13454Z"
        fill="white"
      />
      <path
        d="M11.2422 3.27253L11.2607 3.2417L11.2545 3.27253H11.2422Z"
        fill="white"
      />
      <path
        d="M11.11 3.254C11.11 3.27287 11.0974 3.23512 11.1037 3.22883L11.0659 3.26658L11.1037 3.20996L11.11 3.254Z"
        fill="white"
      />
      <path
        d="M11.0977 3.27344C11.1103 3.27973 11.0914 3.30489 11.0914 3.31118C11.0914 3.31747 11.0662 3.33635 11.0536 3.33006C11.0411 3.32376 11.0599 3.30489 11.0599 3.2986C11.0595 3.30943 11.0617 3.32021 11.0662 3.33006C11.0851 3.32376 11.0914 3.2986 11.0977 3.28602H11.0851V3.27344H11.0977Z"
        fill="white"
      />
      <path
        d="M11.2171 3.46082V3.42383C11.2109 3.43616 11.2171 3.44849 11.2171 3.46082Z"
        fill="white"
      />
      <path
        d="M9.49937 3.31738C9.46792 3.374 9.49308 3.46207 9.42388 3.49982C9.35468 3.53756 9.37985 3.46207 9.39243 3.43691C9.40501 3.41175 9.46163 3.36142 9.48679 3.31738H9.49937Z"
        fill="white"
      />
      <path
        d="M8.31681 3.41177C8.30423 3.43064 8.29794 3.4621 8.26648 3.4558C8.23503 3.44951 8.2539 3.43064 8.24132 3.41806C8.22874 3.40548 8.26648 3.38661 8.27277 3.37402H8.29165C8.31052 3.3929 8.31052 3.38661 8.31681 3.41177Z"
        fill="white"
      />
      <path
        d="M10.135 3.82061C10.1225 3.84339 10.1025 3.86116 10.0784 3.87093C10.0702 3.86581 10.0638 3.85809 10.0604 3.84898C10.057 3.83988 10.0567 3.8299 10.0596 3.82061C10.0669 3.79029 10.0847 3.76355 10.1099 3.74512C10.1476 3.7577 10.1288 3.78915 10.135 3.82061Z"
        fill="white"
      />
      <path
        d="M8.15332 3.42383C8.15949 3.44233 8.17798 3.43 8.17798 3.43616H8.15949C8.14716 3.42383 8.15948 3.40534 8.17182 3.39917C8.18415 3.39301 8.15332 3.4115 8.15332 3.42383Z"
        fill="white"
      />
      <path
        d="M11.2421 4.32997C11.2321 4.35747 11.2118 4.38002 11.1855 4.39288C11.1603 4.38659 11.1352 4.37401 11.1541 4.34256C11.1729 4.3111 11.2358 4.27336 11.2421 4.32997Z"
        fill="white"
      />
      <path
        d="M10.6947 4.2106C10.7009 4.21689 10.7072 4.20431 10.7135 4.20431C10.7198 4.20431 10.7009 4.23576 10.6947 4.23576C10.6884 4.23576 10.6632 4.39303 10.5877 4.42449C10.5122 4.45594 10.55 4.39932 10.55 4.37416L10.6003 4.26092V4.27351C10.6295 4.23368 10.6657 4.19956 10.7072 4.17285C10.7009 4.18543 10.6884 4.19801 10.6947 4.2106Z"
        fill="white"
      />
      <path
        d="M9.74541 3.91493H9.72025V3.92751H9.71396C9.69508 3.92751 9.6825 3.94638 9.69508 3.95896C9.70767 3.97154 9.73283 3.97783 9.75799 3.95896C9.78316 3.94009 9.73283 4.05332 9.6825 4.04703C9.67616 4.04033 9.67122 4.03242 9.66798 4.02378C9.66474 4.01513 9.66326 4.00593 9.66363 3.99671C9.67283 3.97453 9.67917 3.95128 9.6825 3.92751V3.94009H9.68879L9.70766 3.90863C9.71396 3.91493 9.72654 3.90863 9.72654 3.92751L9.7517 3.90234C9.74541 3.90234 9.73912 3.90863 9.74541 3.91493Z"
        fill="white"
      />
      <path
        d="M7.41714 3.33595C7.39198 3.34854 7.38569 3.32337 7.3794 3.31079C7.37311 3.29821 7.42972 3.27305 7.41714 3.24159C7.40456 3.21014 7.4423 3.31708 7.41714 3.33595Z"
        fill="white"
      />
      <path
        d="M9.71999 3.94602C9.71378 3.95845 9.71378 3.93359 9.71999 3.93359V3.94602Z"
        fill="white"
      />
      <path
        d="M9.72617 3.97145H9.701V3.95887C9.69471 3.96516 9.68842 3.95887 9.68213 3.95887L9.71358 3.94629C9.71987 3.95887 9.71358 3.97145 9.73246 3.96516V3.95887C9.72617 3.95887 9.72617 3.96516 9.72617 3.97145Z"
        fill="white"
      />
      <path
        d="M6.21582 5.79585H6.24098C6.24727 5.80843 6.1592 5.8336 6.22211 5.85876C6.1592 5.88392 6.11517 5.95312 6.04597 5.92796C5.97677 5.9028 6.03338 5.93425 6.03338 5.94683H6.06484C6.03967 5.97829 6.02709 6.02861 5.97677 6.0349C5.92644 6.0412 5.9516 6.02861 5.9516 6.01603C5.9516 6.00345 6.09629 5.94054 6.03968 5.82731C6.04712 5.80467 6.05942 5.78393 6.07572 5.76654C6.09202 5.74916 6.11193 5.73554 6.13404 5.72665L6.15291 5.68262C6.13404 5.71407 6.17178 5.71407 6.17807 5.73294L6.19695 5.70778V5.73923H6.23469C6.2284 5.74553 6.20324 5.77069 6.21582 5.79585Z"
        fill="white"
      />
      <path
        d="M7.99596 3.69486C7.97709 3.70744 7.97709 3.74518 7.93934 3.7326C7.9016 3.72002 7.93305 3.69486 7.92676 3.67599C7.92047 3.65711 7.95192 3.6634 7.95192 3.64453C7.9645 3.65711 8.01483 3.66969 7.99596 3.69486Z"
        fill="white"
      />
      <path
        d="M10.3301 4.49339C10.3295 4.51128 10.3253 4.52887 10.3178 4.54509C10.3102 4.56131 10.2994 4.57583 10.2861 4.58775C10.2735 4.58146 10.2609 4.59404 10.2546 4.57517C10.2483 4.5563 10.2861 4.50597 10.3049 4.48081C10.3238 4.45564 10.3238 4.4871 10.3301 4.49339Z"
        fill="white"
      />
      <path
        d="M10.2988 4.53083L10.3112 4.5H10.3173L10.2988 4.53083Z"
        fill="white"
      />
      <path
        d="M7.63741 3.78901C7.6437 3.77642 7.64999 3.80159 7.65628 3.80159C7.66258 3.80159 7.64999 3.84562 7.62483 3.84562C7.59967 3.84562 7.61225 3.82046 7.60596 3.80159L7.63112 3.78271L7.63741 3.78901Z"
        fill="white"
      />
      <path
        d="M7.63666 3.80158L7.62433 3.81391L7.61816 3.80158L7.62433 3.80774L7.63666 3.79541L7.64282 3.80774L7.63666 3.80158Z"
        fill="white"
      />
      <path
        d="M7.48677 4.17892C7.49306 4.19779 7.49936 4.23553 7.4679 4.24811C7.46171 4.25689 7.45288 4.26345 7.44269 4.26685C7.4325 4.27024 7.4215 4.27029 7.41128 4.26699C7.37354 4.22924 7.41757 4.19779 7.41757 4.16004C7.44274 4.17262 7.44903 4.14746 7.46161 4.14746C7.47419 4.14746 7.48048 4.17892 7.48677 4.17892Z"
        fill="white"
      />
      <path
        d="M6.77599 3.77034H6.79486C6.78228 3.80179 6.78857 3.85212 6.74454 3.87099C6.73478 3.864 6.72722 3.85436 6.72276 3.84321C6.7183 3.83207 6.71713 3.81988 6.71937 3.80808C6.73195 3.78292 6.75712 3.77034 6.77599 3.75146V3.77034Z"
        fill="white"
      />
      <path
        d="M10.1603 5.08484C10.1729 5.11629 10.1477 5.16662 10.1226 5.19807C10.115 5.20873 10.1039 5.21643 10.0913 5.21987C10.0787 5.22331 10.0653 5.22227 10.0534 5.21695C10.0219 5.20436 10.0219 5.17291 10.0282 5.14775C10.0345 5.12258 10.0596 5.11 10.0596 5.08484C10.0596 5.05968 10.1037 5.02822 10.1163 5.07855L10.1414 5.05968C10.1351 5.07855 10.1477 5.09113 10.1603 5.08484Z"
        fill="white"
      />
      <path
        d="M9.48059 4.76465V4.77698H9.47443V4.78931H9.46826L9.49292 4.77698L9.48059 4.76465Z"
        fill="white"
      />
      <path
        d="M7.20995 4.14169L7.22253 4.15427C7.19108 4.16056 7.19108 4.23606 7.13446 4.21718C7.07784 4.19831 7.1093 4.16686 7.1093 4.1354C7.1093 4.10395 7.12188 4.11653 7.13446 4.11024H7.14075C7.15334 4.09137 7.15963 4.11653 7.1785 4.09766H7.20366C7.18479 4.12282 7.22883 4.12282 7.20995 4.14169Z"
        fill="white"
      />
      <path
        d="M9.42397 4.87745C9.4051 4.86487 9.41768 4.83971 9.41768 4.83342L9.44914 4.78938V4.80825C9.43027 4.78938 9.42397 4.82083 9.41768 4.82713C9.41139 4.83342 9.42397 4.846 9.43026 4.846C9.43655 4.846 9.46172 4.80825 9.46801 4.79567L9.49317 4.77051C9.48688 4.81454 9.4743 4.87116 9.42397 4.87745Z"
        fill="white"
      />
      <path
        d="M8.63062 5.26691C8.63062 5.27307 8.62445 5.27307 8.61829 5.27307H8.60596L8.62445 5.26074C8.62445 5.26074 8.62445 5.26691 8.63062 5.26691Z"
        fill="white"
      />
      <path
        d="M7.33532 4.8017H7.32299V4.7832C7.31682 4.7832 7.33532 4.79553 7.35381 4.78937C7.37231 4.7832 7.34148 4.8017 7.33532 4.8017Z"
        fill="white"
      />
      <path
        d="M8.34775 5.83335H8.3291C8.33532 5.82092 8.35396 5.82713 8.34775 5.83335Z"
        fill="white"
      />
      <path
        d="M8.31693 5.85872C8.32322 5.87759 8.31693 5.85872 8.31693 5.85243H8.30435V5.87759C8.30435 5.89017 8.31693 5.89017 8.32322 5.89646C8.32951 5.90275 8.3358 5.8713 8.3358 5.85243H8.34209C8.34209 5.87759 8.32322 5.89646 8.29806 5.92162C8.2929 5.9244 8.28694 5.92529 8.2812 5.92414C8.27545 5.92299 8.27029 5.91988 8.2666 5.91533C8.2684 5.89792 8.27534 5.88145 8.28655 5.868C8.29775 5.85455 8.31271 5.84475 8.32951 5.83984L8.31693 5.85872Z"
        fill="white"
      />
      <path
        d="M8.27979 5.87109H8.28573L8.29167 5.88298L8.27979 5.87109Z"
        fill="white"
      />
      <path
        d="M6.64996 5.55659C6.6248 5.56918 6.60593 5.5503 6.59964 5.52514C6.59334 5.49998 6.59964 5.49369 6.61222 5.4811C6.6248 5.46852 6.63738 5.50627 6.64367 5.4811C6.64996 5.45594 6.63109 5.45594 6.64367 5.44336V5.46223C6.66255 5.46223 6.66254 5.44965 6.68142 5.44336V5.46223H6.70658C6.68771 5.4874 6.68771 5.53143 6.64996 5.55659Z"
        fill="white"
      />
      <path
        d="M7.70675 5.90255C7.68787 5.94029 7.68158 5.97804 7.63125 5.97175C7.58093 5.96546 7.61867 5.92771 7.62496 5.90884L7.65642 5.87109H7.70675C7.70045 5.88368 7.69416 5.90884 7.70675 5.90255Z"
        fill="white"
      />
      <path
        d="M7.66903 5.94045C7.67532 5.94045 7.68161 5.92787 7.6879 5.92158C7.69419 5.91529 7.6879 5.94045 7.68161 5.94674C7.67532 5.95303 7.65644 5.92787 7.64386 5.92158C7.63128 5.91529 7.67532 5.89641 7.67532 5.88383C7.67532 5.87125 7.69419 5.90899 7.66903 5.94045Z"
        fill="white"
      />
      <path
        d="M7.64972 5.92768C7.65589 5.92768 7.65589 5.92151 7.64972 5.92151H7.64355V5.90918H7.66821L7.64972 5.92768Z"
        fill="white"
      />
      <path
        d="M6.69389 5.29841C6.68131 5.29841 6.67502 5.28583 6.66873 5.27953C6.66244 5.27324 6.68131 5.24179 6.69389 5.22292C6.70647 5.20404 6.68131 5.24179 6.6876 5.26066H6.71277C6.70647 5.24808 6.71277 5.2355 6.71906 5.2355C6.72061 5.24726 6.71911 5.25923 6.7147 5.27024C6.71029 5.28126 6.70313 5.29096 6.69389 5.29841Z"
        fill="white"
      />
      <path
        d="M7.70038 6.18584H7.68151V6.15439C7.68151 6.15439 7.67522 6.16068 7.68151 6.16068H7.69409V6.12922C7.70667 6.13552 7.70667 6.12293 7.71296 6.11664V6.12922V6.15439L7.75071 6.11035C7.73183 6.14181 7.72554 6.17326 7.70038 6.18584Z"
        fill="white"
      />
      <path
        d="M4.53613 6.60065C4.54871 6.6384 4.56759 6.59436 4.58646 6.60065C4.60533 6.60694 4.555 6.60694 4.56129 6.63211C4.569 6.63513 4.57748 6.63553 4.58544 6.63326C4.5934 6.63099 4.60038 6.62616 4.60533 6.61953C4.59904 6.65098 4.54242 6.65727 4.56129 6.70131C4.58017 6.74534 4.58646 6.7076 4.58646 6.72018C4.58646 6.73276 4.56759 6.7768 4.54871 6.79567H4.56129C4.54871 6.82083 4.51726 6.83342 4.49209 6.85229C4.46693 6.87116 4.45435 6.88374 4.47951 6.90891C4.50468 6.93407 4.4229 6.89632 4.4229 6.9152C4.40033 6.91779 4.37747 6.91453 4.35653 6.90571C4.33559 6.89689 4.31728 6.88283 4.30337 6.86487C4.27192 6.846 4.29079 6.83342 4.27192 6.80196H4.2845C4.27821 6.78938 4.2845 6.7768 4.26562 6.77051C4.27226 6.76556 4.27708 6.75857 4.27936 6.75062C4.28163 6.74266 4.28123 6.73418 4.27821 6.72647C4.26562 6.7076 4.27192 6.67614 4.2845 6.67614C4.29708 6.67614 4.2845 6.66356 4.27821 6.65727C4.27192 6.65098 4.29079 6.64469 4.29079 6.6384C4.32107 6.60557 4.34459 6.56709 4.35999 6.52516V6.53775L4.37257 6.55033V6.5C4.38515 6.51887 4.37257 6.54404 4.39144 6.55662C4.41031 6.5692 4.41031 6.53775 4.4229 6.53145V6.54404C4.44806 6.55662 4.44806 6.51887 4.47322 6.51887C4.49839 6.51887 4.49839 6.56291 4.52355 6.56291L4.56129 6.53775C4.55088 6.54412 4.5428 6.55368 4.53826 6.56502C4.53373 6.57636 4.53298 6.58886 4.53613 6.60065Z"
        fill="white"
      />
      <path
        d="M7.3921 6.27424V6.26166C7.37323 6.25537 7.36694 6.26795 7.35436 6.28053V6.29311C7.37323 6.29311 7.36065 6.27424 7.37952 6.28053C7.39839 6.28682 7.35436 6.31198 7.34178 6.32457C7.3292 6.33715 7.32919 6.28682 7.34807 6.27424C7.36694 6.26166 7.37952 6.25537 7.39839 6.24278C7.41727 6.2302 7.40468 6.26795 7.3921 6.27424Z"
        fill="white"
      />
      <path
        d="M7.07719 6.48778C7.05203 6.50036 7.00799 6.50036 7.0017 6.48149C6.99541 6.46262 6.99541 6.46262 6.99541 6.45633C6.98984 6.461 6.98333 6.46442 6.97631 6.46634C6.96929 6.46826 6.96194 6.46863 6.95477 6.46743C6.94759 6.46624 6.94076 6.4635 6.93475 6.45941C6.92873 6.45532 6.92367 6.44998 6.91992 6.44374C6.95138 6.34938 7.05203 6.3368 7.10236 6.32422V6.34938L7.12752 6.3368C7.13268 6.36417 7.13076 6.3924 7.12196 6.41882C7.11315 6.44525 7.09774 6.46898 7.07719 6.48778Z"
        fill="white"
      />
      <path
        d="M3.71872 8.58239H3.7313C3.71872 8.58868 3.71242 8.60756 3.70613 8.62643H3.73759C3.7313 8.63901 3.69984 8.63901 3.71872 8.66418H3.72501C3.67468 8.67676 3.68726 8.72079 3.63694 8.73337C3.58661 8.74596 3.56145 8.75225 3.52999 8.76483C3.49854 8.77741 3.50483 8.75225 3.49225 8.73967L3.46079 8.65159C3.47401 8.63526 3.48269 8.61573 3.48595 8.59498C3.4557 8.5903 3.42736 8.57722 3.40417 8.55723C3.36643 8.51319 3.41676 8.48803 3.41676 8.45029C3.41676 8.41254 3.46708 8.43141 3.47966 8.41883V8.40625C3.47337 8.45029 3.52999 8.41254 3.55515 8.41254H3.56774C3.56774 8.42512 3.54886 8.43141 3.55515 8.444L3.58661 8.43141C3.58032 8.4377 3.57403 8.4377 3.57403 8.45029L3.58661 8.46287C3.58032 8.46287 3.58032 8.46916 3.58032 8.47545L3.5929 8.48803L3.58032 8.5069C3.59919 8.51319 3.61177 8.5069 3.61177 8.53207L3.66839 8.51949L3.65581 8.53836H3.68726V8.55723H3.72501C3.7313 8.54465 3.68726 8.56981 3.71872 8.58239Z"
        fill="white"
      />
      <path
        d="M5.54887 6.23007H5.56145C5.55516 6.26782 5.57403 6.32443 5.52999 6.35589C5.50518 6.37627 5.47404 6.38739 5.44192 6.38734C5.42344 6.3754 5.40883 6.35833 5.3999 6.33822C5.39096 6.31811 5.38807 6.29583 5.3916 6.27411C5.41676 6.26153 5.42934 6.2112 5.4545 6.19233V6.2112L5.51741 6.18604C5.5237 6.19862 5.54258 6.2112 5.54887 6.23007Z"
        fill="white"
      />
      <path
        d="M6.68083 6.21094L6.66895 6.22282V6.21688L6.68083 6.21094Z"
        fill="white"
      />
      <path
        d="M6.56836 6.52531V6.51298C6.56836 6.52531 6.59302 6.53147 6.59302 6.51298C6.59302 6.49448 6.58069 6.53764 6.56836 6.52531Z"
        fill="white"
      />
      <path
        d="M6.41715 6.64491H6.42344C6.42973 6.64491 6.41086 6.67636 6.42973 6.67636C6.44861 6.67636 6.32279 6.67636 6.32908 6.76444C6.33537 6.85251 6.25359 6.80218 6.21584 6.77702C6.20391 6.76421 6.19727 6.74735 6.19727 6.72984C6.19727 6.71232 6.20391 6.69546 6.21584 6.68265L6.24101 6.63862C6.2473 6.6512 6.25988 6.64491 6.25988 6.63862L6.27875 6.62604C6.29133 6.65749 6.31021 6.60716 6.32908 6.61345H6.32279C6.35424 6.63862 6.36683 6.60087 6.39199 6.60716H6.41086C6.42344 6.61975 6.41086 6.63233 6.41715 6.64491Z"
        fill="white"
      />
      <path
        d="M5.27887 7.4691C5.29775 7.4691 5.26 7.49427 5.28517 7.49427C5.31033 7.49427 5.28516 7.52572 5.27887 7.5383H5.28517C5.24113 7.54459 5.29146 7.59492 5.22226 7.60121C5.15306 7.6075 5.16564 7.6075 5.15306 7.63266C5.14048 7.65783 5.09015 7.60121 5.07757 7.55088C5.06499 7.50056 5.08386 7.5383 5.08386 7.48797V7.46281C5.11531 7.48797 5.09015 7.41878 5.1216 7.43765L5.15935 7.3999C5.15306 7.41248 5.15935 7.41248 5.15935 7.41878C5.15935 7.42507 5.18451 7.40619 5.19709 7.3999V7.41878H5.22226C5.21597 7.42507 5.22226 7.43136 5.22855 7.43765L5.24113 7.42507C5.27887 7.44394 5.24113 7.4691 5.27887 7.4691Z"
        fill="white"
      />
      <path
        d="M5.09668 7.29908L5.12134 7.27441L5.10901 7.28674L5.09668 7.29908Z"
        fill="white"
      />
      <path
        d="M4.01374 7.0729V7.08548C3.99487 7.09177 4.00745 7.10435 4.00745 7.11693C4.00745 7.12952 3.95083 7.14839 3.93196 7.12322L3.91309 7.07919C3.93196 7.07919 3.93196 7.05403 3.93825 7.04144C3.94454 7.02886 3.96341 7.03515 3.96341 7.04144C3.98229 7.03515 3.98858 7.04144 4.00745 7.04773C4.02632 7.05403 4.00116 7.06661 4.01374 7.0729Z"
        fill="white"
      />
      <path
        d="M3.98845 7.05371V7.05965L3.97656 7.0656L3.98845 7.05371Z"
        fill="white"
      />
      <path
        d="M3.32816 6.05992C3.30929 6.0725 3.27783 6.05363 3.27783 6.02218C3.27783 5.99072 3.29041 5.99072 3.30929 5.99072C3.32816 5.99072 3.35961 6.05363 3.32816 6.05992Z"
        fill="white"
      />
      <path
        d="M3.6993 7.8279C3.70559 7.84048 3.6993 7.84048 3.70559 7.85935C3.71188 7.87822 3.67413 7.89081 3.64897 7.87822C3.6423 7.87175 3.63715 7.86388 3.63389 7.85518C3.63062 7.84648 3.62933 7.83716 3.6301 7.8279L3.65526 7.80273C3.67413 7.80903 3.69301 7.80273 3.70559 7.8279H3.6993Z"
        fill="white"
      />
      <path
        d="M3.61742 7.94662C3.61125 7.94045 3.61125 7.93429 3.61742 7.92196C3.62358 7.90963 3.63591 7.92196 3.63591 7.94045L3.61742 7.94662Z"
        fill="white"
      />
      <path
        d="M3.66829 6.94704C3.66581 6.95434 3.66168 6.96098 3.65623 6.96643C3.65078 6.97188 3.64414 6.97601 3.63684 6.97849C3.63055 6.96591 3.61167 6.96591 3.61797 6.95333C3.6192 6.94543 3.62291 6.93813 3.62857 6.93248C3.63422 6.92682 3.64152 6.92311 3.64942 6.92188C3.65571 6.92817 3.66829 6.92817 3.65571 6.94075L3.66829 6.94704Z"
        fill="white"
      />
      <path
        d="M3.64252 6.9462H3.63643C3.63034 6.95229 3.64252 6.91575 3.64861 6.94011C3.6547 6.96447 3.64252 6.9462 3.64252 6.9462Z"
        fill="white"
      />
      <path
        d="M3.31537 7.58845C3.30279 7.60103 3.30908 7.60732 3.32166 7.6199H3.32795C3.33424 7.6199 3.31537 7.63248 3.30908 7.6199C3.30279 7.60732 3.31537 7.65765 3.29021 7.65765C3.26504 7.65765 3.30908 7.67652 3.31537 7.6891C3.32166 7.70168 3.28392 7.67023 3.26504 7.6891C3.24617 7.70797 3.20213 7.70168 3.18955 7.73314C3.17697 7.76459 3.16439 7.73943 3.1581 7.72056C3.15582 7.72311 3.15409 7.7261 3.15301 7.72934C3.15193 7.73259 3.15152 7.73602 3.15181 7.73943C3.12664 7.73314 3.10148 7.6891 3.0889 7.70168C3.07632 7.71426 3.07003 7.67652 3.05745 7.67652C3.05678 7.67104 3.05469 7.66583 3.05138 7.66141C3.04807 7.65699 3.04365 7.65353 3.03857 7.65136C3.06374 7.6199 3.00083 7.62619 3.02599 7.60732C3.05115 7.58845 3.00712 7.58845 3.00083 7.58216C2.99454 7.57587 3.02599 7.58845 3.03228 7.57587C3.03857 7.56328 3.04486 7.53183 3.0197 7.49409C2.99454 7.45634 3.03857 7.48779 3.03857 7.47521H3.03228C3.05744 7.48779 3.05745 7.44376 3.07003 7.43747C3.08261 7.43118 3.12664 7.45634 3.12664 7.40601C3.12664 7.35569 3.17068 7.45634 3.18326 7.4186V7.39972C3.20213 7.4123 3.17068 7.42489 3.19584 7.43747C3.22101 7.45005 3.20213 7.41859 3.21472 7.4123C3.2273 7.40601 3.19584 7.46892 3.23988 7.46263L3.26504 7.44376C3.25988 7.45783 3.25774 7.47284 3.25875 7.48779C3.27762 7.51296 3.28392 7.46892 3.29021 7.48779C3.2965 7.50667 3.27133 7.50667 3.28392 7.51925L3.32166 7.53183C3.30279 7.53183 3.33424 7.56958 3.31537 7.58845Z"
        fill="white"
      />
      <path
        d="M4.71872 8.28729C4.69355 8.29358 4.67468 8.32504 4.64323 8.29987C4.61177 8.27471 4.61177 8.21809 4.6621 8.21809V8.19922H4.70613C4.69984 8.22438 4.73759 8.21809 4.7313 8.24955C4.72501 8.281 4.70613 8.27471 4.71872 8.28729Z"
        fill="white"
      />
      <path
        d="M4.49219 8.36805L4.52301 8.33722L4.53534 8.33105V8.33722L4.49219 8.36805Z"
        fill="white"
      />
      <path
        d="M4.46054 8.43823H4.47312L4.46054 8.4571H4.4857C4.46683 8.46968 4.46683 8.48855 4.46683 8.51372H4.47312C4.46181 8.53392 4.44649 8.55159 4.42809 8.56565C4.4097 8.57972 4.38863 8.58987 4.36617 8.5955C4.32843 8.58921 4.29068 8.57033 4.25923 8.5955C4.22777 8.62066 4.2781 8.57663 4.25294 8.57033C4.22778 8.56404 4.2089 8.53259 4.18374 8.52001C4.15858 8.50743 4.19003 8.46968 4.18374 8.44452C4.17745 8.41935 4.21519 8.41935 4.19632 8.40048H4.21519C4.23407 8.38161 4.2089 8.36903 4.2089 8.35644H4.24036C4.24036 8.33128 4.28439 8.31241 4.29697 8.29983C4.30956 8.28725 4.34101 8.26208 4.35359 8.23692C4.36617 8.21176 4.34101 8.29983 4.38505 8.31241C4.38476 8.309 4.38517 8.30557 4.38625 8.30233C4.38733 8.29908 4.38906 8.29609 4.39134 8.29354C4.42908 8.30612 4.37875 8.34386 4.4165 8.34386L4.44795 8.28095C4.44166 8.35645 4.41021 8.40048 4.46054 8.43823Z"
        fill="white"
      />
      <path
        d="M4.17139 8.29332L4.1776 8.28711L4.18382 8.30575L4.17139 8.29332Z"
        fill="white"
      />
      <path
        d="M5.58691 3.27317L5.60556 3.26074L5.59313 3.27317H5.58691Z"
        fill="white"
      />
      <path
        d="M5.55518 3.28577L5.56751 3.27344L5.57984 3.28577H5.55518Z"
        fill="white"
      />
      <path
        d="M9.23559 6.95316C9.23559 6.97203 9.21672 6.97832 9.21672 6.99719C9.2042 7.0012 9.19061 7.00016 9.17886 6.99428C9.1671 6.9884 9.15811 6.97816 9.15381 6.96574C9.15458 6.95131 9.15985 6.93749 9.16887 6.92621C9.1779 6.91493 9.19023 6.90675 9.20413 6.90283C9.21471 6.90579 9.2238 6.91259 9.22961 6.9219C9.23543 6.93121 9.23756 6.94236 9.23559 6.95316Z"
        fill="white"
      />
      <path
        d="M9.31759 7.12349C9.29871 7.13607 9.29242 7.1172 9.27984 7.11091C9.27947 7.10168 9.28095 7.09248 9.28419 7.08384C9.28743 7.07519 9.29237 7.06729 9.29871 7.06058C9.33017 7.048 9.36791 7.09832 9.31759 7.12349Z"
        fill="white"
      />
      <path
        d="M8.95823 3.896L8.95201 3.91464L8.9458 3.90843L8.95823 3.896Z"
        fill="white"
      />
      <path
        d="M8.79524 4.09735L8.77637 4.08476C8.77637 4.04702 8.81411 4.02815 8.84557 4.02186C8.87702 4.01557 8.82669 4.09106 8.79524 4.09735Z"
        fill="white"
      />
      <path
        d="M6.63141 7.60147H6.65029V7.63922C6.69432 7.65809 6.63141 7.68955 6.65029 7.70842C6.63681 7.72687 6.61856 7.7413 6.59751 7.75017C6.57645 7.75903 6.55337 7.762 6.53076 7.75874C6.49301 7.73987 6.5056 7.72729 6.46785 7.70213C6.43011 7.67696 6.41123 7.63922 6.47414 7.61406C6.53705 7.58889 6.51818 7.58889 6.53705 7.55115C6.55592 7.5134 6.56221 7.56373 6.5748 7.56373L6.59367 7.55115C6.58738 7.5826 6.61883 7.57631 6.64399 7.57631C6.66916 7.57631 6.63141 7.58889 6.63141 7.60147Z"
        fill="white"
      />
      <path
        d="M10.6185 2.00859C10.6181 2.02187 10.6138 2.03473 10.6062 2.04558C10.5939 2.03325 10.5815 2.03325 10.5815 2.01476C10.5815 1.99626 10.6124 1.99626 10.6185 2.00859Z"
        fill="white"
      />
      <path
        d="M10.978 2.11586C10.9654 2.13473 10.9528 2.17876 10.9276 2.16618C10.9025 2.1536 10.8836 2.14102 10.8899 2.10327C10.8962 2.06553 10.9151 2.07182 10.9213 2.05295C10.9276 2.03407 10.9591 2.0844 10.978 2.11586Z"
        fill="white"
      />
      <path
        d="M10.6944 2.06489C10.6944 2.07722 10.6944 2.08339 10.6882 2.08955C10.6821 2.09572 10.6636 2.08339 10.6636 2.07106C10.6636 2.05872 10.6882 2.04023 10.6944 2.06489Z"
        fill="white"
      />
      <path
        d="M9.97774 2.12849C9.97303 2.14145 9.96419 2.1525 9.95258 2.15994C9.94 2.14736 9.92742 2.15365 9.92112 2.13478C9.91836 2.13026 9.91678 2.12512 9.91654 2.11983C9.91629 2.11454 9.91738 2.10928 9.91971 2.10453C9.92204 2.09977 9.92554 2.09568 9.92987 2.09264C9.9342 2.08959 9.93922 2.08769 9.94448 2.08711C9.94975 2.08652 9.95507 2.08727 9.95996 2.0893C9.96486 2.09132 9.96916 2.09454 9.97248 2.09866C9.97579 2.10279 9.97801 2.10769 9.97893 2.1129C9.97985 2.11811 9.97944 2.12347 9.97774 2.12849Z"
        fill="white"
      />
      <path
        d="M10.5559 2.33588C10.5559 2.36054 10.5374 2.34821 10.5251 2.35437C10.5219 2.34839 10.5208 2.34152 10.5219 2.33483C10.523 2.32815 10.5263 2.32201 10.5313 2.31738C10.5436 2.31738 10.5498 2.32355 10.5559 2.33588Z"
        fill="white"
      />
      <path
        d="M10.002 2.39217C9.99584 2.4045 9.98351 2.39217 9.97735 2.39217C9.97118 2.39217 9.97735 2.37368 9.97735 2.36135C9.97735 2.34902 10.0143 2.36751 10.002 2.39217Z"
        fill="white"
      />
      <path
        d="M10.241 2.47388C10.2286 2.48621 10.2101 2.48621 10.204 2.47388C10.1978 2.46155 10.204 2.44922 10.2225 2.44922C10.241 2.44922 10.2348 2.46155 10.241 2.47388Z"
        fill="white"
      />
      <path
        d="M10.0278 2.44916C10.009 2.46174 10.0215 2.52465 9.98379 2.49949C9.94605 2.47432 9.97121 2.43658 10.0027 2.424C10.0341 2.41141 10.0215 2.43029 10.0278 2.44916Z"
        fill="white"
      />
      <path
        d="M7.77597 5.09736H7.75081C7.74452 5.01558 7.83259 4.95896 7.88921 4.92122L7.93953 4.90234C7.92939 4.94536 7.90931 4.98541 7.8809 5.01927C7.8525 5.05314 7.81657 5.07988 7.77597 5.09736Z"
        fill="white"
      />
      <path
        d="M11.9404 2.94601C11.8837 2.9586 11.9152 2.87052 11.9089 2.82649C11.9026 2.78245 12.0033 2.67551 12.0284 2.58744L12.0536 2.53711C12.0159 2.66293 12.0536 2.86423 11.9404 2.94601Z"
        fill="white"
      />
      <path
        d="M8.83298 2.67591L8.81411 2.68849C8.79524 2.68849 8.77637 2.6822 8.77637 2.65703L8.79524 2.60042H8.80153L8.82669 2.58154C8.85815 2.60671 8.83928 2.64445 8.83298 2.67591Z"
        fill="white"
      />
      <path
        d="M8.93945 2.21005V2.19141L8.94567 2.19762L8.93945 2.21005Z"
        fill="white"
      />
      <path
        d="M8.63098 3.13454V3.14712C8.63727 3.14712 8.63727 3.13454 8.63727 3.12825C8.63727 3.12196 8.64985 3.18487 8.64985 3.22261C8.64985 3.26036 8.61211 3.26036 8.58065 3.25406C8.5492 3.24777 8.56178 3.22261 8.5492 3.20374C8.53662 3.18487 8.59324 3.17228 8.58065 3.14083H8.58695L8.63727 3.10938C8.63727 3.12196 8.63727 3.13454 8.63098 3.13454Z"
        fill="white"
      />
      <path
        d="M11.2422 3.27253L11.2607 3.2417L11.2545 3.27253H11.2422Z"
        fill="white"
      />
      <path
        d="M11.11 3.254C11.11 3.27287 11.0974 3.23512 11.1037 3.22883L11.0659 3.26658L11.1037 3.20996L11.11 3.254Z"
        fill="white"
      />
      <path
        d="M11.0977 3.27344C11.1103 3.27973 11.0914 3.30489 11.0914 3.31118C11.0914 3.31747 11.0662 3.33635 11.0536 3.33006C11.0411 3.32376 11.0599 3.30489 11.0599 3.2986C11.0595 3.30943 11.0617 3.32021 11.0662 3.33006C11.0851 3.32376 11.0914 3.2986 11.0977 3.28602H11.0851V3.27344H11.0977Z"
        fill="white"
      />
      <path
        d="M11.2171 3.46082V3.42383C11.2109 3.43616 11.2171 3.44849 11.2171 3.46082Z"
        fill="white"
      />
      <path
        d="M9.49937 3.31738C9.46792 3.374 9.49308 3.46207 9.42388 3.49982C9.35468 3.53756 9.37985 3.46207 9.39243 3.43691C9.40501 3.41175 9.46163 3.36142 9.48679 3.31738H9.49937Z"
        fill="white"
      />
      <path
        d="M8.31681 3.41177C8.30423 3.43064 8.29794 3.4621 8.26648 3.4558C8.23503 3.44951 8.2539 3.43064 8.24132 3.41806C8.22874 3.40548 8.26648 3.38661 8.27277 3.37402H8.29165C8.31052 3.3929 8.31052 3.38661 8.31681 3.41177Z"
        fill="white"
      />
      <path
        d="M10.135 3.82061C10.1225 3.84339 10.1025 3.86116 10.0784 3.87093C10.0702 3.86581 10.0638 3.85809 10.0604 3.84898C10.057 3.83988 10.0567 3.8299 10.0596 3.82061C10.0669 3.79029 10.0847 3.76355 10.1099 3.74512C10.1476 3.7577 10.1288 3.78915 10.135 3.82061Z"
        fill="white"
      />
      <path
        d="M8.15332 3.42383C8.15949 3.44233 8.17798 3.43 8.17798 3.43616H8.15949C8.14716 3.42383 8.15948 3.40534 8.17182 3.39917C8.18415 3.39301 8.15332 3.4115 8.15332 3.42383Z"
        fill="white"
      />
      <path
        d="M11.2421 4.32997C11.2321 4.35747 11.2118 4.38002 11.1855 4.39288C11.1603 4.38659 11.1352 4.37401 11.1541 4.34256C11.1729 4.3111 11.2358 4.27336 11.2421 4.32997Z"
        fill="white"
      />
      <path
        d="M10.6947 4.2106C10.7009 4.21689 10.7072 4.20431 10.7135 4.20431C10.7198 4.20431 10.7009 4.23576 10.6947 4.23576C10.6884 4.23576 10.6632 4.39303 10.5877 4.42449C10.5122 4.45594 10.55 4.39932 10.55 4.37416L10.6003 4.26092V4.27351C10.6295 4.23368 10.6657 4.19956 10.7072 4.17285C10.7009 4.18543 10.6884 4.19801 10.6947 4.2106Z"
        fill="white"
      />
      <path
        d="M9.74541 3.91493H9.72025V3.92751H9.71396C9.69508 3.92751 9.6825 3.94638 9.69508 3.95896C9.70767 3.97154 9.73283 3.97783 9.75799 3.95896C9.78316 3.94009 9.73283 4.05332 9.6825 4.04703C9.67616 4.04033 9.67122 4.03242 9.66798 4.02378C9.66474 4.01513 9.66326 4.00593 9.66363 3.99671C9.67283 3.97453 9.67917 3.95128 9.6825 3.92751V3.94009H9.68879L9.70766 3.90863C9.71396 3.91493 9.72654 3.90863 9.72654 3.92751L9.7517 3.90234C9.74541 3.90234 9.73912 3.90863 9.74541 3.91493Z"
        fill="white"
      />
      <path
        d="M7.41714 3.33595C7.39198 3.34854 7.38569 3.32337 7.3794 3.31079C7.37311 3.29821 7.42972 3.27305 7.41714 3.24159C7.40456 3.21014 7.4423 3.31708 7.41714 3.33595Z"
        fill="white"
      />
      <path
        d="M9.71999 3.94602C9.71378 3.95845 9.71378 3.93359 9.71999 3.93359V3.94602Z"
        fill="white"
      />
      <path
        d="M9.72617 3.97145H9.701V3.95887C9.69471 3.96516 9.68842 3.95887 9.68213 3.95887L9.71358 3.94629C9.71987 3.95887 9.71358 3.97145 9.73246 3.96516V3.95887C9.72617 3.95887 9.72617 3.96516 9.72617 3.97145Z"
        fill="white"
      />
      <path
        d="M6.21582 5.79585H6.24098C6.24727 5.80843 6.1592 5.8336 6.22211 5.85876C6.1592 5.88392 6.11517 5.95312 6.04597 5.92796C5.97677 5.9028 6.03338 5.93425 6.03338 5.94683H6.06484C6.03967 5.97829 6.02709 6.02861 5.97677 6.0349C5.92644 6.0412 5.9516 6.02861 5.9516 6.01603C5.9516 6.00345 6.09629 5.94054 6.03968 5.82731C6.04712 5.80467 6.05942 5.78393 6.07572 5.76654C6.09202 5.74916 6.11193 5.73554 6.13404 5.72665L6.15291 5.68262C6.13404 5.71407 6.17178 5.71407 6.17807 5.73294L6.19695 5.70778V5.73923H6.23469C6.2284 5.74553 6.20324 5.77069 6.21582 5.79585Z"
        fill="white"
      />
      <path
        d="M7.99596 3.69486C7.97709 3.70744 7.97709 3.74518 7.93934 3.7326C7.9016 3.72002 7.93305 3.69486 7.92676 3.67599C7.92047 3.65711 7.95192 3.6634 7.95192 3.64453C7.9645 3.65711 8.01483 3.66969 7.99596 3.69486Z"
        fill="white"
      />
      <path
        d="M10.3301 4.49339C10.3295 4.51128 10.3253 4.52887 10.3178 4.54509C10.3102 4.56131 10.2994 4.57583 10.2861 4.58775C10.2735 4.58146 10.2609 4.59404 10.2546 4.57517C10.2483 4.5563 10.2861 4.50597 10.3049 4.48081C10.3238 4.45564 10.3238 4.4871 10.3301 4.49339Z"
        fill="white"
      />
      <path
        d="M10.2988 4.53083L10.3112 4.5H10.3173L10.2988 4.53083Z"
        fill="white"
      />
      <path
        d="M7.63741 3.78901C7.6437 3.77642 7.64999 3.80159 7.65628 3.80159C7.66258 3.80159 7.64999 3.84562 7.62483 3.84562C7.59967 3.84562 7.61225 3.82046 7.60596 3.80159L7.63112 3.78271L7.63741 3.78901Z"
        fill="white"
      />
      <path
        d="M7.63666 3.80158L7.62433 3.81391L7.61816 3.80158L7.62433 3.80774L7.63666 3.79541L7.64282 3.80774L7.63666 3.80158Z"
        fill="white"
      />
      <path
        d="M7.48677 4.17892C7.49306 4.19779 7.49936 4.23553 7.4679 4.24811C7.46171 4.25689 7.45288 4.26345 7.44269 4.26685C7.4325 4.27024 7.4215 4.27029 7.41128 4.26699C7.37354 4.22924 7.41757 4.19779 7.41757 4.16004C7.44274 4.17262 7.44903 4.14746 7.46161 4.14746C7.47419 4.14746 7.48048 4.17892 7.48677 4.17892Z"
        fill="white"
      />
      <path
        d="M6.77599 3.77034H6.79486C6.78228 3.80179 6.78857 3.85212 6.74454 3.87099C6.73478 3.864 6.72722 3.85436 6.72276 3.84321C6.7183 3.83207 6.71713 3.81988 6.71937 3.80808C6.73195 3.78292 6.75712 3.77034 6.77599 3.75146V3.77034Z"
        fill="white"
      />
      <path
        d="M10.1603 5.08484C10.1729 5.11629 10.1477 5.16662 10.1226 5.19807C10.115 5.20873 10.1039 5.21643 10.0913 5.21987C10.0787 5.22331 10.0653 5.22227 10.0534 5.21695C10.0219 5.20436 10.0219 5.17291 10.0282 5.14775C10.0345 5.12258 10.0596 5.11 10.0596 5.08484C10.0596 5.05968 10.1037 5.02822 10.1163 5.07855L10.1414 5.05968C10.1351 5.07855 10.1477 5.09113 10.1603 5.08484Z"
        fill="white"
      />
      <path
        d="M9.48059 4.76465V4.77698H9.47443V4.78931H9.46826L9.49292 4.77698L9.48059 4.76465Z"
        fill="white"
      />
      <path
        d="M7.20995 4.14169L7.22253 4.15427C7.19108 4.16056 7.19108 4.23606 7.13446 4.21718C7.07784 4.19831 7.1093 4.16686 7.1093 4.1354C7.1093 4.10395 7.12188 4.11653 7.13446 4.11024H7.14075C7.15334 4.09137 7.15963 4.11653 7.1785 4.09766H7.20366C7.18479 4.12282 7.22883 4.12282 7.20995 4.14169Z"
        fill="white"
      />
      <path
        d="M9.42397 4.87745C9.4051 4.86487 9.41768 4.83971 9.41768 4.83342L9.44914 4.78938V4.80825C9.43027 4.78938 9.42397 4.82083 9.41768 4.82713C9.41139 4.83342 9.42397 4.846 9.43026 4.846C9.43655 4.846 9.46172 4.80825 9.46801 4.79567L9.49317 4.77051C9.48688 4.81454 9.4743 4.87116 9.42397 4.87745Z"
        fill="white"
      />
      <path
        d="M8.63062 5.26691C8.63062 5.27307 8.62445 5.27307 8.61829 5.27307H8.60596L8.62445 5.26074C8.62445 5.26074 8.62445 5.26691 8.63062 5.26691Z"
        fill="white"
      />
      <path
        d="M7.33532 4.8017H7.32299V4.7832C7.31682 4.7832 7.33532 4.79553 7.35381 4.78937C7.37231 4.7832 7.34148 4.8017 7.33532 4.8017Z"
        fill="white"
      />
      <path
        d="M8.34775 5.83335H8.3291C8.33532 5.82092 8.35396 5.82713 8.34775 5.83335Z"
        fill="white"
      />
      <path
        d="M8.31693 5.85872C8.32322 5.87759 8.31693 5.85872 8.31693 5.85243H8.30435V5.87759C8.30435 5.89017 8.31693 5.89017 8.32322 5.89646C8.32951 5.90275 8.3358 5.8713 8.3358 5.85243H8.34209C8.34209 5.87759 8.32322 5.89646 8.29806 5.92162C8.2929 5.9244 8.28694 5.92529 8.2812 5.92414C8.27545 5.92299 8.27029 5.91988 8.2666 5.91533C8.2684 5.89792 8.27534 5.88145 8.28655 5.868C8.29775 5.85455 8.31271 5.84475 8.32951 5.83984L8.31693 5.85872Z"
        fill="white"
      />
      <path
        d="M8.27979 5.87109H8.28573L8.29167 5.88298L8.27979 5.87109Z"
        fill="white"
      />
      <path
        d="M6.64996 5.55659C6.6248 5.56918 6.60593 5.5503 6.59964 5.52514C6.59334 5.49998 6.59964 5.49369 6.61222 5.4811C6.6248 5.46852 6.63738 5.50627 6.64367 5.4811C6.64996 5.45594 6.63109 5.45594 6.64367 5.44336V5.46223C6.66255 5.46223 6.66254 5.44965 6.68142 5.44336V5.46223H6.70658C6.68771 5.4874 6.68771 5.53143 6.64996 5.55659Z"
        fill="white"
      />
      <path
        d="M7.70675 5.90255C7.68787 5.94029 7.68158 5.97804 7.63125 5.97175C7.58093 5.96546 7.61867 5.92771 7.62496 5.90884L7.65642 5.87109H7.70675C7.70045 5.88368 7.69416 5.90884 7.70675 5.90255Z"
        fill="white"
      />
      <path
        d="M7.66903 5.94045C7.67532 5.94045 7.68161 5.92787 7.6879 5.92158C7.69419 5.91529 7.6879 5.94045 7.68161 5.94674C7.67532 5.95303 7.65644 5.92787 7.64386 5.92158C7.63128 5.91529 7.67532 5.89641 7.67532 5.88383C7.67532 5.87125 7.69419 5.90899 7.66903 5.94045Z"
        fill="white"
      />
      <path
        d="M7.64972 5.92768C7.65589 5.92768 7.65589 5.92151 7.64972 5.92151H7.64355V5.90918H7.66821L7.64972 5.92768Z"
        fill="white"
      />
      <path
        d="M6.69389 5.29841C6.68131 5.29841 6.67502 5.28583 6.66873 5.27953C6.66244 5.27324 6.68131 5.24179 6.69389 5.22292C6.70647 5.20404 6.68131 5.24179 6.6876 5.26066H6.71277C6.70647 5.24808 6.71277 5.2355 6.71906 5.2355C6.72061 5.24726 6.71911 5.25923 6.7147 5.27024C6.71029 5.28126 6.70313 5.29096 6.69389 5.29841Z"
        fill="white"
      />
      <path
        d="M7.70038 6.18584H7.68151V6.15439C7.68151 6.15439 7.67522 6.16068 7.68151 6.16068H7.69409V6.12922C7.70667 6.13552 7.70667 6.12293 7.71296 6.11664V6.12922V6.15439L7.75071 6.11035C7.73183 6.14181 7.72554 6.17326 7.70038 6.18584Z"
        fill="white"
      />
      <path
        d="M4.53613 6.60065C4.54871 6.6384 4.56759 6.59436 4.58646 6.60065C4.60533 6.60694 4.555 6.60694 4.56129 6.63211C4.569 6.63513 4.57748 6.63553 4.58544 6.63326C4.5934 6.63099 4.60038 6.62616 4.60533 6.61953C4.59904 6.65098 4.54242 6.65727 4.56129 6.70131C4.58017 6.74534 4.58646 6.7076 4.58646 6.72018C4.58646 6.73276 4.56759 6.7768 4.54871 6.79567H4.56129C4.54871 6.82083 4.51726 6.83342 4.49209 6.85229C4.46693 6.87116 4.45435 6.88374 4.47951 6.90891C4.50468 6.93407 4.4229 6.89632 4.4229 6.9152C4.40033 6.91779 4.37747 6.91453 4.35653 6.90571C4.33559 6.89689 4.31728 6.88283 4.30337 6.86487C4.27192 6.846 4.29079 6.83342 4.27192 6.80196H4.2845C4.27821 6.78938 4.2845 6.7768 4.26562 6.77051C4.27226 6.76556 4.27708 6.75857 4.27936 6.75062C4.28163 6.74266 4.28123 6.73418 4.27821 6.72647C4.26562 6.7076 4.27192 6.67614 4.2845 6.67614C4.29708 6.67614 4.2845 6.66356 4.27821 6.65727C4.27192 6.65098 4.29079 6.64469 4.29079 6.6384C4.32107 6.60557 4.34459 6.56709 4.35999 6.52516V6.53775L4.37257 6.55033V6.5C4.38515 6.51887 4.37257 6.54404 4.39144 6.55662C4.41031 6.5692 4.41031 6.53775 4.4229 6.53145V6.54404C4.44806 6.55662 4.44806 6.51887 4.47322 6.51887C4.49839 6.51887 4.49839 6.56291 4.52355 6.56291L4.56129 6.53775C4.55088 6.54412 4.5428 6.55368 4.53826 6.56502C4.53373 6.57636 4.53298 6.58886 4.53613 6.60065Z"
        fill="white"
      />
      <path
        d="M7.3921 6.27424V6.26166C7.37323 6.25537 7.36694 6.26795 7.35436 6.28053V6.29311C7.37323 6.29311 7.36065 6.27424 7.37952 6.28053C7.39839 6.28682 7.35436 6.31198 7.34178 6.32457C7.3292 6.33715 7.32919 6.28682 7.34807 6.27424C7.36694 6.26166 7.37952 6.25537 7.39839 6.24278C7.41727 6.2302 7.40468 6.26795 7.3921 6.27424Z"
        fill="white"
      />
      <path
        d="M7.07719 6.48778C7.05203 6.50036 7.00799 6.50036 7.0017 6.48149C6.99541 6.46262 6.99541 6.46262 6.99541 6.45633C6.98984 6.461 6.98333 6.46442 6.97631 6.46634C6.96929 6.46826 6.96194 6.46863 6.95477 6.46743C6.94759 6.46624 6.94076 6.4635 6.93475 6.45941C6.92873 6.45532 6.92367 6.44998 6.91992 6.44374C6.95138 6.34938 7.05203 6.3368 7.10236 6.32422V6.34938L7.12752 6.3368C7.13268 6.36417 7.13076 6.3924 7.12196 6.41882C7.11315 6.44525 7.09774 6.46898 7.07719 6.48778Z"
        fill="white"
      />
      <path
        d="M3.71872 8.58239H3.7313C3.71872 8.58868 3.71242 8.60756 3.70613 8.62643H3.73759C3.7313 8.63901 3.69984 8.63901 3.71872 8.66418H3.72501C3.67468 8.67676 3.68726 8.72079 3.63694 8.73337C3.58661 8.74596 3.56145 8.75225 3.52999 8.76483C3.49854 8.77741 3.50483 8.75225 3.49225 8.73967L3.46079 8.65159C3.47401 8.63526 3.48269 8.61573 3.48595 8.59498C3.4557 8.5903 3.42736 8.57722 3.40417 8.55723C3.36643 8.51319 3.41676 8.48803 3.41676 8.45029C3.41676 8.41254 3.46708 8.43141 3.47966 8.41883V8.40625C3.47337 8.45029 3.52999 8.41254 3.55515 8.41254H3.56774C3.56774 8.42512 3.54886 8.43141 3.55515 8.444L3.58661 8.43141C3.58032 8.4377 3.57403 8.4377 3.57403 8.45029L3.58661 8.46287C3.58032 8.46287 3.58032 8.46916 3.58032 8.47545L3.5929 8.48803L3.58032 8.5069C3.59919 8.51319 3.61177 8.5069 3.61177 8.53207L3.66839 8.51949L3.65581 8.53836H3.68726V8.55723H3.72501C3.7313 8.54465 3.68726 8.56981 3.71872 8.58239Z"
        fill="white"
      />
      <path
        d="M5.54887 6.23007H5.56145C5.55516 6.26782 5.57403 6.32443 5.52999 6.35589C5.50518 6.37627 5.47404 6.38739 5.44192 6.38734C5.42344 6.3754 5.40883 6.35833 5.3999 6.33822C5.39096 6.31811 5.38807 6.29583 5.3916 6.27411C5.41676 6.26153 5.42934 6.2112 5.4545 6.19233V6.2112L5.51741 6.18604C5.5237 6.19862 5.54258 6.2112 5.54887 6.23007Z"
        fill="white"
      />
      <path
        d="M6.68083 6.21094L6.66895 6.22282V6.21688L6.68083 6.21094Z"
        fill="white"
      />
      <path
        d="M6.56836 6.52531V6.51298C6.56836 6.52531 6.59302 6.53147 6.59302 6.51298C6.59302 6.49448 6.58069 6.53764 6.56836 6.52531Z"
        fill="white"
      />
      <path
        d="M6.41715 6.64491H6.42344C6.42973 6.64491 6.41086 6.67636 6.42973 6.67636C6.44861 6.67636 6.32279 6.67636 6.32908 6.76444C6.33537 6.85251 6.25359 6.80218 6.21584 6.77702C6.20391 6.76421 6.19727 6.74735 6.19727 6.72984C6.19727 6.71232 6.20391 6.69546 6.21584 6.68265L6.24101 6.63862C6.2473 6.6512 6.25988 6.64491 6.25988 6.63862L6.27875 6.62604C6.29133 6.65749 6.31021 6.60716 6.32908 6.61345H6.32279C6.35424 6.63862 6.36683 6.60087 6.39199 6.60716H6.41086C6.42344 6.61975 6.41086 6.63233 6.41715 6.64491Z"
        fill="white"
      />
      <path
        d="M5.27887 7.4691C5.29775 7.4691 5.26 7.49427 5.28517 7.49427C5.31033 7.49427 5.28516 7.52572 5.27887 7.5383H5.28517C5.24113 7.54459 5.29146 7.59492 5.22226 7.60121C5.15306 7.6075 5.16564 7.6075 5.15306 7.63266C5.14048 7.65783 5.09015 7.60121 5.07757 7.55088C5.06499 7.50056 5.08386 7.5383 5.08386 7.48797V7.46281C5.11531 7.48797 5.09015 7.41878 5.1216 7.43765L5.15935 7.3999C5.15306 7.41248 5.15935 7.41248 5.15935 7.41878C5.15935 7.42507 5.18451 7.40619 5.19709 7.3999V7.41878H5.22226C5.21597 7.42507 5.22226 7.43136 5.22855 7.43765L5.24113 7.42507C5.27887 7.44394 5.24113 7.4691 5.27887 7.4691Z"
        fill="white"
      />
      <path
        d="M5.09668 7.29908L5.12134 7.27441L5.10901 7.28674L5.09668 7.29908Z"
        fill="white"
      />
      <path
        d="M4.01374 7.0729V7.08548C3.99487 7.09177 4.00745 7.10435 4.00745 7.11693C4.00745 7.12952 3.95083 7.14839 3.93196 7.12322L3.91309 7.07919C3.93196 7.07919 3.93196 7.05403 3.93825 7.04144C3.94454 7.02886 3.96341 7.03515 3.96341 7.04144C3.98229 7.03515 3.98858 7.04144 4.00745 7.04773C4.02632 7.05403 4.00116 7.06661 4.01374 7.0729Z"
        fill="white"
      />
      <path
        d="M3.98845 7.05371V7.05965L3.97656 7.0656L3.98845 7.05371Z"
        fill="white"
      />
      <path
        d="M3.32816 6.05992C3.30929 6.0725 3.27783 6.05363 3.27783 6.02218C3.27783 5.99072 3.29041 5.99072 3.30929 5.99072C3.32816 5.99072 3.35961 6.05363 3.32816 6.05992Z"
        fill="white"
      />
      <path
        d="M3.6993 7.8279C3.70559 7.84048 3.6993 7.84048 3.70559 7.85935C3.71188 7.87822 3.67413 7.89081 3.64897 7.87822C3.6423 7.87175 3.63715 7.86388 3.63389 7.85518C3.63062 7.84648 3.62933 7.83716 3.6301 7.8279L3.65526 7.80273C3.67413 7.80903 3.69301 7.80273 3.70559 7.8279H3.6993Z"
        fill="white"
      />
      <path
        d="M3.61742 7.94662C3.61125 7.94045 3.61125 7.93429 3.61742 7.92196C3.62358 7.90963 3.63591 7.92196 3.63591 7.94045L3.61742 7.94662Z"
        fill="white"
      />
      <path
        d="M3.66829 6.94704C3.66581 6.95434 3.66168 6.96098 3.65623 6.96643C3.65078 6.97188 3.64414 6.97601 3.63684 6.97849C3.63055 6.96591 3.61167 6.96591 3.61797 6.95333C3.6192 6.94543 3.62291 6.93813 3.62857 6.93248C3.63422 6.92682 3.64152 6.92311 3.64942 6.92188C3.65571 6.92817 3.66829 6.92817 3.65571 6.94075L3.66829 6.94704Z"
        fill="white"
      />
      <path
        d="M3.64252 6.9462H3.63643C3.63034 6.95229 3.64252 6.91575 3.64861 6.94011C3.6547 6.96447 3.64252 6.9462 3.64252 6.9462Z"
        fill="white"
      />
      <path
        d="M3.31537 7.58845C3.30279 7.60103 3.30908 7.60732 3.32166 7.6199H3.32795C3.33424 7.6199 3.31537 7.63248 3.30908 7.6199C3.30279 7.60732 3.31537 7.65765 3.29021 7.65765C3.26504 7.65765 3.30908 7.67652 3.31537 7.6891C3.32166 7.70168 3.28392 7.67023 3.26504 7.6891C3.24617 7.70797 3.20213 7.70168 3.18955 7.73314C3.17697 7.76459 3.16439 7.73943 3.1581 7.72056C3.15582 7.72311 3.15409 7.7261 3.15301 7.72934C3.15193 7.73259 3.15152 7.73602 3.15181 7.73943C3.12664 7.73314 3.10148 7.6891 3.0889 7.70168C3.07632 7.71426 3.07003 7.67652 3.05745 7.67652C3.05678 7.67104 3.05469 7.66583 3.05138 7.66141C3.04807 7.65699 3.04365 7.65353 3.03857 7.65136C3.06374 7.6199 3.00083 7.62619 3.02599 7.60732C3.05115 7.58845 3.00712 7.58845 3.00083 7.58216C2.99454 7.57587 3.02599 7.58845 3.03228 7.57587C3.03857 7.56328 3.04486 7.53183 3.0197 7.49409C2.99454 7.45634 3.03857 7.48779 3.03857 7.47521H3.03228C3.05744 7.48779 3.05745 7.44376 3.07003 7.43747C3.08261 7.43118 3.12664 7.45634 3.12664 7.40601C3.12664 7.35569 3.17068 7.45634 3.18326 7.4186V7.39972C3.20213 7.4123 3.17068 7.42489 3.19584 7.43747C3.22101 7.45005 3.20213 7.41859 3.21472 7.4123C3.2273 7.40601 3.19584 7.46892 3.23988 7.46263L3.26504 7.44376C3.25988 7.45783 3.25774 7.47284 3.25875 7.48779C3.27762 7.51296 3.28392 7.46892 3.29021 7.48779C3.2965 7.50667 3.27133 7.50667 3.28392 7.51925L3.32166 7.53183C3.30279 7.53183 3.33424 7.56958 3.31537 7.58845Z"
        fill="white"
      />
      <path
        d="M4.71872 8.28729C4.69355 8.29358 4.67468 8.32504 4.64323 8.29987C4.61177 8.27471 4.61177 8.21809 4.6621 8.21809V8.19922H4.70613C4.69984 8.22438 4.73759 8.21809 4.7313 8.24955C4.72501 8.281 4.70613 8.27471 4.71872 8.28729Z"
        fill="white"
      />
      <path
        d="M4.49219 8.36805L4.52301 8.33722L4.53534 8.33105V8.33722L4.49219 8.36805Z"
        fill="white"
      />
      <path
        d="M4.46054 8.43823H4.47312L4.46054 8.4571H4.4857C4.46683 8.46968 4.46683 8.48855 4.46683 8.51372H4.47312C4.46181 8.53392 4.44649 8.55159 4.42809 8.56565C4.4097 8.57972 4.38863 8.58987 4.36617 8.5955C4.32843 8.58921 4.29068 8.57033 4.25923 8.5955C4.22777 8.62066 4.2781 8.57663 4.25294 8.57033C4.22778 8.56404 4.2089 8.53259 4.18374 8.52001C4.15858 8.50743 4.19003 8.46968 4.18374 8.44452C4.17745 8.41935 4.21519 8.41935 4.19632 8.40048H4.21519C4.23407 8.38161 4.2089 8.36903 4.2089 8.35644H4.24036C4.24036 8.33128 4.28439 8.31241 4.29697 8.29983C4.30956 8.28725 4.34101 8.26208 4.35359 8.23692C4.36617 8.21176 4.34101 8.29983 4.38505 8.31241C4.38476 8.309 4.38517 8.30557 4.38625 8.30233C4.38733 8.29908 4.38906 8.29609 4.39134 8.29354C4.42908 8.30612 4.37875 8.34386 4.4165 8.34386L4.44795 8.28095C4.44166 8.35645 4.41021 8.40048 4.46054 8.43823Z"
        fill="white"
      />
      <path
        d="M4.17139 8.29332L4.1776 8.28711L4.18382 8.30575L4.17139 8.29332Z"
        fill="white"
      />
      <path
        d="M12.1612 19.4098L12.1543 19.4028H12.1612V19.4098Z"
        fill="white"
      />
      <path
        d="M13.6573 19.271C13.6573 19.2772 13.6573 19.2833 13.6634 19.2833C13.6696 19.2833 13.6511 19.2957 13.6449 19.2957C13.6388 19.2957 13.6326 19.2772 13.6388 19.271H13.6573Z"
        fill="#214063"
      />
      <path
        d="M13.7081 19.2834H13.6957C13.6921 19.2802 13.6898 19.2758 13.6895 19.271C13.6957 19.271 13.7143 19.271 13.7081 19.2834Z"
        fill="#214063"
      />
      <path
        d="M12.242 17.7547H12.2358C12.2358 17.7547 12.2482 17.7485 12.242 17.7547Z"
        fill="#214063"
      />
      <path
        d="M12.2798 17.7607C12.2798 17.7666 12.2798 17.7666 12.2739 17.7666C12.2681 17.7666 12.2681 17.7607 12.2739 17.7607H12.2798Z"
        fill="#214063"
      />
      <path
        d="M12.9532 18.8423H12.947C12.9443 18.8377 12.9429 18.8323 12.9429 18.8269C12.9429 18.8215 12.9443 18.8162 12.947 18.8115C12.947 18.8239 12.9593 18.8362 12.9532 18.8423Z"
        fill="#214063"
      />
      <path
        d="M12.2795 17.8552C12.2733 17.8614 12.267 17.8676 12.2608 17.8614C12.2605 17.858 12.2609 17.8547 12.262 17.8515C12.2631 17.8482 12.2648 17.8453 12.267 17.8428C12.2703 17.8428 12.2735 17.8441 12.2758 17.8464C12.2782 17.8487 12.2795 17.8519 12.2795 17.8552Z"
        fill="#214063"
      />
      <path
        d="M12.4873 17.3076C12.4996 17.3138 12.5181 17.3261 12.512 17.3446C12.5058 17.3631 12.5058 17.3384 12.4996 17.3384C12.4935 17.3384 12.4935 17.3138 12.4873 17.3076Z"
        fill="#214063"
      />
      <path
        d="M13.3249 19.9628H13.3312V19.9753C13.3438 19.9628 13.3375 19.9879 13.3501 19.9879C13.3506 19.9938 13.3497 19.9997 13.3475 20.0051C13.3454 20.0106 13.3419 20.0155 13.3375 20.0194H13.3124C13.3124 20.0068 13.2872 20.0194 13.2935 20.0005C13.2998 19.9816 13.2935 19.9879 13.2935 19.9753C13.2935 19.9628 13.2998 19.9753 13.2998 19.969C13.3061 19.9753 13.3124 19.969 13.3187 19.9628C13.3249 19.9565 13.3249 19.9628 13.3249 19.9628Z"
        fill="#214063"
      />
      <path
        d="M12.5319 17.4147C12.5323 17.4194 12.5345 17.4238 12.538 17.427C12.5319 17.4332 12.5257 17.4208 12.5195 17.4147V17.4023C12.5228 17.4023 12.5259 17.4036 12.5282 17.406C12.5306 17.4083 12.5319 17.4114 12.5319 17.4147Z"
        fill="#214063"
      />
      <path
        d="M12.5883 17.4394C12.576 17.4333 12.576 17.4209 12.5698 17.4086C12.5637 17.3963 12.5883 17.4271 12.5883 17.4394Z"
        fill="#214063"
      />
      <path
        d="M12.5827 17.4347C12.5827 17.4347 12.5757 17.4347 12.5827 17.4277V17.4347Z"
        fill="white"
      />
      <path
        d="M12.7638 18.0876H12.752C12.7579 18.0876 12.7579 18.0817 12.7638 18.0876Z"
        fill="#214063"
      />
      <path
        d="M13.0787 18.0564C13.079 18.0597 13.0786 18.0631 13.0775 18.0663C13.0764 18.0694 13.0748 18.0724 13.0725 18.0749H13.054C13.0479 18.0687 13.0602 18.0625 13.054 18.0564C13.0479 18.0502 13.0725 18.0502 13.0787 18.0564Z"
        fill="#214063"
      />
      <path
        d="M13.004 18.0881C13.004 18.0881 12.9971 18.095 12.9971 18.0881C12.9971 18.0811 12.9971 18.0881 13.004 18.0881Z"
        fill="#214063"
      />
      <path
        d="M12.8389 18.2204H12.8273C12.8215 18.2204 12.8331 18.2146 12.8389 18.2204Z"
        fill="#214063"
      />
      <path
        d="M12.5636 17.7618L12.5566 17.7549L12.5636 17.7618Z"
        fill="#214063"
      />
      <path
        d="M12.5754 17.817C12.5754 17.8231 12.5816 17.8293 12.5754 17.8293C12.5693 17.8293 12.5569 17.8108 12.5508 17.8046H12.5569C12.5446 17.7923 12.5631 17.7923 12.5508 17.7861C12.5625 17.793 12.5713 17.804 12.5754 17.817Z"
        fill="#214063"
      />
      <path
        d="M13.0097 18.1636C13.0155 18.1694 13.0097 18.1694 13.0097 18.1752C13.0097 18.181 13.0039 18.1694 13.0039 18.1636H13.0097Z"
        fill="#214063"
      />
      <path
        d="M12.8898 18.2701C12.8882 18.2701 12.8867 18.2707 12.8856 18.2718C12.8845 18.273 12.8839 18.2745 12.8839 18.276C12.8835 18.2715 12.8814 18.2672 12.8779 18.2642C12.8839 18.2642 12.8898 18.2642 12.8898 18.2701Z"
        fill="#214063"
      />
      <path
        d="M12.9596 18.2454H12.9534C12.9534 18.2454 12.9473 18.2393 12.9534 18.2393C12.9596 18.2393 12.9534 18.2454 12.9596 18.2454Z"
        fill="#214063"
      />
      <path
        d="M12.9024 18.2769C12.9024 18.2831 12.9148 18.2955 12.9024 18.2955C12.89 18.2955 12.89 18.2831 12.8962 18.2769H12.9024Z"
        fill="#214063"
      />
      <path
        d="M12.6516 17.8994H12.6704C12.6767 17.9246 12.6956 17.9435 12.683 17.9686H12.6704C12.6641 17.9623 12.6641 17.956 12.6579 17.956C12.6516 17.956 12.639 17.9372 12.6453 17.9246V17.8994H12.6516Z"
        fill="#214063"
      />
      <path
        d="M12.594 17.993C12.5755 18.0054 12.5755 17.9807 12.5693 17.9745V17.9561C12.5764 17.9594 12.5825 17.9646 12.5868 17.9711C12.5911 17.9776 12.5936 17.9852 12.594 17.993Z"
        fill="#214063"
      />
      <path
        d="M12.5876 17.9806H12.5757L12.5816 17.9746L12.5757 17.9806H12.5876Z"
        fill="white"
      />
      <path
        d="M12.9725 19.2581H12.9662C12.9474 19.2455 12.9536 19.2141 12.9536 19.1952V19.1826C12.9628 19.1926 12.9693 19.2048 12.9726 19.218C12.9759 19.2312 12.9759 19.2449 12.9725 19.2581Z"
        fill="#214063"
      />
      <path
        d="M12.6135 18.088V18.1006C12.6073 18.1006 12.601 18.1006 12.601 18.0943C12.601 18.088 12.5884 18.0755 12.5884 18.0629H12.5947V18.0503C12.6056 18.06 12.6124 18.0735 12.6135 18.088Z"
        fill="#214063"
      />
      <path
        d="M12.6071 18.1256C12.6132 18.1256 12.6194 18.1441 12.6194 18.1503C12.6194 18.1564 12.6194 18.1626 12.6132 18.1626L12.5947 18.1379C12.6009 18.1318 12.5947 18.1256 12.5947 18.1194C12.5947 18.1133 12.6009 18.1318 12.6071 18.1256Z"
        fill="#214063"
      />
      <path
        d="M12.6144 18.1318L12.6074 18.1388L12.6144 18.1318Z"
        fill="white"
      />
      <path
        d="M12.3743 18.377C12.3743 18.3778 12.3741 18.3786 12.3738 18.3793C12.3735 18.3801 12.373 18.3807 12.3725 18.3813C12.3719 18.3819 12.3712 18.3823 12.3705 18.3827C12.3697 18.383 12.3689 18.3831 12.3681 18.3831C12.3558 18.3831 12.3558 18.3708 12.3558 18.3646C12.3558 18.3585 12.3496 18.3585 12.3496 18.3523C12.3496 18.3461 12.3681 18.3646 12.3743 18.377Z"
        fill="#214063"
      />
      <path
        d="M13.4309 18.0505C13.4183 18.0631 13.412 18.0442 13.4057 18.0316C13.3994 18.019 13.4057 17.9939 13.3994 17.975V17.9624C13.4057 17.9876 13.4435 18.019 13.4309 18.0505Z"
        fill="#214063"
      />
      <path
        d="M12.6696 18.541C12.6696 18.5426 12.6689 18.5442 12.6677 18.5453C12.6666 18.5465 12.665 18.5471 12.6634 18.5471C12.6618 18.5471 12.6602 18.5465 12.659 18.5453C12.6579 18.5442 12.6572 18.5426 12.6572 18.541V18.5225C12.661 18.5238 12.6643 18.5263 12.6665 18.5296C12.6687 18.533 12.6698 18.537 12.6696 18.541Z"
        fill="#214063"
      />
      <path
        d="M12.6144 18.4161L12.6074 18.4092H12.6144V18.4161Z"
        fill="white"
      />
      <path
        d="M12.72 18.6793H12.7262C12.7262 18.6777 12.7255 18.6761 12.7244 18.675C12.7232 18.6738 12.7217 18.6732 12.72 18.6732C12.7324 18.6732 12.7324 18.6793 12.7447 18.6917C12.757 18.704 12.7447 18.704 12.7324 18.7101C12.72 18.7163 12.7262 18.704 12.72 18.704C12.7139 18.704 12.72 18.6917 12.7139 18.6855V18.667L12.72 18.6793Z"
        fill="#214063"
      />
      <path
        d="M13.2877 18.2462C13.2859 18.2462 13.2841 18.2455 13.2828 18.2442C13.2815 18.2429 13.2808 18.2411 13.2808 18.2393L13.2877 18.2462Z"
        fill="#214063"
      />
      <path
        d="M13.2866 18.2511C13.2882 18.2511 13.2897 18.2505 13.2908 18.2494C13.2919 18.2483 13.2926 18.2468 13.2926 18.2452C13.2926 18.2436 13.2919 18.2421 13.2908 18.241C13.2897 18.2399 13.2882 18.2393 13.2866 18.2393V18.2511Z"
        fill="#214063"
      />
      <path
        d="M12.9409 18.5469C12.9472 18.5657 12.9661 18.5783 12.9598 18.5972C12.9535 18.6161 12.9409 18.6035 12.9409 18.5972C12.9377 18.5827 12.9377 18.5677 12.9409 18.5532V18.5469Z"
        fill="#214063"
      />
      <path
        d="M12.7137 18.805C12.7137 18.811 12.7198 18.8171 12.7137 18.8232H12.7015C12.6993 18.8208 12.6976 18.8179 12.6966 18.8147C12.6955 18.8116 12.6951 18.8083 12.6954 18.805H12.7015C12.7076 18.805 12.7076 18.7989 12.7137 18.805Z"
        fill="#214063"
      />
      <path
        d="M13.1726 18.5223C13.1735 18.531 13.1713 18.5397 13.1664 18.5469H13.1541C13.1541 18.5346 13.1479 18.5284 13.1541 18.5223C13.1603 18.5161 13.1664 18.5223 13.1726 18.5223Z"
        fill="#214063"
      />
      <path
        d="M12.6826 18.8429C12.6843 18.8429 12.6858 18.8422 12.687 18.841C12.6882 18.8399 12.6888 18.8383 12.6888 18.8366C12.6852 18.8335 12.683 18.829 12.6826 18.8242V18.8429Z"
        fill="#214063"
      />
      <path
        d="M13.5011 18.4087C13.5033 18.4112 13.505 18.4141 13.5061 18.4173C13.5071 18.4205 13.5075 18.4238 13.5073 18.4272C13.5011 18.4333 13.4888 18.4333 13.4888 18.4272C13.4888 18.421 13.4949 18.3963 13.5011 18.4087Z"
        fill="#214063"
      />
      <path
        d="M13.362 18.4911C13.3636 18.4911 13.3652 18.4904 13.3664 18.4893C13.3676 18.4881 13.3683 18.4865 13.3683 18.4848C13.3745 18.4848 13.3683 18.4911 13.3683 18.4974C13.3758 18.5031 13.3816 18.5109 13.385 18.5198C13.3883 18.5287 13.3891 18.5384 13.3871 18.5477C13.3808 18.554 13.3683 18.5477 13.3683 18.5477L13.3557 18.5163C13.3548 18.5034 13.3569 18.4904 13.362 18.4785V18.4911Z"
        fill="#214063"
      />
      <path
        d="M13.1105 18.6162C13.1088 18.6162 13.1073 18.6169 13.1061 18.618C13.105 18.6192 13.1043 18.6207 13.1043 18.6224H13.0981C13.0981 18.6285 13.0981 18.6347 13.1043 18.6347C13.1105 18.6347 13.1166 18.6285 13.1166 18.6224C13.1192 18.6241 13.1213 18.6264 13.1227 18.629C13.1242 18.6317 13.1249 18.6347 13.1249 18.6378C13.1249 18.6408 13.1242 18.6438 13.1227 18.6465C13.1213 18.6492 13.1192 18.6515 13.1166 18.6532H13.1043C13.1043 18.647 13.0981 18.6409 13.0981 18.6347C13.0981 18.6347 13.0981 18.6285 13.1043 18.6347V18.6224C13.1043 18.6162 13.1043 18.6162 13.1105 18.6162Z"
        fill="#214063"
      />
      <path
        d="M12.519 18.9868C12.519 18.9885 12.5183 18.99 12.5172 18.9912C12.516 18.9923 12.5145 18.993 12.5128 18.993C12.5112 18.993 12.5096 18.9923 12.5085 18.9912C12.5073 18.99 12.5067 18.9885 12.5067 18.9868C12.5005 18.9807 12.5067 18.9683 12.5005 18.9622C12.4943 18.956 12.519 18.9745 12.519 18.9868Z"
        fill="#214063"
      />
      <path
        d="M13.1163 18.6289C13.1163 18.6348 13.1104 18.6348 13.1104 18.6408H13.1163V18.6289Z"
        fill="white"
      />
      <path
        d="M12.8398 19.7357H12.8461C12.8524 19.7357 12.8398 19.7608 12.8587 19.7545C12.8775 19.7483 12.8587 19.7923 12.8398 19.8049H12.8461C12.8524 19.8175 12.865 19.83 12.8587 19.8363H12.8461C12.8209 19.8237 12.8524 19.7923 12.8209 19.7797C12.7895 19.7671 12.8084 19.7545 12.8084 19.742V19.7294C12.8146 19.7357 12.8209 19.7294 12.8272 19.7294H12.8335V19.7168C12.8332 19.7202 12.8336 19.7236 12.8347 19.7269C12.8358 19.7301 12.8375 19.7331 12.8398 19.7357Z"
        fill="#214063"
      />
      <path
        d="M12.7079 18.931C12.7079 18.9371 12.7141 18.9495 12.7079 18.9556C12.7018 18.9618 12.6956 18.9495 12.6895 18.9433C12.6911 18.9433 12.6927 18.9426 12.6938 18.9415C12.695 18.9403 12.6956 18.9388 12.6956 18.9371C12.6956 18.9355 12.695 18.9339 12.6938 18.9328C12.6927 18.9316 12.6911 18.931 12.6895 18.931C12.6956 18.931 12.7079 18.9248 12.7079 18.931Z"
        fill="#214063"
      />
      <path
        d="M13.3431 18.61C13.3469 18.6128 13.35 18.6166 13.3522 18.6208C13.3543 18.6251 13.3554 18.6298 13.3554 18.6346H13.3492C13.3369 18.6346 13.3369 18.6223 13.3369 18.61C13.3369 18.5976 13.3431 18.61 13.3431 18.61Z"
        fill="#214063"
      />
      <path
        d="M12.6572 19.0316C12.6572 19.0254 12.6634 19.0316 12.6634 19.0316C12.6634 19.0316 12.6759 19.0378 12.6697 19.044H12.6572V19.0316Z"
        fill="#214063"
      />
      <path
        d="M12.6642 19.0317V19.0387H12.6572V19.0317H12.6642Z"
        fill="white"
      />
      <path
        d="M12.7202 19.1445C12.7219 19.1452 12.7235 19.1462 12.7249 19.1475C12.7262 19.1489 12.7272 19.1505 12.7278 19.1523C12.7284 19.1541 12.7285 19.156 12.7283 19.1578C12.728 19.1597 12.7274 19.1615 12.7263 19.163C12.7263 19.163 12.7263 19.1754 12.7202 19.1754C12.714 19.1754 12.7078 19.163 12.7017 19.1569C12.7078 19.1507 12.7017 19.1507 12.7078 19.1445H12.7202Z"
        fill="#214063"
      />
      <path
        d="M12.4935 19.2207C12.4996 19.233 12.512 19.2392 12.5058 19.2515C12.4996 19.2639 12.4935 19.2515 12.4873 19.2454V19.2207H12.4935Z"
        fill="#214063"
      />
      <path
        d="M13.4309 18.749C13.4371 18.749 13.4432 18.7614 13.4432 18.7737C13.4432 18.786 13.4432 18.786 13.4309 18.7922H13.4124C13.4127 18.7888 13.4123 18.7855 13.4112 18.7823C13.4102 18.7791 13.4085 18.7762 13.4062 18.7737C13.4247 18.7737 13.4062 18.7552 13.4186 18.7614H13.4309V18.749Z"
        fill="#214063"
      />
      <path
        d="M13.2296 18.8302H13.2236V18.8184C13.2236 18.8184 13.2236 18.8302 13.2296 18.8302Z"
        fill="#214063"
      />
      <path
        d="M12.657 19.2014C12.657 19.2137 12.6693 19.2261 12.657 19.2384C12.6447 19.2507 12.6447 19.2322 12.6385 19.2261C12.6323 19.2199 12.6323 19.2199 12.6323 19.2137H12.6447C12.6447 19.2014 12.657 19.1891 12.657 19.2014Z"
        fill="#214063"
      />
      <path
        d="M13.2361 18.8612H13.23V18.8427H13.2361C13.23 18.8427 13.2361 18.8489 13.2361 18.8489C13.2361 18.8489 13.2423 18.855 13.2423 18.8489C13.2423 18.8427 13.2423 18.8365 13.2361 18.8365H13.2423V18.8242C13.2361 18.8365 13.2485 18.8489 13.2361 18.8612Z"
        fill="#214063"
      />
      <path
        d="M12.8272 19.2951H12.8213C12.8213 19.301 12.8272 19.2951 12.8272 19.2892C12.8272 19.2834 12.8272 19.2951 12.8272 19.2951Z"
        fill="#214063"
      />
      <path
        d="M13.2424 19.277H13.2486C13.2547 19.2708 13.2486 19.2708 13.2424 19.2646C13.2486 19.2708 13.2486 19.277 13.2547 19.2893H13.2424C13.2363 19.2831 13.2363 19.277 13.2424 19.2646V19.277Z"
        fill="#214063"
      />
      <path
        d="M13.2368 19.2832H13.2438V19.2902L13.2368 19.2832Z"
        fill="white"
      />
      <path
        d="M12.8709 19.5911C12.8709 19.5972 12.8585 19.5972 12.8524 19.5972C12.8462 19.5972 12.8462 19.5911 12.8462 19.5849C12.8462 19.5787 12.8585 19.5849 12.8524 19.5787H12.8462C12.8478 19.5787 12.8494 19.5781 12.8506 19.5769C12.8517 19.5758 12.8524 19.5742 12.8524 19.5726C12.8524 19.5709 12.8517 19.5694 12.8506 19.5682C12.8494 19.5671 12.8478 19.5664 12.8462 19.5664H12.8585C12.8585 19.5726 12.8709 19.5787 12.8709 19.5911Z"
        fill="#214063"
      />
      <path
        d="M13.1411 19.4215C13.1411 19.4277 13.1534 19.44 13.1411 19.4462C13.1287 19.4523 13.1287 19.4462 13.1226 19.44V19.4215V19.4092H13.1287C13.1349 19.4215 13.1349 19.4215 13.1411 19.4215Z"
        fill="#214063"
      />
      <path
        d="M13.1413 19.4343C13.1413 19.4405 13.1351 19.4343 13.1351 19.4343C13.1351 19.4343 13.1289 19.4281 13.1289 19.4219C13.1289 19.4157 13.1351 19.4219 13.1413 19.4343Z"
        fill="white"
      />
      <path
        d="M12.8147 19.5349H12.8085C12.8022 19.5349 12.8022 19.5287 12.8022 19.5225C12.8022 19.5241 12.8029 19.5257 12.8041 19.5269C12.8052 19.528 12.8068 19.5287 12.8085 19.5287C12.8147 19.5225 12.8209 19.5287 12.8147 19.5349Z"
        fill="#214063"
      />
      <path
        d="M13.1984 19.4714H13.186C13.1922 19.4653 13.186 19.4653 13.186 19.4653H13.1984V19.4468C13.1984 19.4591 13.2045 19.4653 13.1984 19.4714Z"
        fill="#214063"
      />
      <path
        d="M12.7329 20.2836C12.7455 20.2836 12.7392 20.271 12.7392 20.271C12.7392 20.271 12.7392 20.2773 12.7455 20.2836C12.7518 20.2899 12.7518 20.271 12.7455 20.271C12.7518 20.2773 12.7455 20.2962 12.7581 20.3025H12.7707C12.7707 20.315 12.777 20.315 12.7833 20.3276C12.7896 20.3339 12.7833 20.3465 12.7833 20.3528C12.7833 20.3591 12.7896 20.3717 12.7959 20.3717C12.8021 20.3717 12.7833 20.3779 12.7896 20.3842C12.7867 20.3906 12.7824 20.3962 12.7769 20.4006C12.7714 20.405 12.765 20.408 12.7581 20.4094H12.7392C12.7329 20.4094 12.7329 20.4031 12.7267 20.4094C12.7204 20.4157 12.7267 20.3968 12.7204 20.3968C12.717 20.3968 12.7138 20.3955 12.7115 20.3931C12.7091 20.3908 12.7078 20.3876 12.7078 20.3842H12.7015C12.7002 20.3709 12.6959 20.3579 12.6889 20.3465H12.6826C12.6889 20.3465 12.6952 20.3528 12.7015 20.3465V20.3339H12.7078C12.7141 20.3276 12.7015 20.3213 12.7078 20.315C12.7141 20.3087 12.7204 20.3213 12.7267 20.315V20.2962C12.7204 20.271 12.7267 20.2836 12.7329 20.2836Z"
        fill="#214063"
      />
      <path
        d="M13.1671 19.5599C13.1671 19.5583 13.1665 19.5567 13.1653 19.5556C13.1642 19.5544 13.1626 19.5537 13.161 19.5537C13.1593 19.5537 13.1577 19.5544 13.1566 19.5556C13.1554 19.5567 13.1548 19.5583 13.1548 19.5599C13.1548 19.5615 13.1554 19.5631 13.1566 19.5643C13.1577 19.5654 13.1593 19.5661 13.161 19.5661C13.1671 19.5661 13.1609 19.5661 13.1671 19.5599C13.1733 19.5537 13.1671 19.5722 13.1671 19.5784C13.1671 19.5846 13.1548 19.5722 13.1548 19.5661C13.1548 19.5599 13.161 19.5537 13.161 19.5476C13.161 19.5414 13.1671 19.5537 13.1671 19.5599Z"
        fill="#214063"
      />
      <path
        d="M13.1545 19.6667C13.1545 19.6729 13.1482 19.6855 13.1419 19.6792C13.1356 19.6729 13.1356 19.6792 13.1293 19.6792C13.123 19.6792 13.1293 19.6981 13.1167 19.6918C13.1041 19.6855 13.1167 19.6478 13.123 19.6289H13.1293C13.1335 19.6297 13.1374 19.6312 13.141 19.6336C13.1445 19.6359 13.1476 19.6389 13.1499 19.6424C13.1523 19.6459 13.1539 19.6499 13.1547 19.6541C13.1554 19.6582 13.1554 19.6625 13.1545 19.6667Z"
        fill="#214063"
      />
      <path
        d="M13.0918 20.8057L13.1044 20.8182C13.1044 20.8245 13.1044 20.8308 13.1107 20.8308C13.1107 20.8497 13.1233 20.8497 13.117 20.8623C13.1107 20.8749 13.1107 20.8874 13.1107 20.9C13.1107 20.9126 13.1044 20.9 13.1044 20.9063H13.073C13.073 20.9 13.0667 20.9 13.0604 20.8937L13.0415 20.9063C13.0289 20.9126 13.0289 20.8937 13.0163 20.8937C13.0038 20.8937 13.0163 20.8749 13.0163 20.8686C13.0226 20.8749 13.0226 20.856 13.0289 20.8497C13.0289 20.856 13.0289 20.856 13.0352 20.856H13.0541C13.0541 20.8497 13.0541 20.8434 13.0604 20.8497V20.8308H13.073C13.0855 20.7994 13.0855 20.812 13.0918 20.8057Z"
        fill="#214063"
      />
      <path
        d="M12.8215 19.9688H12.8278C12.8278 19.975 12.8467 19.9813 12.8467 19.9939C12.8477 20.0048 12.8455 20.0157 12.8404 20.0254L12.8027 20.0128C12.809 20.0065 12.7964 19.9939 12.7964 19.9876H12.8027V19.9688H12.8215Z"
        fill="#214063"
      />
      <path
        d="M13.0726 19.7864H13.0664C13.0726 19.7864 13.0787 19.7803 13.0726 19.7803C13.0664 19.7803 13.0787 19.7864 13.0726 19.7864Z"
        fill="#214063"
      />
      <path
        d="M13.0725 19.8432H13.0788C13.0913 19.8558 13.0599 19.8621 13.0788 19.881C13.0976 19.8998 13.0788 19.8998 13.0662 19.9061C13.0536 19.9124 13.0473 19.8998 13.041 19.8872V19.8747C13.0536 19.8747 13.041 19.8621 13.0473 19.8558C13.0599 19.8495 13.0536 19.8432 13.0599 19.8369H13.0725V19.8432Z"
        fill="#214063"
      />
      <path
        d="M13.0604 20.2523C13.0666 20.246 13.0666 20.2586 13.0666 20.2523C13.0666 20.246 13.0792 20.2586 13.0792 20.2649C13.0729 20.2775 13.0981 20.2712 13.0855 20.29C13.0729 20.3089 13.0792 20.3026 13.0792 20.3089C13.0792 20.3152 13.0666 20.3215 13.0541 20.3152L13.0352 20.3026C13.0415 20.3026 13.0226 20.2963 13.0352 20.29V20.2775H13.0415V20.2649H13.0478V20.2523C13.0478 20.254 13.0484 20.2556 13.0496 20.2568C13.0508 20.2579 13.0524 20.2586 13.0541 20.2586C13.0541 20.246 13.0541 20.2649 13.0604 20.2523Z"
        fill="#214063"
      />
      <path
        d="M12.7579 20.5035H12.7641C12.7657 20.5035 12.7673 20.5042 12.7685 20.5053C12.7696 20.5065 12.7703 20.5081 12.7703 20.5097C12.7703 20.5159 12.7703 20.5282 12.7641 20.5282H12.7456C12.7472 20.5282 12.7488 20.5276 12.75 20.5264C12.7511 20.5252 12.7518 20.5237 12.7518 20.522C12.7518 20.5204 12.7511 20.5188 12.75 20.5177C12.7488 20.5165 12.7472 20.5159 12.7456 20.5159V20.5035L12.7579 20.4912C12.7518 20.4974 12.7579 20.5035 12.7579 20.5035Z"
        fill="#214063"
      />
      <path
        d="M12.4054 20.5162C12.4054 20.5224 12.3991 20.5286 12.3867 20.5224V20.5099C12.3929 20.5037 12.4116 20.5037 12.4054 20.5162Z"
        fill="#214063"
      />
      <path
        d="M12.9028 20.7051H12.9089C12.9089 20.7112 12.9089 20.7236 12.9028 20.7236C12.8966 20.7236 12.8966 20.7297 12.8904 20.7236C12.8843 20.7174 12.8904 20.7174 12.8843 20.7112L12.9028 20.7051Z"
        fill="#214063"
      />
      <path
        d="M12.6759 20.5728C12.6793 20.5758 12.6814 20.5801 12.6818 20.5846H12.6699V20.5728H12.6759Z"
        fill="#214063"
      />
      <path
        d="M12.6699 20.5797C12.6769 20.5797 12.663 20.5728 12.6769 20.5728L12.6699 20.5797Z"
        fill="white"
      />
      <path
        d="M12.5571 20.7172H12.5634C12.5571 20.7235 12.5634 20.7235 12.5634 20.7298H12.5697C12.5697 20.7306 12.5699 20.7315 12.5702 20.7322C12.5705 20.733 12.571 20.7337 12.5716 20.7343C12.5721 20.7348 12.5728 20.7353 12.5736 20.7356C12.5744 20.7359 12.5752 20.7361 12.576 20.7361H12.5823C12.576 20.7487 12.5823 20.7738 12.5571 20.7801H12.5383C12.5257 20.7738 12.5257 20.7676 12.5194 20.7613C12.5131 20.755 12.5257 20.7613 12.5194 20.755V20.7424C12.5257 20.7424 12.5257 20.7361 12.5194 20.7361L12.5446 20.7235V20.7109C12.5571 20.7109 12.5508 20.7172 12.5571 20.7172Z"
        fill="#214063"
      />
      <path
        d="M12.7837 20.7742H12.7899C12.7962 20.7805 12.8025 20.7805 12.8025 20.7868H12.8088C12.8088 20.7931 12.8025 20.7931 12.8025 20.7994C12.8025 20.8056 12.7962 20.8182 12.8025 20.8245C12.8088 20.8308 12.8025 20.8371 12.7962 20.8308H12.8025C12.7962 20.8371 12.7837 20.8371 12.7837 20.8434H12.7648C12.7585 20.8371 12.7522 20.856 12.7522 20.8434C12.7522 20.8308 12.7459 20.8434 12.7459 20.8497V20.8371C12.7333 20.8497 12.7333 20.8245 12.7207 20.8308C12.7082 20.8371 12.7207 20.8245 12.7207 20.8245H12.7145C12.7207 20.8182 12.7145 20.8119 12.7145 20.8056C12.7145 20.7993 12.727 20.7931 12.7145 20.7805C12.7019 20.7679 12.7333 20.7805 12.7207 20.7679C12.727 20.7679 12.727 20.7805 12.727 20.7742C12.727 20.7679 12.727 20.7679 12.727 20.7616C12.727 20.7553 12.7396 20.7742 12.7396 20.7616H12.7522C12.7585 20.7616 12.7522 20.749 12.7585 20.7553C12.7585 20.7561 12.7587 20.757 12.759 20.7577C12.7593 20.7585 12.7598 20.7592 12.7603 20.7598C12.7609 20.7603 12.7616 20.7608 12.7624 20.7611C12.7631 20.7614 12.764 20.7616 12.7648 20.7616V20.749C12.7711 20.7742 12.7837 20.7679 12.7837 20.7742Z"
        fill="#214063"
      />
      <path
        d="M13.166 20.5166C13.1666 20.5215 13.1658 20.5264 13.1636 20.5308C13.1614 20.5352 13.158 20.5388 13.1537 20.5413C13.1475 20.5351 13.129 20.5351 13.1414 20.5228C13.1475 20.5289 13.1537 20.5166 13.1599 20.5228C13.166 20.5289 13.1598 20.5228 13.166 20.5166Z"
        fill="#214063"
      />
      <path
        d="M13.1551 20.5855L13.1489 20.5731V20.5669H13.1551V20.5855Z"
        fill="#214063"
      />
      <path
        d="M13.1677 20.6045C13.1677 20.6108 13.1677 20.6108 13.174 20.6108C13.174 20.6141 13.1753 20.6173 13.1777 20.6197C13.18 20.622 13.1832 20.6234 13.1866 20.6234C13.1916 20.6353 13.1938 20.6482 13.1929 20.6611L13.174 20.6863C13.1677 20.6926 13.174 20.68 13.1677 20.6863H13.1425C13.1425 20.68 13.1362 20.68 13.1237 20.68C13.1111 20.68 13.1237 20.6674 13.1174 20.6674C13.1124 20.66 13.1101 20.6511 13.1111 20.6422C13.1174 20.6359 13.1111 20.6297 13.1048 20.6234C13.0985 20.6171 13.1174 20.6297 13.1237 20.6234C13.1299 20.6171 13.1362 20.6359 13.1425 20.6297L13.1299 20.6108C13.1425 20.5982 13.1488 20.6108 13.1677 20.6045Z"
        fill="#214063"
      />
      <path
        d="M13.085 20.6554V20.6484H13.0919L13.085 20.6554Z"
        fill="#214063"
      />
      <path
        d="M8.4864 18.805C8.4864 18.8112 8.48023 18.8112 8.48023 18.8173C8.48023 18.8235 8.4679 18.8235 8.4679 18.8173C8.46686 18.8158 8.46618 18.814 8.46593 18.8121C8.46568 18.8102 8.46586 18.8083 8.46645 18.8066C8.46705 18.8048 8.46804 18.8032 8.46936 18.8018C8.47068 18.8005 8.47229 18.7995 8.47407 18.7988L8.4864 18.805Z"
        fill="#214063"
      />
      <path
        d="M8.51256 18.8366C8.51256 18.8429 8.50635 18.8366 8.50635 18.8366V18.8242C8.51256 18.818 8.52499 18.8242 8.51256 18.8366Z"
        fill="#214063"
      />
      <path
        d="M7.76872 17.2388H7.75684C7.76278 17.2329 7.76872 17.2329 7.76872 17.2388Z"
        fill="#214063"
      />
      <path
        d="M7.79504 17.2451C7.79504 17.2521 7.79504 17.2521 7.78809 17.2521H7.79504V17.2451Z"
        fill="#214063"
      />
      <path
        d="M8.11559 18.2198H8.10938C8.10938 18.2136 8.11559 18.2012 8.1218 18.2012C8.12802 18.2012 8.1218 18.2136 8.11559 18.2198Z"
        fill="#214063"
      />
      <path
        d="M7.78825 17.3203C7.78231 17.3263 7.77637 17.3263 7.77637 17.3203H7.78825Z"
        fill="#214063"
      />
      <path
        d="M7.98389 16.8865C7.99622 16.8927 8.00855 16.905 8.00238 16.9174C7.99622 16.9297 7.99622 16.9174 7.99005 16.9112C7.98389 16.905 7.99005 16.8927 7.98389 16.8804V16.8865Z"
        fill="#214063"
      />
      <path
        d="M7.93953 19.1824H7.94582V19.1949C7.95211 19.1949 7.93953 19.2075 7.94582 19.2075C7.95211 19.2075 7.93324 19.2264 7.92066 19.2264H7.90808C7.90808 19.2201 7.8892 19.2138 7.90179 19.2075C7.91437 19.2012 7.90808 19.1949 7.91437 19.1886C7.92066 19.1824 7.92066 19.1886 7.92066 19.1886H7.93953C7.93324 19.1761 7.93953 19.1761 7.93953 19.1824Z"
        fill="#214063"
      />
      <path
        d="M8.02063 16.9806V16.9929C8.01447 16.9929 8.0083 16.9806 8.0083 16.9806V16.9683L8.02063 16.9806Z"
        fill="#214063"
      />
      <path
        d="M8.06486 17.0056C8.05869 16.9995 8.05869 16.9871 8.05253 16.981C8.04636 16.9748 8.06486 16.9995 8.06486 17.0056Z"
        fill="#214063"
      />
      <path
        d="M8.14172 17.5786H8.13477C8.13582 17.578 8.13702 17.5776 8.13824 17.5776C8.13946 17.5776 8.14066 17.578 8.14172 17.5786Z"
        fill="#214063"
      />
      <path
        d="M8.31115 17.6232C8.31024 17.6232 8.30934 17.623 8.30849 17.6226C8.30765 17.6223 8.30688 17.6218 8.30624 17.6211C8.30559 17.6205 8.30508 17.6197 8.30473 17.6189C8.30438 17.618 8.3042 17.6171 8.3042 17.6162L8.31115 17.6232Z"
        fill="#214063"
      />
      <path
        d="M8.39838 17.6158C8.39838 17.6158 8.39838 17.6282 8.39221 17.6282C8.38605 17.6282 8.37988 17.6282 8.37988 17.6158C8.37988 17.6035 8.37988 17.6097 8.37988 17.6035L8.39838 17.6158Z"
        fill="#214063"
      />
      <path
        d="M8.32989 17.6287C8.32989 17.6287 8.33606 17.6287 8.32989 17.6348H8.32373C8.32373 17.6348 8.32989 17.6225 8.32989 17.6287Z"
        fill="#214063"
      />
      <path
        d="M8.17733 17.6977C8.17153 17.6977 8.17153 17.7035 8.16573 17.6977C8.15994 17.6919 8.17733 17.6919 8.17733 17.6977Z"
        fill="#214063"
      />
      <path
        d="M8.0216 17.2775L8.01465 17.2705H8.0216V17.2775Z"
        fill="#214063"
      />
      <path
        d="M8.0268 17.3206C8.0268 17.3267 8.03296 17.3329 8.0268 17.3329C8.02063 17.3329 8.01447 17.3144 8.0083 17.3082H8.01447C8.0083 17.3021 8.02063 17.3021 8.01447 17.2959C8.02084 17.3028 8.02512 17.3113 8.0268 17.3206Z"
        fill="#214063"
      />
      <path
        d="M8.20915 17.7485C8.20915 17.7501 8.20853 17.7516 8.20741 17.7527C8.2063 17.7539 8.20479 17.7545 8.20321 17.7545C8.19727 17.7545 8.20321 17.7485 8.19727 17.7485H8.20915Z"
        fill="#214063"
      />
      <path
        d="M8.26721 17.7485C8.26721 17.7485 8.26025 17.7555 8.26025 17.7485H8.26721Z"
        fill="#214063"
      />
      <path
        d="M8.21554 17.7611C8.21554 17.7673 8.22175 17.7735 8.20932 17.7735C8.1969 17.7735 8.20311 17.7611 8.20932 17.7549L8.21554 17.7611Z"
        fill="#214063"
      />
      <path
        d="M8.07788 17.4023H8.09046C8.09675 17.4212 8.10933 17.4464 8.09675 17.459H8.08417C8.08053 17.4557 8.07827 17.4512 8.07788 17.4464C8.07788 17.4401 8.06529 17.4338 8.07159 17.4212C8.0713 17.4178 8.07171 17.4144 8.07279 17.4111C8.07387 17.4079 8.0756 17.4049 8.07788 17.4023Z"
        fill="#214063"
      />
      <path
        d="M8.02142 17.4706C8.00909 17.4767 8.00909 17.4583 8.00293 17.4521V17.4336C8.012 17.4442 8.01835 17.4569 8.02142 17.4706Z"
        fill="#214063"
      />
      <path
        d="M8.01525 17.4601H8.0083L8.01525 17.4531L8.0083 17.4601H8.01525Z"
        fill="white"
      />
      <path
        d="M8.00222 18.5347H7.99593C7.98335 18.5221 8.00222 18.497 8.00851 18.4844H8.0148C8.01641 18.4932 8.01611 18.5022 8.01394 18.5109C8.01177 18.5196 8.00778 18.5277 8.00222 18.5347Z"
        fill="#214063"
      />
      <path
        d="M8.02142 17.5468V17.5591H8.00909C8.00292 17.553 8.00909 17.5406 8.00909 17.5345C8.01525 17.5345 8.00909 17.5345 8.00909 17.5283C8.01455 17.5335 8.01877 17.5398 8.02142 17.5468Z"
        fill="#214063"
      />
      <path
        d="M8.0153 17.5416C8.00834 17.5416 8.0153 17.5416 8.0153 17.5347V17.5416Z"
        fill="white"
      />
      <path
        d="M8.00909 17.5784L8.02142 17.6031C8.01526 17.6093 8.01526 17.6154 8.00909 17.6093C8.00293 17.6031 8.00293 17.5969 8.00293 17.5846V17.5723C8.00293 17.5723 8.00293 17.5846 8.00909 17.5784Z"
        fill="#214063"
      />
      <path d="M8.01525 17.585L8.0083 17.5919V17.585H8.01525Z" fill="white" />
      <path
        d="M7.78235 17.7356H7.77619C7.77002 17.7356 7.77002 17.7233 7.77002 17.7171C7.77002 17.7109 7.77002 17.7171 7.77002 17.7109C7.77385 17.7138 7.77696 17.7175 7.7791 17.7218C7.78124 17.7261 7.78235 17.7308 7.78235 17.7356Z"
        fill="#214063"
      />
      <path
        d="M8.67594 17.6917C8.66335 17.698 8.66336 17.6854 8.65706 17.6728C8.65077 17.6602 8.66965 17.6414 8.66336 17.6162H8.66965C8.66965 17.6351 8.69481 17.6728 8.67594 17.6917Z"
        fill="#214063"
      />
      <path
        d="M7.983 17.9177H7.97678C7.97678 17.9239 7.97057 17.9239 7.97057 17.9177C7.97057 17.9115 7.97057 17.9053 7.96436 17.9053H7.97057C7.983 17.8991 7.983 17.9053 7.983 17.9177Z"
        fill="#214063"
      />
      <path d="M7.96545 17.8058L7.9585 17.7988H7.96545V17.8058Z" fill="white" />
      <path
        d="M7.98304 18.0317H7.98921C7.99144 18.0342 7.99314 18.0372 7.9942 18.0403C7.99526 18.0435 7.99566 18.0469 7.99537 18.0502C7.99537 18.0564 7.99537 18.0626 7.98921 18.0626H7.97688C7.97071 18.0564 7.98304 18.0502 7.97688 18.0441H7.98304V18.0317Z"
        fill="#214063"
      />
      <path
        d="M8.52423 17.8235C8.52423 17.8297 8.51807 17.8235 8.51807 17.8174L8.52423 17.8235Z"
        fill="#214063"
      />
      <path
        d="M8.52401 17.8293H8.51807C8.52401 17.8293 8.52401 17.8233 8.52401 17.8174V17.8293Z"
        fill="#214063"
      />
      <path
        d="M8.18469 17.9873C8.18469 17.9996 8.19703 18.0181 8.19086 18.0305C8.1893 18.0315 8.18751 18.0322 8.18565 18.0324C8.18378 18.0327 8.18189 18.0325 8.1801 18.0319C8.17831 18.0313 8.17669 18.0303 8.17535 18.029C8.17401 18.0277 8.17299 18.0261 8.17236 18.0243C8.17236 18.012 8.18469 17.9996 8.18469 17.9873Z"
        fill="#214063"
      />
      <path
        d="M7.94553 18.1258C7.94553 18.1321 7.94554 18.1383 7.93932 18.1383C7.93311 18.1383 7.93311 18.1383 7.93311 18.1321C7.93311 18.1258 7.93311 18.1258 7.93311 18.1196H7.94553V18.1258Z"
        fill="#214063"
      />
      <path
        d="M8.36682 18.031C8.36682 18.031 8.36682 18.0433 8.36066 18.0433H8.35449V18.0248C8.36682 18.0125 8.36682 18.0248 8.36682 18.031Z"
        fill="#214063"
      />
      <path
        d="M7.91357 18.1443C7.91357 18.1505 7.91979 18.1443 7.91979 18.1443H7.91357Z"
        fill="#214063"
      />
      <path
        d="M8.64988 18.025C8.65597 18.0311 8.64988 18.0372 8.64988 18.0433H8.6377C8.6377 18.0311 8.64379 18.0128 8.64988 18.025Z"
        fill="#214063"
      />
      <path
        d="M8.52479 18.0503C8.53108 18.0566 8.53108 18.0503 8.53108 18.0503V18.0566C8.53108 18.0566 8.53737 18.0943 8.52479 18.1069H8.51221V18.0817L8.52479 18.0503Z"
        fill="#214063"
      />
      <path
        d="M8.29749 18.0877H8.29132C8.28515 18.0939 8.28515 18.0939 8.29132 18.1001C8.29749 18.1062 8.29749 18.0939 8.30365 18.0877C8.30982 18.0816 8.30982 18.1124 8.29749 18.1186C8.28516 18.1247 8.29132 18.1124 8.28516 18.1062V18.0939C8.28516 18.0939 8.29132 18.0877 8.29132 18.0939H8.29749C8.29749 18.0939 8.29132 18.0877 8.29749 18.0877Z"
        fill="#214063"
      />
      <path
        d="M7.75044 18.2011C7.75044 18.2027 7.74979 18.2043 7.74863 18.2055C7.74748 18.2066 7.74591 18.2073 7.74427 18.2073C7.74264 18.2073 7.74107 18.2066 7.73991 18.2055C7.73876 18.2043 7.73811 18.2027 7.73811 18.2011C7.73194 18.1949 7.74427 18.1888 7.73811 18.1826L7.75044 18.2011Z"
        fill="#214063"
      />
      <path
        d="M7.72555 18.805H7.73184C7.73184 18.805 7.71296 18.8176 7.73184 18.8176C7.75071 18.8176 7.71296 18.8428 7.70038 18.8428C7.70103 18.8477 7.70018 18.8528 7.69794 18.8573C7.69569 18.8617 7.69217 18.8654 7.6878 18.8679C7.68698 18.8679 7.68616 18.8678 7.68539 18.8674C7.68463 18.8671 7.68394 18.8667 7.68335 18.8661C7.68277 18.8655 7.6823 18.8648 7.68199 18.864C7.68167 18.8633 7.68151 18.8624 7.68151 18.8616C7.67522 18.8427 7.70667 18.8365 7.6878 18.8176C7.68823 18.806 7.69268 18.7948 7.70038 18.7861C7.70038 18.7924 7.71296 18.7924 7.71296 18.7924H7.72555C7.72388 18.7924 7.72228 18.7931 7.7211 18.7943C7.71992 18.7954 7.71926 18.797 7.71926 18.7987C7.71926 18.8004 7.71992 18.802 7.7211 18.8032C7.72228 18.8043 7.72388 18.805 7.72555 18.805Z"
        fill="#214063"
      />
      <path
        d="M7.90781 18.2204C7.90781 18.2204 7.9078 18.2328 7.90159 18.2328C7.89538 18.2328 7.89537 18.2266 7.88916 18.2204H7.89538C7.89538 18.2204 7.90781 18.2079 7.90781 18.2204Z"
        fill="#214063"
      />
      <path
        d="M8.4801 18.1446V18.1693C8.47393 18.1693 8.47393 18.1755 8.47393 18.1693C8.47393 18.1631 8.46777 18.157 8.47393 18.1446C8.4801 18.1323 8.47393 18.1446 8.4801 18.1446Z"
        fill="#214063"
      />
      <path
        d="M7.83887 18.2767C7.84508 18.2705 7.84508 18.2767 7.84508 18.2767C7.84673 18.2767 7.84831 18.2774 7.84948 18.2785C7.85064 18.2797 7.8513 18.2813 7.8513 18.2829C7.8513 18.2846 7.85064 18.2862 7.84948 18.2873C7.84831 18.2885 7.84673 18.2892 7.84508 18.2892C7.84427 18.2892 7.84346 18.289 7.8427 18.2887C7.84195 18.2884 7.84126 18.2879 7.84069 18.2873C7.84011 18.2868 7.83965 18.2861 7.83934 18.2853C7.83903 18.2846 7.83887 18.2838 7.83887 18.2829V18.2705V18.2767Z"
        fill="#214063"
      />
      <path
        d="M7.84582 18.2769V18.2838L7.83887 18.2769H7.84582Z"
        fill="white"
      />
      <path
        d="M7.8512 18.3714C7.85283 18.3714 7.8544 18.372 7.85556 18.3732C7.85671 18.3744 7.85736 18.3759 7.85736 18.3776C7.85736 18.3792 7.85671 18.3808 7.85556 18.3819C7.8544 18.3831 7.85283 18.3837 7.8512 18.3837V18.3961C7.83887 18.3899 7.84503 18.3776 7.83887 18.3714C7.84503 18.3714 7.84503 18.3714 7.84503 18.3652L7.8512 18.3714Z"
        fill="#214063"
      />
      <path
        d="M7.65607 18.3525H7.66223C7.66223 18.3587 7.6684 18.371 7.66223 18.3772C7.65896 18.3772 7.65583 18.3759 7.65351 18.3736C7.6512 18.3713 7.6499 18.3681 7.6499 18.3649C7.65029 18.3601 7.6525 18.3557 7.65607 18.3525Z"
        fill="#214063"
      />
      <path
        d="M8.50496 18.2897C8.50799 18.2931 8.50967 18.2974 8.50967 18.302C8.50967 18.3065 8.50799 18.3109 8.50496 18.3143C8.50496 18.3176 8.50366 18.3207 8.50135 18.323C8.49903 18.3254 8.4959 18.3267 8.49263 18.3267C8.48646 18.3267 8.48646 18.3205 8.4803 18.3143C8.47413 18.3082 8.48646 18.302 8.4803 18.2958C8.47413 18.2897 8.48646 18.2835 8.49263 18.2897H8.49879C8.49879 18.2897 8.49879 18.2897 8.50496 18.2897Z"
        fill="#214063"
      />
      <path
        d="M7.78866 18.3896C7.78866 18.3959 7.79488 18.4083 7.78245 18.4083C7.77002 18.4083 7.77002 18.4021 7.77002 18.3959H7.78866V18.3896Z"
        fill="#214063"
      />
      <path
        d="M8.33002 18.3208C8.32373 18.3208 8.32373 18.3145 8.32373 18.3083V18.2957H8.33002C8.32835 18.2957 8.32675 18.2963 8.32557 18.2975C8.32439 18.2987 8.32373 18.3003 8.32373 18.302H8.33002C8.33631 18.2957 8.33002 18.2894 8.33002 18.2831V18.2705C8.33516 18.2779 8.33792 18.2867 8.33792 18.2957C8.33792 18.3047 8.33516 18.3134 8.33002 18.3208Z"
        fill="#214063"
      />
      <path
        d="M7.88332 18.5162C7.87669 18.5096 7.88332 18.5096 7.88332 18.5162V18.5162Z"
        fill="#214063"
      />
      <path
        d="M8.19085 18.6474C8.19701 18.6474 8.19085 18.6412 8.19085 18.6351C8.19701 18.6412 8.19085 18.6474 8.19085 18.6536H8.18468C8.17852 18.6412 8.18468 18.6351 8.19085 18.6289V18.6474Z"
        fill="#214063"
      />
      <path
        d="M7.80042 18.7231C7.80042 18.7247 7.79977 18.7263 7.79861 18.7274C7.79745 18.7286 7.79589 18.7293 7.79425 18.7293C7.79262 18.7293 7.79105 18.7286 7.78989 18.7274C7.78874 18.7263 7.78809 18.7247 7.78809 18.7231V18.7108C7.78809 18.7108 7.79425 18.7169 7.79425 18.7108C7.79344 18.7108 7.79264 18.7106 7.79189 18.7103C7.79114 18.71 7.79046 18.7095 7.78989 18.7089C7.78932 18.7084 7.78887 18.7077 7.78856 18.7069C7.78825 18.7062 7.78809 18.7054 7.78809 18.7046H7.80042C7.80042 18.7108 7.80658 18.7169 7.80042 18.7231Z"
        fill="#214063"
      />
      <path
        d="M8.05902 18.7171C8.05902 18.7233 8.05902 18.7356 8.04669 18.7356C8.04313 18.7324 8.04092 18.728 8.04053 18.7233V18.7109H8.05286L8.05902 18.7171Z"
        fill="#214063"
      />
      <path
        d="M8.05309 18.7292H8.0593C8.05309 18.7354 8.05309 18.7292 8.04688 18.7292C8.05047 18.726 8.0527 18.7216 8.05309 18.7168C8.05309 18.723 8.0593 18.7168 8.05309 18.7292Z"
        fill="white"
      />
      <path
        d="M7.7888 18.6667H7.78258C7.78093 18.6667 7.77935 18.6661 7.77819 18.6649C7.77702 18.6637 7.77637 18.6622 7.77637 18.6605C7.77637 18.6589 7.77702 18.6573 7.77819 18.6561C7.77935 18.655 7.78093 18.6543 7.78258 18.6543H7.7888C7.7888 18.6605 7.79501 18.6667 7.7888 18.6667Z"
        fill="#214063"
      />
      <path
        d="M8.07764 18.7795H8.08358V18.7676C8.08277 18.772 8.08071 18.7761 8.07764 18.7795Z"
        fill="#214063"
      />
      <path
        d="M7.41111 19.0756C7.4174 19.0819 7.4174 19.0693 7.4174 19.0693C7.4174 19.0693 7.41111 19.0756 7.4174 19.0819H7.42369C7.42369 19.0882 7.41111 19.0882 7.4174 19.1008H7.42369V19.1197C7.42369 19.126 7.4174 19.1322 7.41111 19.1385C7.40482 19.1448 7.40482 19.1448 7.41111 19.1511H7.39853C7.39769 19.1545 7.39557 19.1573 7.39262 19.1591C7.38967 19.1609 7.38614 19.1614 7.3828 19.1606C7.37946 19.1597 7.3766 19.1576 7.37483 19.1546C7.37306 19.1517 7.37253 19.1482 7.37337 19.1448L7.36078 19.1322C7.35449 19.126 7.35449 19.1197 7.36078 19.1197H7.35449C7.36078 19.1071 7.36707 19.1008 7.36707 19.0882H7.37337C7.37966 19.0882 7.37966 19.0756 7.38595 19.0756C7.39224 19.0756 7.39224 19.0882 7.39853 19.0819H7.40482C7.40761 19.0807 7.40985 19.0784 7.41111 19.0756Z"
        fill="#214063"
      />
      <path
        d="M8.02071 18.8239C8.01714 18.827 8.01493 18.8314 8.01454 18.8362C8.00221 18.8362 8.00838 18.8239 8.00838 18.8239L8.02071 18.8115V18.8239Z"
        fill="#214063"
      />
      <path
        d="M7.96407 18.8993C7.95791 18.9055 7.95174 18.9055 7.95174 18.8993C7.95174 18.8931 7.94557 18.8993 7.94557 18.8931C7.94557 18.887 7.93325 18.9055 7.92708 18.8993C7.92092 18.8931 7.95174 18.8685 7.95791 18.8623H7.96407C7.96732 18.8679 7.96903 18.8743 7.96903 18.8808C7.96903 18.8873 7.96732 18.8937 7.96407 18.8993Z"
        fill="#214063"
      />
      <path
        d="M7.32278 19.56V19.5726H7.32907C7.32907 19.5789 7.31649 19.5789 7.32278 19.5852H7.32907C7.31649 19.5852 7.32278 19.5977 7.3102 19.604C7.29762 19.6103 7.29133 19.6103 7.28503 19.6166C7.28503 19.615 7.28437 19.6134 7.28319 19.6122C7.28201 19.611 7.28041 19.6103 7.27875 19.6103L7.26616 19.5915V19.5789H7.24729C7.23471 19.5726 7.24729 19.5663 7.24729 19.5537H7.25987C7.25987 19.5663 7.27245 19.5537 7.27875 19.5537H7.32278C7.32278 19.5537 7.3102 19.56 7.32278 19.56Z"
        fill="#214063"
      />
      <path
        d="M7.6127 18.9437C7.6127 18.95 7.61899 18.9626 7.6127 18.9688L7.59383 18.9814C7.58125 18.9751 7.58125 18.9688 7.57496 18.9563C7.56867 18.9437 7.58125 18.9437 7.58754 18.9374L7.60012 18.9248C7.60012 18.9374 7.60641 18.9374 7.6127 18.9437Z"
        fill="#214063"
      />
      <path
        d="M7.83136 18.9812C7.83752 18.9935 7.81286 18.9874 7.81902 19.0058C7.82519 19.0243 7.80053 19.0182 7.79436 19.012C7.7882 19.0058 7.78203 18.9997 7.7882 18.9935V18.9812C7.79436 18.9874 7.79436 18.9812 7.79436 18.9812H7.82519C7.83135 18.975 7.82519 18.975 7.83136 18.9812Z"
        fill="#214063"
      />
      <path
        d="M7.62421 19.2332C7.62421 19.2332 7.61805 19.2394 7.62421 19.2394C7.61805 19.2455 7.63038 19.2579 7.61805 19.2579C7.60572 19.2579 7.60571 19.264 7.60571 19.2702C7.60093 19.2702 7.59621 19.2691 7.59193 19.2669C7.58765 19.2648 7.58393 19.2617 7.58105 19.2579V19.2455C7.58722 19.2517 7.58106 19.2394 7.58722 19.2394C7.59339 19.2394 7.58722 19.2332 7.59339 19.2332H7.61188C7.62421 19.227 7.61188 19.2332 7.62421 19.2332Z"
        fill="#214063"
      />
      <path
        d="M7.31663 19.2013H7.3042V19.1888C7.30585 19.1888 7.30743 19.1882 7.30859 19.187C7.30976 19.1858 7.31041 19.1843 7.31041 19.1826H7.32284L7.31663 19.2013Z"
        fill="#214063"
      />
      <path
        d="M7.11497 19.0065C7.10875 19.0065 7.10254 19.0065 7.10254 18.9941C7.10254 18.9817 7.10254 18.9879 7.10254 18.9879C7.10254 18.9879 7.12118 19.0003 7.11497 19.0065Z"
        fill="#214063"
      />
      <path
        d="M7.27903 19.39H7.28524C7.28524 19.3962 7.27903 19.3962 7.27282 19.3962C7.2666 19.3962 7.2666 19.39 7.2666 19.3838H7.27903V19.39Z"
        fill="#214063"
      />
      <path
        d="M7.22266 19.1886V19.1826C7.22266 19.1826 7.2286 19.1826 7.22266 19.1886Z"
        fill="#214063"
      />
      <path
        d="M7.22918 19.1895C7.22219 19.1965 7.22918 19.1825 7.22918 19.1895V19.1895Z"
        fill="white"
      />
      <path
        d="M7.09577 19.1823H7.10193C7.09577 19.1823 7.10193 19.1884 7.09577 19.1946H7.10193C7.09577 19.1946 7.10193 19.2007 7.09577 19.2007H7.10193C7.0896 19.2069 7.08344 19.2254 7.06494 19.2131V19.1946V19.1699H7.07727C7.08344 19.1699 7.07727 19.1699 7.07727 19.1761C7.07891 19.1761 7.08048 19.1754 7.08163 19.1743C7.08279 19.1731 7.08344 19.1716 7.08344 19.1699C7.08344 19.1761 7.0896 19.1761 7.09577 19.1823H7.10193C7.10193 19.1761 7.0896 19.1761 7.09577 19.1823Z"
        fill="#214063"
      />
      <path
        d="M7.18438 19.3523C7.17809 19.3586 7.18438 19.3586 7.18438 19.3586C7.18438 19.3649 7.19067 19.3586 7.18438 19.3586C7.18438 19.3523 7.18438 19.3712 7.17809 19.3712C7.1718 19.3712 7.18438 19.3712 7.18438 19.3775C7.18438 19.3837 7.17809 19.3712 7.17809 19.3775C7.17809 19.3837 7.15921 19.3837 7.15921 19.39H7.13405C7.13238 19.39 7.13078 19.3894 7.1296 19.3882C7.12842 19.387 7.12776 19.3854 7.12776 19.3837H7.12147C7.12147 19.3712 7.10889 19.3775 7.11518 19.3712C7.12147 19.3649 7.10889 19.3712 7.10889 19.3649H7.11518C7.1026 19.3586 7.11518 19.3523 7.10889 19.346C7.11056 19.346 7.11216 19.3453 7.11333 19.3442C7.11451 19.343 7.11518 19.3414 7.11518 19.3397H7.10889C7.11518 19.3397 7.11518 19.3334 7.11518 19.3271C7.11518 19.3208 7.13405 19.3334 7.12776 19.3208C7.12147 19.3083 7.14034 19.3271 7.14663 19.3208C7.14663 19.3208 7.14034 19.3271 7.14663 19.3271H7.15292C7.15292 19.3271 7.15292 19.3397 7.15921 19.3397H7.1655V19.3523H7.1718V19.3649H7.18438C7.17809 19.3397 7.18438 19.346 7.18438 19.3523Z"
        fill="#214063"
      />
      <path
        d="M6.93916 19.3151H6.94545V19.334C6.93916 19.334 6.94545 19.3465 6.93916 19.3465C6.93287 19.3465 6.93916 19.3591 6.93287 19.3528C6.93287 19.3537 6.93303 19.3545 6.93335 19.3552C6.93367 19.356 6.93413 19.3567 6.93471 19.3573C6.9353 19.3579 6.93599 19.3583 6.93675 19.3586C6.93752 19.359 6.93834 19.3591 6.93916 19.3591H6.914C6.90771 19.3591 6.90771 19.3465 6.90142 19.3528L6.88884 19.3403V19.3214C6.88884 19.3151 6.89513 19.3151 6.88884 19.3088C6.88255 19.3025 6.88884 19.3025 6.89513 19.2962H6.90142V19.2836C6.90142 19.2828 6.90158 19.282 6.9019 19.2812C6.90221 19.2805 6.90268 19.2798 6.90326 19.2792C6.90384 19.2786 6.90454 19.2781 6.9053 19.2778C6.90606 19.2775 6.90688 19.2773 6.90771 19.2773C6.914 19.2836 6.914 19.2773 6.92029 19.2773C6.92658 19.2773 6.914 19.2836 6.92029 19.2836H6.92658C6.93287 19.2899 6.93287 19.2773 6.93287 19.2773C6.93287 19.2773 6.94545 19.3088 6.93916 19.3151Z"
        fill="#214063"
      />
      <path
        d="M7.15243 19.5909C7.15085 19.5909 7.14934 19.5903 7.14823 19.5892C7.14711 19.588 7.14648 19.5865 7.14648 19.585H7.15837L7.15243 19.5909Z"
        fill="#214063"
      />
      <path
        d="M7.19051 19.8107H7.18457C7.18457 19.8048 7.19051 19.8048 7.19051 19.7988H7.19646C7.19646 19.8048 7.19645 19.8107 7.19051 19.8107Z"
        fill="#214063"
      />
      <path
        d="M6.93905 19.4211H6.93311V19.4092H6.93905C6.93905 19.4092 6.9331 19.4151 6.93905 19.4151C6.93905 19.4151 6.94499 19.4151 6.93905 19.4211Z"
        fill="#214063"
      />
      <path
        d="M6.99557 19.598C7.00174 19.598 7.00174 19.6041 7.00174 19.6103L6.98324 19.6226L6.96475 19.6041C6.95858 19.6041 6.97091 19.598 6.95858 19.598C6.94625 19.598 6.97091 19.5918 6.96475 19.5918H6.99557V19.598Z"
        fill="#214063"
      />
      <path
        d="M6.96414 19.5727C6.96414 19.579 6.95785 19.579 6.95785 19.5853C6.95156 19.579 6.95156 19.5853 6.95156 19.5853C6.95156 19.579 6.95156 19.5853 6.94527 19.579C6.9436 19.579 6.942 19.5784 6.94082 19.5772C6.93964 19.576 6.93898 19.5744 6.93898 19.5727C6.93269 19.5853 6.9264 19.5727 6.92011 19.5727C6.92011 19.5719 6.91994 19.5711 6.91963 19.5703C6.91931 19.5696 6.91885 19.5689 6.91826 19.5683C6.91768 19.5677 6.91699 19.5672 6.91622 19.5669C6.91546 19.5666 6.91464 19.5664 6.91381 19.5664C6.91381 19.5539 6.90123 19.5539 6.90752 19.535C6.91381 19.535 6.90752 19.5287 6.90752 19.5287H6.91381C6.91381 19.5224 6.9264 19.5224 6.9264 19.5161H6.93898C6.94527 19.5224 6.94527 19.5287 6.95156 19.5287C6.96414 19.5539 6.95785 19.5727 6.96414 19.5727Z"
        fill="#214063"
      />
      <path
        d="M6.83221 19.5414C6.83221 19.5431 6.83288 19.5447 6.83406 19.5459C6.83523 19.5471 6.83683 19.5477 6.8385 19.5477C6.84479 19.554 6.84479 19.5477 6.84479 19.5477C6.84479 19.5494 6.84413 19.551 6.84295 19.5522C6.84177 19.5534 6.84017 19.554 6.8385 19.554H6.84479C6.8385 19.554 6.83221 19.5603 6.8385 19.5666C6.83221 19.5729 6.84479 19.5792 6.83221 19.5792C6.83449 19.5817 6.83622 19.5847 6.8373 19.588C6.83838 19.5912 6.83879 19.5946 6.8385 19.5981C6.83221 19.5981 6.8385 19.6043 6.83221 19.6043C6.83221 19.6106 6.82592 19.6043 6.82592 19.6106H6.81334C6.81334 19.609 6.81268 19.6074 6.8115 19.6062C6.81032 19.605 6.80872 19.6043 6.80705 19.6043C6.80076 19.6043 6.80705 19.6106 6.80705 19.6169C6.80705 19.6232 6.80076 19.5981 6.79447 19.6043H6.7693C6.7693 19.5981 6.7693 19.5981 6.76301 19.5981V19.5855C6.75672 19.5918 6.76301 19.5792 6.75672 19.5792C6.75043 19.5792 6.75043 19.5729 6.75043 19.5729C6.75043 19.5666 6.75043 19.5666 6.74414 19.5603C6.74414 19.5603 6.75043 19.554 6.74414 19.554C6.74414 19.5523 6.7448 19.5507 6.74598 19.5496C6.74716 19.5484 6.74876 19.5477 6.75043 19.5477V19.5351H6.75672C6.76301 19.5289 6.75043 19.51 6.76301 19.51H6.7693C6.7756 19.51 6.7756 19.5037 6.78189 19.4974C6.78818 19.4911 6.79447 19.51 6.79447 19.5037C6.79447 19.4974 6.79447 19.4974 6.80076 19.4974C6.80705 19.4974 6.79447 19.51 6.80076 19.51H6.80705V19.5226H6.82592C6.82592 19.5163 6.82592 19.5289 6.83221 19.5289V19.5414Z"
        fill="#214063"
      />
      <path
        d="M7.53653 19.4469C7.53037 19.4469 7.53037 19.4592 7.51804 19.4531C7.50571 19.4469 7.50571 19.4346 7.51804 19.4346H7.53037C7.53037 19.4407 7.53653 19.4346 7.53653 19.4469C7.53653 19.4592 7.53037 19.4407 7.53653 19.4469Z"
        fill="#214063"
      />
      <path
        d="M7.48633 19.4777L7.49227 19.4658H7.49821L7.48633 19.4777Z"
        fill="#214063"
      />
      <path
        d="M7.48679 19.4909H7.49308V19.5035H7.49938L7.47421 19.5286C7.46792 19.5286 7.45534 19.5224 7.45534 19.5349H7.44905L7.43018 19.5224C7.43647 19.5161 7.43018 19.5161 7.43018 19.5098C7.43018 19.5035 7.43647 19.4972 7.43018 19.4972H7.43647C7.43647 19.4909 7.43018 19.4909 7.43018 19.4846H7.43647C7.43647 19.4783 7.44276 19.4783 7.44905 19.472C7.45534 19.4657 7.45534 19.4594 7.45534 19.4532C7.45534 19.4469 7.46163 19.472 7.46792 19.472C7.4805 19.472 7.46792 19.4846 7.4805 19.4846V19.4657C7.47421 19.472 7.47421 19.4846 7.48679 19.4909Z"
        fill="#214063"
      />
      <path
        d="M7.41113 19.4722L7.41809 19.4791L7.41113 19.4722Z"
        fill="#214063"
      />
      <path
        d="M12.1612 19.4098L12.1543 19.4028H12.1612V19.4098Z"
        fill="white"
      />
      <path
        d="M13.6573 19.271C13.6573 19.2772 13.6573 19.2833 13.6634 19.2833C13.6696 19.2833 13.6511 19.2957 13.6449 19.2957C13.6388 19.2957 13.6326 19.2772 13.6388 19.271H13.6573Z"
        fill="#214063"
      />
      <path
        d="M13.7081 19.2834H13.6957C13.6921 19.2802 13.6898 19.2758 13.6895 19.271C13.6957 19.271 13.7143 19.271 13.7081 19.2834Z"
        fill="#214063"
      />
      <path
        d="M12.242 17.7547H12.2358C12.2358 17.7547 12.2482 17.7485 12.242 17.7547Z"
        fill="#214063"
      />
      <path
        d="M12.2798 17.7607C12.2798 17.7666 12.2798 17.7666 12.2739 17.7666C12.2681 17.7666 12.2681 17.7607 12.2739 17.7607H12.2798Z"
        fill="#214063"
      />
      <path
        d="M12.9532 18.8423H12.947C12.9443 18.8377 12.9429 18.8323 12.9429 18.8269C12.9429 18.8215 12.9443 18.8162 12.947 18.8115C12.947 18.8239 12.9593 18.8362 12.9532 18.8423Z"
        fill="#214063"
      />
      <path
        d="M12.2795 17.8552C12.2733 17.8614 12.267 17.8676 12.2608 17.8614C12.2605 17.858 12.2609 17.8547 12.262 17.8515C12.2631 17.8482 12.2648 17.8453 12.267 17.8428C12.2703 17.8428 12.2735 17.8441 12.2758 17.8464C12.2782 17.8487 12.2795 17.8519 12.2795 17.8552Z"
        fill="#214063"
      />
      <path
        d="M12.4873 17.3076C12.4996 17.3138 12.5181 17.3261 12.512 17.3446C12.5058 17.3631 12.5058 17.3384 12.4996 17.3384C12.4935 17.3384 12.4935 17.3138 12.4873 17.3076Z"
        fill="#214063"
      />
      <path
        d="M13.3249 19.9628H13.3312V19.9753C13.3438 19.9628 13.3375 19.9879 13.3501 19.9879C13.3506 19.9938 13.3497 19.9997 13.3475 20.0051C13.3454 20.0106 13.3419 20.0155 13.3375 20.0194H13.3124C13.3124 20.0068 13.2872 20.0194 13.2935 20.0005C13.2998 19.9816 13.2935 19.9879 13.2935 19.9753C13.2935 19.9628 13.2998 19.9753 13.2998 19.969C13.3061 19.9753 13.3124 19.969 13.3187 19.9628C13.3249 19.9565 13.3249 19.9628 13.3249 19.9628Z"
        fill="#214063"
      />
      <path
        d="M12.5319 17.4147C12.5323 17.4194 12.5345 17.4238 12.538 17.427C12.5319 17.4332 12.5257 17.4208 12.5195 17.4147V17.4023C12.5228 17.4023 12.5259 17.4036 12.5282 17.406C12.5306 17.4083 12.5319 17.4114 12.5319 17.4147Z"
        fill="#214063"
      />
      <path
        d="M12.5883 17.4394C12.576 17.4333 12.576 17.4209 12.5698 17.4086C12.5637 17.3963 12.5883 17.4271 12.5883 17.4394Z"
        fill="#214063"
      />
      <path
        d="M12.5827 17.4347C12.5827 17.4347 12.5757 17.4347 12.5827 17.4277V17.4347Z"
        fill="white"
      />
      <path
        d="M12.7638 18.0876H12.752C12.7579 18.0876 12.7579 18.0817 12.7638 18.0876Z"
        fill="#214063"
      />
      <path
        d="M13.0787 18.0564C13.079 18.0597 13.0786 18.0631 13.0775 18.0663C13.0764 18.0694 13.0748 18.0724 13.0725 18.0749H13.054C13.0479 18.0687 13.0602 18.0625 13.054 18.0564C13.0479 18.0502 13.0725 18.0502 13.0787 18.0564Z"
        fill="#214063"
      />
      <path
        d="M13.004 18.0881C13.004 18.0881 12.9971 18.095 12.9971 18.0881C12.9971 18.0811 12.9971 18.0881 13.004 18.0881Z"
        fill="#214063"
      />
      <path
        d="M12.8389 18.2204H12.8273C12.8215 18.2204 12.8331 18.2146 12.8389 18.2204Z"
        fill="#214063"
      />
      <path
        d="M12.5636 17.7618L12.5566 17.7549L12.5636 17.7618Z"
        fill="#214063"
      />
      <path
        d="M12.5754 17.817C12.5754 17.8231 12.5816 17.8293 12.5754 17.8293C12.5693 17.8293 12.5569 17.8108 12.5508 17.8046H12.5569C12.5446 17.7923 12.5631 17.7923 12.5508 17.7861C12.5625 17.793 12.5713 17.804 12.5754 17.817Z"
        fill="#214063"
      />
      <path
        d="M13.0097 18.1636C13.0155 18.1694 13.0097 18.1694 13.0097 18.1752C13.0097 18.181 13.0039 18.1694 13.0039 18.1636H13.0097Z"
        fill="#214063"
      />
      <path
        d="M12.8898 18.2701C12.8882 18.2701 12.8867 18.2707 12.8856 18.2718C12.8845 18.273 12.8839 18.2745 12.8839 18.276C12.8835 18.2715 12.8814 18.2672 12.8779 18.2642C12.8839 18.2642 12.8898 18.2642 12.8898 18.2701Z"
        fill="#214063"
      />
      <path
        d="M12.9596 18.2454H12.9534C12.9534 18.2454 12.9473 18.2393 12.9534 18.2393C12.9596 18.2393 12.9534 18.2454 12.9596 18.2454Z"
        fill="#214063"
      />
      <path
        d="M12.9024 18.2769C12.9024 18.2831 12.9148 18.2955 12.9024 18.2955C12.89 18.2955 12.89 18.2831 12.8962 18.2769H12.9024Z"
        fill="#214063"
      />
      <path
        d="M12.6516 17.8994H12.6704C12.6767 17.9246 12.6956 17.9435 12.683 17.9686H12.6704C12.6641 17.9623 12.6641 17.956 12.6579 17.956C12.6516 17.956 12.639 17.9372 12.6453 17.9246V17.8994H12.6516Z"
        fill="#214063"
      />
      <path
        d="M12.594 17.993C12.5755 18.0054 12.5755 17.9807 12.5693 17.9745V17.9561C12.5764 17.9594 12.5825 17.9646 12.5868 17.9711C12.5911 17.9776 12.5936 17.9852 12.594 17.993Z"
        fill="#214063"
      />
      <path
        d="M12.5876 17.9806H12.5757L12.5816 17.9746L12.5757 17.9806H12.5876Z"
        fill="white"
      />
      <path
        d="M12.9725 19.2581H12.9662C12.9474 19.2455 12.9536 19.2141 12.9536 19.1952V19.1826C12.9628 19.1926 12.9693 19.2048 12.9726 19.218C12.9759 19.2312 12.9759 19.2449 12.9725 19.2581Z"
        fill="#214063"
      />
      <path
        d="M12.6135 18.088V18.1006C12.6073 18.1006 12.601 18.1006 12.601 18.0943C12.601 18.088 12.5884 18.0755 12.5884 18.0629H12.5947V18.0503C12.6056 18.06 12.6124 18.0735 12.6135 18.088Z"
        fill="#214063"
      />
      <path
        d="M12.6071 18.1256C12.6132 18.1256 12.6194 18.1441 12.6194 18.1503C12.6194 18.1564 12.6194 18.1626 12.6132 18.1626L12.5947 18.1379C12.6009 18.1318 12.5947 18.1256 12.5947 18.1194C12.5947 18.1133 12.6009 18.1318 12.6071 18.1256Z"
        fill="#214063"
      />
      <path
        d="M12.6144 18.1318L12.6074 18.1388L12.6144 18.1318Z"
        fill="white"
      />
      <path
        d="M12.3743 18.377C12.3743 18.3778 12.3741 18.3786 12.3738 18.3793C12.3735 18.3801 12.373 18.3807 12.3725 18.3813C12.3719 18.3819 12.3712 18.3823 12.3705 18.3827C12.3697 18.383 12.3689 18.3831 12.3681 18.3831C12.3558 18.3831 12.3558 18.3708 12.3558 18.3646C12.3558 18.3585 12.3496 18.3585 12.3496 18.3523C12.3496 18.3461 12.3681 18.3646 12.3743 18.377Z"
        fill="#214063"
      />
      <path
        d="M13.4309 18.0505C13.4183 18.0631 13.412 18.0442 13.4057 18.0316C13.3994 18.019 13.4057 17.9939 13.3994 17.975V17.9624C13.4057 17.9876 13.4435 18.019 13.4309 18.0505Z"
        fill="#214063"
      />
      <path
        d="M12.6696 18.541C12.6696 18.5426 12.6689 18.5442 12.6677 18.5453C12.6666 18.5465 12.665 18.5471 12.6634 18.5471C12.6618 18.5471 12.6602 18.5465 12.659 18.5453C12.6579 18.5442 12.6572 18.5426 12.6572 18.541V18.5225C12.661 18.5238 12.6643 18.5263 12.6665 18.5296C12.6687 18.533 12.6698 18.537 12.6696 18.541Z"
        fill="#214063"
      />
      <path
        d="M12.6144 18.4161L12.6074 18.4092H12.6144V18.4161Z"
        fill="white"
      />
      <path
        d="M12.72 18.6793H12.7262C12.7262 18.6777 12.7255 18.6761 12.7244 18.675C12.7232 18.6738 12.7217 18.6732 12.72 18.6732C12.7324 18.6732 12.7324 18.6793 12.7447 18.6917C12.757 18.704 12.7447 18.704 12.7324 18.7101C12.72 18.7163 12.7262 18.704 12.72 18.704C12.7139 18.704 12.72 18.6917 12.7139 18.6855V18.667L12.72 18.6793Z"
        fill="#214063"
      />
      <path
        d="M13.2877 18.2462C13.2859 18.2462 13.2841 18.2455 13.2828 18.2442C13.2815 18.2429 13.2808 18.2411 13.2808 18.2393L13.2877 18.2462Z"
        fill="#214063"
      />
      <path
        d="M13.2866 18.2511C13.2882 18.2511 13.2897 18.2505 13.2908 18.2494C13.2919 18.2483 13.2926 18.2468 13.2926 18.2452C13.2926 18.2436 13.2919 18.2421 13.2908 18.241C13.2897 18.2399 13.2882 18.2393 13.2866 18.2393V18.2511Z"
        fill="#214063"
      />
      <path
        d="M12.9409 18.5469C12.9472 18.5657 12.9661 18.5783 12.9598 18.5972C12.9535 18.6161 12.9409 18.6035 12.9409 18.5972C12.9377 18.5827 12.9377 18.5677 12.9409 18.5532V18.5469Z"
        fill="#214063"
      />
      <path
        d="M12.7137 18.805C12.7137 18.811 12.7198 18.8171 12.7137 18.8232H12.7015C12.6993 18.8208 12.6976 18.8179 12.6966 18.8147C12.6955 18.8116 12.6951 18.8083 12.6954 18.805H12.7015C12.7076 18.805 12.7076 18.7989 12.7137 18.805Z"
        fill="#214063"
      />
      <path
        d="M13.1726 18.5223C13.1735 18.531 13.1713 18.5397 13.1664 18.5469H13.1541C13.1541 18.5346 13.1479 18.5284 13.1541 18.5223C13.1603 18.5161 13.1664 18.5223 13.1726 18.5223Z"
        fill="#214063"
      />
      <path
        d="M12.6826 18.8429C12.6843 18.8429 12.6858 18.8422 12.687 18.841C12.6882 18.8399 12.6888 18.8383 12.6888 18.8366C12.6852 18.8335 12.683 18.829 12.6826 18.8242V18.8429Z"
        fill="#214063"
      />
      <path
        d="M13.5011 18.4087C13.5033 18.4112 13.505 18.4141 13.5061 18.4173C13.5071 18.4205 13.5075 18.4238 13.5073 18.4272C13.5011 18.4333 13.4888 18.4333 13.4888 18.4272C13.4888 18.421 13.4949 18.3963 13.5011 18.4087Z"
        fill="#214063"
      />
      <path
        d="M13.362 18.4911C13.3636 18.4911 13.3652 18.4904 13.3664 18.4893C13.3676 18.4881 13.3683 18.4865 13.3683 18.4848C13.3745 18.4848 13.3683 18.4911 13.3683 18.4974C13.3758 18.5031 13.3816 18.5109 13.385 18.5198C13.3883 18.5287 13.3891 18.5384 13.3871 18.5477C13.3808 18.554 13.3683 18.5477 13.3683 18.5477L13.3557 18.5163C13.3548 18.5034 13.3569 18.4904 13.362 18.4785V18.4911Z"
        fill="#214063"
      />
      <path
        d="M13.1105 18.6162C13.1088 18.6162 13.1073 18.6169 13.1061 18.618C13.105 18.6192 13.1043 18.6207 13.1043 18.6224H13.0981C13.0981 18.6285 13.0981 18.6347 13.1043 18.6347C13.1105 18.6347 13.1166 18.6285 13.1166 18.6224C13.1192 18.6241 13.1213 18.6264 13.1227 18.629C13.1242 18.6317 13.1249 18.6347 13.1249 18.6378C13.1249 18.6408 13.1242 18.6438 13.1227 18.6465C13.1213 18.6492 13.1192 18.6515 13.1166 18.6532H13.1043C13.1043 18.647 13.0981 18.6409 13.0981 18.6347C13.0981 18.6347 13.0981 18.6285 13.1043 18.6347V18.6224C13.1043 18.6162 13.1043 18.6162 13.1105 18.6162Z"
        fill="#214063"
      />
      <path
        d="M12.519 18.9868C12.519 18.9885 12.5183 18.99 12.5172 18.9912C12.516 18.9923 12.5145 18.993 12.5128 18.993C12.5112 18.993 12.5096 18.9923 12.5085 18.9912C12.5073 18.99 12.5067 18.9885 12.5067 18.9868C12.5005 18.9807 12.5067 18.9683 12.5005 18.9622C12.4943 18.956 12.519 18.9745 12.519 18.9868Z"
        fill="#214063"
      />
      <path
        d="M13.1163 18.6289C13.1163 18.6348 13.1104 18.6348 13.1104 18.6408H13.1163V18.6289Z"
        fill="white"
      />
      <path
        d="M12.8398 19.7357H12.8461C12.8524 19.7357 12.8398 19.7608 12.8587 19.7545C12.8775 19.7483 12.8587 19.7923 12.8398 19.8049H12.8461C12.8524 19.8175 12.865 19.83 12.8587 19.8363H12.8461C12.8209 19.8237 12.8524 19.7923 12.8209 19.7797C12.7895 19.7671 12.8084 19.7545 12.8084 19.742V19.7294C12.8146 19.7357 12.8209 19.7294 12.8272 19.7294H12.8335V19.7168C12.8332 19.7202 12.8336 19.7236 12.8347 19.7269C12.8358 19.7301 12.8375 19.7331 12.8398 19.7357Z"
        fill="#214063"
      />
      <path
        d="M12.7079 18.931C12.7079 18.9371 12.7141 18.9495 12.7079 18.9556C12.7018 18.9618 12.6956 18.9495 12.6895 18.9433C12.6911 18.9433 12.6927 18.9426 12.6938 18.9415C12.695 18.9403 12.6956 18.9388 12.6956 18.9371C12.6956 18.9355 12.695 18.9339 12.6938 18.9328C12.6927 18.9316 12.6911 18.931 12.6895 18.931C12.6956 18.931 12.7079 18.9248 12.7079 18.931Z"
        fill="#214063"
      />
      <path
        d="M13.3431 18.61C13.3469 18.6128 13.35 18.6166 13.3522 18.6208C13.3543 18.6251 13.3554 18.6298 13.3554 18.6346H13.3492C13.3369 18.6346 13.3369 18.6223 13.3369 18.61C13.3369 18.5976 13.3431 18.61 13.3431 18.61Z"
        fill="#214063"
      />
      <path
        d="M12.6572 19.0316C12.6572 19.0254 12.6634 19.0316 12.6634 19.0316C12.6634 19.0316 12.6759 19.0378 12.6697 19.044H12.6572V19.0316Z"
        fill="#214063"
      />
      <path
        d="M12.6642 19.0317V19.0387H12.6572V19.0317H12.6642Z"
        fill="white"
      />
      <path
        d="M12.7202 19.1445C12.7219 19.1452 12.7235 19.1462 12.7249 19.1475C12.7262 19.1489 12.7272 19.1505 12.7278 19.1523C12.7284 19.1541 12.7285 19.156 12.7283 19.1578C12.728 19.1597 12.7274 19.1615 12.7263 19.163C12.7263 19.163 12.7263 19.1754 12.7202 19.1754C12.714 19.1754 12.7078 19.163 12.7017 19.1569C12.7078 19.1507 12.7017 19.1507 12.7078 19.1445H12.7202Z"
        fill="#214063"
      />
      <path
        d="M12.4935 19.2207C12.4996 19.233 12.512 19.2392 12.5058 19.2515C12.4996 19.2639 12.4935 19.2515 12.4873 19.2454V19.2207H12.4935Z"
        fill="#214063"
      />
      <path
        d="M13.4309 18.749C13.4371 18.749 13.4432 18.7614 13.4432 18.7737C13.4432 18.786 13.4432 18.786 13.4309 18.7922H13.4124C13.4127 18.7888 13.4123 18.7855 13.4112 18.7823C13.4102 18.7791 13.4085 18.7762 13.4062 18.7737C13.4247 18.7737 13.4062 18.7552 13.4186 18.7614H13.4309V18.749Z"
        fill="#214063"
      />
      <path
        d="M13.2296 18.8302H13.2236V18.8184C13.2236 18.8184 13.2236 18.8302 13.2296 18.8302Z"
        fill="#214063"
      />
      <path
        d="M12.657 19.2014C12.657 19.2137 12.6693 19.2261 12.657 19.2384C12.6447 19.2507 12.6447 19.2322 12.6385 19.2261C12.6323 19.2199 12.6323 19.2199 12.6323 19.2137H12.6447C12.6447 19.2014 12.657 19.1891 12.657 19.2014Z"
        fill="#214063"
      />
      <path
        d="M13.2361 18.8612H13.23V18.8427H13.2361C13.23 18.8427 13.2361 18.8489 13.2361 18.8489C13.2361 18.8489 13.2423 18.855 13.2423 18.8489C13.2423 18.8427 13.2423 18.8365 13.2361 18.8365H13.2423V18.8242C13.2361 18.8365 13.2485 18.8489 13.2361 18.8612Z"
        fill="#214063"
      />
      <path
        d="M12.8272 19.2951H12.8213C12.8213 19.301 12.8272 19.2951 12.8272 19.2892C12.8272 19.2834 12.8272 19.2951 12.8272 19.2951Z"
        fill="#214063"
      />
      <path
        d="M13.2424 19.277H13.2486C13.2547 19.2708 13.2486 19.2708 13.2424 19.2646C13.2486 19.2708 13.2486 19.277 13.2547 19.2893H13.2424C13.2363 19.2831 13.2363 19.277 13.2424 19.2646V19.277Z"
        fill="#214063"
      />
      <path
        d="M13.2368 19.2832H13.2438V19.2902L13.2368 19.2832Z"
        fill="white"
      />
      <path
        d="M12.8709 19.5911C12.8709 19.5972 12.8585 19.5972 12.8524 19.5972C12.8462 19.5972 12.8462 19.5911 12.8462 19.5849C12.8462 19.5787 12.8585 19.5849 12.8524 19.5787H12.8462C12.8478 19.5787 12.8494 19.5781 12.8506 19.5769C12.8517 19.5758 12.8524 19.5742 12.8524 19.5726C12.8524 19.5709 12.8517 19.5694 12.8506 19.5682C12.8494 19.5671 12.8478 19.5664 12.8462 19.5664H12.8585C12.8585 19.5726 12.8709 19.5787 12.8709 19.5911Z"
        fill="#214063"
      />
      <path
        d="M13.1411 19.4215C13.1411 19.4277 13.1534 19.44 13.1411 19.4462C13.1287 19.4523 13.1287 19.4462 13.1226 19.44V19.4215V19.4092H13.1287C13.1349 19.4215 13.1349 19.4215 13.1411 19.4215Z"
        fill="#214063"
      />
      <path
        d="M13.1413 19.4343C13.1413 19.4405 13.1351 19.4343 13.1351 19.4343C13.1351 19.4343 13.1289 19.4281 13.1289 19.4219C13.1289 19.4157 13.1351 19.4219 13.1413 19.4343Z"
        fill="white"
      />
      <path
        d="M12.8147 19.5349H12.8085C12.8022 19.5349 12.8022 19.5287 12.8022 19.5225C12.8022 19.5241 12.8029 19.5257 12.8041 19.5269C12.8052 19.528 12.8068 19.5287 12.8085 19.5287C12.8147 19.5225 12.8209 19.5287 12.8147 19.5349Z"
        fill="#214063"
      />
      <path
        d="M13.1984 19.4714H13.186C13.1922 19.4653 13.186 19.4653 13.186 19.4653H13.1984V19.4468C13.1984 19.4591 13.2045 19.4653 13.1984 19.4714Z"
        fill="#214063"
      />
      <path
        d="M12.7329 20.2836C12.7455 20.2836 12.7392 20.271 12.7392 20.271C12.7392 20.271 12.7392 20.2773 12.7455 20.2836C12.7518 20.2899 12.7518 20.271 12.7455 20.271C12.7518 20.2773 12.7455 20.2962 12.7581 20.3025H12.7707C12.7707 20.315 12.777 20.315 12.7833 20.3276C12.7896 20.3339 12.7833 20.3465 12.7833 20.3528C12.7833 20.3591 12.7896 20.3717 12.7959 20.3717C12.8021 20.3717 12.7833 20.3779 12.7896 20.3842C12.7867 20.3906 12.7824 20.3962 12.7769 20.4006C12.7714 20.405 12.765 20.408 12.7581 20.4094H12.7392C12.7329 20.4094 12.7329 20.4031 12.7267 20.4094C12.7204 20.4157 12.7267 20.3968 12.7204 20.3968C12.717 20.3968 12.7138 20.3955 12.7115 20.3931C12.7091 20.3908 12.7078 20.3876 12.7078 20.3842H12.7015C12.7002 20.3709 12.6959 20.3579 12.6889 20.3465H12.6826C12.6889 20.3465 12.6952 20.3528 12.7015 20.3465V20.3339H12.7078C12.7141 20.3276 12.7015 20.3213 12.7078 20.315C12.7141 20.3087 12.7204 20.3213 12.7267 20.315V20.2962C12.7204 20.271 12.7267 20.2836 12.7329 20.2836Z"
        fill="#214063"
      />
      <path
        d="M13.1671 19.5599C13.1671 19.5583 13.1665 19.5567 13.1653 19.5556C13.1642 19.5544 13.1626 19.5537 13.161 19.5537C13.1593 19.5537 13.1577 19.5544 13.1566 19.5556C13.1554 19.5567 13.1548 19.5583 13.1548 19.5599C13.1548 19.5615 13.1554 19.5631 13.1566 19.5643C13.1577 19.5654 13.1593 19.5661 13.161 19.5661C13.1671 19.5661 13.1609 19.5661 13.1671 19.5599C13.1733 19.5537 13.1671 19.5722 13.1671 19.5784C13.1671 19.5846 13.1548 19.5722 13.1548 19.5661C13.1548 19.5599 13.161 19.5537 13.161 19.5476C13.161 19.5414 13.1671 19.5537 13.1671 19.5599Z"
        fill="#214063"
      />
      <path
        d="M13.1545 19.6667C13.1545 19.6729 13.1482 19.6855 13.1419 19.6792C13.1356 19.6729 13.1356 19.6792 13.1293 19.6792C13.123 19.6792 13.1293 19.6981 13.1167 19.6918C13.1041 19.6855 13.1167 19.6478 13.123 19.6289H13.1293C13.1335 19.6297 13.1374 19.6312 13.141 19.6336C13.1445 19.6359 13.1476 19.6389 13.1499 19.6424C13.1523 19.6459 13.1539 19.6499 13.1547 19.6541C13.1554 19.6582 13.1554 19.6625 13.1545 19.6667Z"
        fill="#214063"
      />
      <path
        d="M13.0918 20.8057L13.1044 20.8182C13.1044 20.8245 13.1044 20.8308 13.1107 20.8308C13.1107 20.8497 13.1233 20.8497 13.117 20.8623C13.1107 20.8749 13.1107 20.8874 13.1107 20.9C13.1107 20.9126 13.1044 20.9 13.1044 20.9063H13.073C13.073 20.9 13.0667 20.9 13.0604 20.8937L13.0415 20.9063C13.0289 20.9126 13.0289 20.8937 13.0163 20.8937C13.0038 20.8937 13.0163 20.8749 13.0163 20.8686C13.0226 20.8749 13.0226 20.856 13.0289 20.8497C13.0289 20.856 13.0289 20.856 13.0352 20.856H13.0541C13.0541 20.8497 13.0541 20.8434 13.0604 20.8497V20.8308H13.073C13.0855 20.7994 13.0855 20.812 13.0918 20.8057Z"
        fill="#214063"
      />
      <path
        d="M12.8215 19.9688H12.8278C12.8278 19.975 12.8467 19.9813 12.8467 19.9939C12.8477 20.0048 12.8455 20.0157 12.8404 20.0254L12.8027 20.0128C12.809 20.0065 12.7964 19.9939 12.7964 19.9876H12.8027V19.9688H12.8215Z"
        fill="#214063"
      />
      <path
        d="M13.0726 19.7864H13.0664C13.0726 19.7864 13.0787 19.7803 13.0726 19.7803C13.0664 19.7803 13.0787 19.7864 13.0726 19.7864Z"
        fill="#214063"
      />
      <path
        d="M13.0725 19.8432H13.0788C13.0913 19.8558 13.0599 19.8621 13.0788 19.881C13.0976 19.8998 13.0788 19.8998 13.0662 19.9061C13.0536 19.9124 13.0473 19.8998 13.041 19.8872V19.8747C13.0536 19.8747 13.041 19.8621 13.0473 19.8558C13.0599 19.8495 13.0536 19.8432 13.0599 19.8369H13.0725V19.8432Z"
        fill="#214063"
      />
      <path
        d="M13.0604 20.2523C13.0666 20.246 13.0666 20.2586 13.0666 20.2523C13.0666 20.246 13.0792 20.2586 13.0792 20.2649C13.0729 20.2775 13.0981 20.2712 13.0855 20.29C13.0729 20.3089 13.0792 20.3026 13.0792 20.3089C13.0792 20.3152 13.0666 20.3215 13.0541 20.3152L13.0352 20.3026C13.0415 20.3026 13.0226 20.2963 13.0352 20.29V20.2775H13.0415V20.2649H13.0478V20.2523C13.0478 20.254 13.0484 20.2556 13.0496 20.2568C13.0508 20.2579 13.0524 20.2586 13.0541 20.2586C13.0541 20.246 13.0541 20.2649 13.0604 20.2523Z"
        fill="#214063"
      />
      <path
        d="M12.7579 20.5035H12.7641C12.7657 20.5035 12.7673 20.5042 12.7685 20.5053C12.7696 20.5065 12.7703 20.5081 12.7703 20.5097C12.7703 20.5159 12.7703 20.5282 12.7641 20.5282H12.7456C12.7472 20.5282 12.7488 20.5276 12.75 20.5264C12.7511 20.5252 12.7518 20.5237 12.7518 20.522C12.7518 20.5204 12.7511 20.5188 12.75 20.5177C12.7488 20.5165 12.7472 20.5159 12.7456 20.5159V20.5035L12.7579 20.4912C12.7518 20.4974 12.7579 20.5035 12.7579 20.5035Z"
        fill="#214063"
      />
      <path
        d="M12.4054 20.5162C12.4054 20.5224 12.3991 20.5286 12.3867 20.5224V20.5099C12.3929 20.5037 12.4116 20.5037 12.4054 20.5162Z"
        fill="#214063"
      />
      <path
        d="M12.9028 20.7051H12.9089C12.9089 20.7112 12.9089 20.7236 12.9028 20.7236C12.8966 20.7236 12.8966 20.7297 12.8904 20.7236C12.8843 20.7174 12.8904 20.7174 12.8843 20.7112L12.9028 20.7051Z"
        fill="#214063"
      />
      <path
        d="M12.6759 20.5728C12.6793 20.5758 12.6814 20.5801 12.6818 20.5846H12.6699V20.5728H12.6759Z"
        fill="#214063"
      />
      <path
        d="M12.6699 20.5797C12.6769 20.5797 12.663 20.5728 12.6769 20.5728L12.6699 20.5797Z"
        fill="white"
      />
      <path
        d="M12.5571 20.7172H12.5634C12.5571 20.7235 12.5634 20.7235 12.5634 20.7298H12.5697C12.5697 20.7306 12.5699 20.7315 12.5702 20.7322C12.5705 20.733 12.571 20.7337 12.5716 20.7343C12.5721 20.7348 12.5728 20.7353 12.5736 20.7356C12.5744 20.7359 12.5752 20.7361 12.576 20.7361H12.5823C12.576 20.7487 12.5823 20.7738 12.5571 20.7801H12.5383C12.5257 20.7738 12.5257 20.7676 12.5194 20.7613C12.5131 20.755 12.5257 20.7613 12.5194 20.755V20.7424C12.5257 20.7424 12.5257 20.7361 12.5194 20.7361L12.5446 20.7235V20.7109C12.5571 20.7109 12.5508 20.7172 12.5571 20.7172Z"
        fill="#214063"
      />
      <path
        d="M12.7837 20.7742H12.7899C12.7962 20.7805 12.8025 20.7805 12.8025 20.7868H12.8088C12.8088 20.7931 12.8025 20.7931 12.8025 20.7994C12.8025 20.8056 12.7962 20.8182 12.8025 20.8245C12.8088 20.8308 12.8025 20.8371 12.7962 20.8308H12.8025C12.7962 20.8371 12.7837 20.8371 12.7837 20.8434H12.7648C12.7585 20.8371 12.7522 20.856 12.7522 20.8434C12.7522 20.8308 12.7459 20.8434 12.7459 20.8497V20.8371C12.7333 20.8497 12.7333 20.8245 12.7207 20.8308C12.7082 20.8371 12.7207 20.8245 12.7207 20.8245H12.7145C12.7207 20.8182 12.7145 20.8119 12.7145 20.8056C12.7145 20.7993 12.727 20.7931 12.7145 20.7805C12.7019 20.7679 12.7333 20.7805 12.7207 20.7679C12.727 20.7679 12.727 20.7805 12.727 20.7742C12.727 20.7679 12.727 20.7679 12.727 20.7616C12.727 20.7553 12.7396 20.7742 12.7396 20.7616H12.7522C12.7585 20.7616 12.7522 20.749 12.7585 20.7553C12.7585 20.7561 12.7587 20.757 12.759 20.7577C12.7593 20.7585 12.7598 20.7592 12.7603 20.7598C12.7609 20.7603 12.7616 20.7608 12.7624 20.7611C12.7631 20.7614 12.764 20.7616 12.7648 20.7616V20.749C12.7711 20.7742 12.7837 20.7679 12.7837 20.7742Z"
        fill="#214063"
      />
      <path
        d="M13.166 20.5166C13.1666 20.5215 13.1658 20.5264 13.1636 20.5308C13.1614 20.5352 13.158 20.5388 13.1537 20.5413C13.1475 20.5351 13.129 20.5351 13.1414 20.5228C13.1475 20.5289 13.1537 20.5166 13.1599 20.5228C13.166 20.5289 13.1598 20.5228 13.166 20.5166Z"
        fill="#214063"
      />
      <path
        d="M13.1551 20.5855L13.1489 20.5731V20.5669H13.1551V20.5855Z"
        fill="#214063"
      />
      <path
        d="M13.1677 20.6045C13.1677 20.6108 13.1677 20.6108 13.174 20.6108C13.174 20.6141 13.1753 20.6173 13.1777 20.6197C13.18 20.622 13.1832 20.6234 13.1866 20.6234C13.1916 20.6353 13.1938 20.6482 13.1929 20.6611L13.174 20.6863C13.1677 20.6926 13.174 20.68 13.1677 20.6863H13.1425C13.1425 20.68 13.1362 20.68 13.1237 20.68C13.1111 20.68 13.1237 20.6674 13.1174 20.6674C13.1124 20.66 13.1101 20.6511 13.1111 20.6422C13.1174 20.6359 13.1111 20.6297 13.1048 20.6234C13.0985 20.6171 13.1174 20.6297 13.1237 20.6234C13.1299 20.6171 13.1362 20.6359 13.1425 20.6297L13.1299 20.6108C13.1425 20.5982 13.1488 20.6108 13.1677 20.6045Z"
        fill="#214063"
      />
      <path
        d="M13.085 20.6554V20.6484H13.0919L13.085 20.6554Z"
        fill="#214063"
      />
      <path
        d="M8.4864 18.805C8.4864 18.8112 8.48023 18.8112 8.48023 18.8173C8.48023 18.8235 8.4679 18.8235 8.4679 18.8173C8.46686 18.8158 8.46618 18.814 8.46593 18.8121C8.46568 18.8102 8.46586 18.8083 8.46645 18.8066C8.46705 18.8048 8.46804 18.8032 8.46936 18.8018C8.47068 18.8005 8.47229 18.7995 8.47407 18.7988L8.4864 18.805Z"
        fill="#214063"
      />
      <path
        d="M8.51256 18.8366C8.51256 18.8429 8.50635 18.8366 8.50635 18.8366V18.8242C8.51256 18.818 8.52499 18.8242 8.51256 18.8366Z"
        fill="#214063"
      />
      <path
        d="M7.76872 17.2388H7.75684C7.76278 17.2329 7.76872 17.2329 7.76872 17.2388Z"
        fill="#214063"
      />
      <path
        d="M7.79504 17.2451C7.79504 17.2521 7.79504 17.2521 7.78809 17.2521H7.79504V17.2451Z"
        fill="#214063"
      />
      <path
        d="M8.11559 18.2198H8.10938C8.10938 18.2136 8.11559 18.2012 8.1218 18.2012C8.12802 18.2012 8.1218 18.2136 8.11559 18.2198Z"
        fill="#214063"
      />
      <path
        d="M7.78825 17.3203C7.78231 17.3263 7.77637 17.3263 7.77637 17.3203H7.78825Z"
        fill="#214063"
      />
      <path
        d="M7.98389 16.8865C7.99622 16.8927 8.00855 16.905 8.00238 16.9174C7.99622 16.9297 7.99622 16.9174 7.99005 16.9112C7.98389 16.905 7.99005 16.8927 7.98389 16.8804V16.8865Z"
        fill="#214063"
      />
      <path
        d="M7.93953 19.1824H7.94582V19.1949C7.95211 19.1949 7.93953 19.2075 7.94582 19.2075C7.95211 19.2075 7.93324 19.2264 7.92066 19.2264H7.90808C7.90808 19.2201 7.8892 19.2138 7.90179 19.2075C7.91437 19.2012 7.90808 19.1949 7.91437 19.1886C7.92066 19.1824 7.92066 19.1886 7.92066 19.1886H7.93953C7.93324 19.1761 7.93953 19.1761 7.93953 19.1824Z"
        fill="#214063"
      />
      <path
        d="M8.02063 16.9806V16.9929C8.01447 16.9929 8.0083 16.9806 8.0083 16.9806V16.9683L8.02063 16.9806Z"
        fill="#214063"
      />
      <path
        d="M8.06486 17.0056C8.05869 16.9995 8.05869 16.9871 8.05253 16.981C8.04636 16.9748 8.06486 16.9995 8.06486 17.0056Z"
        fill="#214063"
      />
      <path
        d="M8.14172 17.5786H8.13477C8.13582 17.578 8.13702 17.5776 8.13824 17.5776C8.13946 17.5776 8.14066 17.578 8.14172 17.5786Z"
        fill="#214063"
      />
      <path
        d="M8.31115 17.6232C8.31024 17.6232 8.30934 17.623 8.30849 17.6226C8.30765 17.6223 8.30688 17.6218 8.30624 17.6211C8.30559 17.6205 8.30508 17.6197 8.30473 17.6189C8.30438 17.618 8.3042 17.6171 8.3042 17.6162L8.31115 17.6232Z"
        fill="#214063"
      />
      <path
        d="M8.39838 17.6158C8.39838 17.6158 8.39838 17.6282 8.39221 17.6282C8.38605 17.6282 8.37988 17.6282 8.37988 17.6158C8.37988 17.6035 8.37988 17.6097 8.37988 17.6035L8.39838 17.6158Z"
        fill="#214063"
      />
      <path
        d="M8.32989 17.6287C8.32989 17.6287 8.33606 17.6287 8.32989 17.6348H8.32373C8.32373 17.6348 8.32989 17.6225 8.32989 17.6287Z"
        fill="#214063"
      />
      <path
        d="M8.17733 17.6977C8.17153 17.6977 8.17153 17.7035 8.16573 17.6977C8.15994 17.6919 8.17733 17.6919 8.17733 17.6977Z"
        fill="#214063"
      />
      <path
        d="M8.0216 17.2775L8.01465 17.2705H8.0216V17.2775Z"
        fill="#214063"
      />
      <path
        d="M8.0268 17.3206C8.0268 17.3267 8.03296 17.3329 8.0268 17.3329C8.02063 17.3329 8.01447 17.3144 8.0083 17.3082H8.01447C8.0083 17.3021 8.02063 17.3021 8.01447 17.2959C8.02084 17.3028 8.02512 17.3113 8.0268 17.3206Z"
        fill="#214063"
      />
      <path
        d="M8.20915 17.7485C8.20915 17.7501 8.20853 17.7516 8.20741 17.7527C8.2063 17.7539 8.20479 17.7545 8.20321 17.7545C8.19727 17.7545 8.20321 17.7485 8.19727 17.7485H8.20915Z"
        fill="#214063"
      />
      <path
        d="M8.26721 17.7485C8.26721 17.7485 8.26025 17.7555 8.26025 17.7485H8.26721Z"
        fill="#214063"
      />
      <path
        d="M8.21554 17.7611C8.21554 17.7673 8.22175 17.7735 8.20932 17.7735C8.1969 17.7735 8.20311 17.7611 8.20932 17.7549L8.21554 17.7611Z"
        fill="#214063"
      />
      <path
        d="M8.07788 17.4023H8.09046C8.09675 17.4212 8.10933 17.4464 8.09675 17.459H8.08417C8.08053 17.4557 8.07827 17.4512 8.07788 17.4464C8.07788 17.4401 8.06529 17.4338 8.07159 17.4212C8.0713 17.4178 8.07171 17.4144 8.07279 17.4111C8.07387 17.4079 8.0756 17.4049 8.07788 17.4023Z"
        fill="#214063"
      />
      <path
        d="M8.02142 17.4706C8.00909 17.4767 8.00909 17.4583 8.00293 17.4521V17.4336C8.012 17.4442 8.01835 17.4569 8.02142 17.4706Z"
        fill="#214063"
      />
      <path
        d="M8.01525 17.4601H8.0083L8.01525 17.4531L8.0083 17.4601H8.01525Z"
        fill="white"
      />
      <path
        d="M8.00222 18.5347H7.99593C7.98335 18.5221 8.00222 18.497 8.00851 18.4844H8.0148C8.01641 18.4932 8.01611 18.5022 8.01394 18.5109C8.01177 18.5196 8.00778 18.5277 8.00222 18.5347Z"
        fill="#214063"
      />
      <path
        d="M8.02142 17.5468V17.5591H8.00909C8.00292 17.553 8.00909 17.5406 8.00909 17.5345C8.01525 17.5345 8.00909 17.5345 8.00909 17.5283C8.01455 17.5335 8.01877 17.5398 8.02142 17.5468Z"
        fill="#214063"
      />
      <path
        d="M8.0153 17.5416C8.00834 17.5416 8.0153 17.5416 8.0153 17.5347V17.5416Z"
        fill="white"
      />
      <path
        d="M8.00909 17.5784L8.02142 17.6031C8.01526 17.6093 8.01526 17.6154 8.00909 17.6093C8.00293 17.6031 8.00293 17.5969 8.00293 17.5846V17.5723C8.00293 17.5723 8.00293 17.5846 8.00909 17.5784Z"
        fill="#214063"
      />
      <path d="M8.01525 17.585L8.0083 17.5919V17.585H8.01525Z" fill="white" />
      <path
        d="M7.78235 17.7356H7.77619C7.77002 17.7356 7.77002 17.7233 7.77002 17.7171C7.77002 17.7109 7.77002 17.7171 7.77002 17.7109C7.77385 17.7138 7.77696 17.7175 7.7791 17.7218C7.78124 17.7261 7.78235 17.7308 7.78235 17.7356Z"
        fill="#214063"
      />
      <path
        d="M8.67594 17.6917C8.66335 17.698 8.66336 17.6854 8.65706 17.6728C8.65077 17.6602 8.66965 17.6414 8.66336 17.6162H8.66965C8.66965 17.6351 8.69481 17.6728 8.67594 17.6917Z"
        fill="#214063"
      />
      <path
        d="M7.983 17.9177H7.97678C7.97678 17.9239 7.97057 17.9239 7.97057 17.9177C7.97057 17.9115 7.97057 17.9053 7.96436 17.9053H7.97057C7.983 17.8991 7.983 17.9053 7.983 17.9177Z"
        fill="#214063"
      />
      <path d="M7.96545 17.8058L7.9585 17.7988H7.96545V17.8058Z" fill="white" />
      <path
        d="M7.98304 18.0317H7.98921C7.99144 18.0342 7.99314 18.0372 7.9942 18.0403C7.99526 18.0435 7.99566 18.0469 7.99537 18.0502C7.99537 18.0564 7.99537 18.0626 7.98921 18.0626H7.97688C7.97071 18.0564 7.98304 18.0502 7.97688 18.0441H7.98304V18.0317Z"
        fill="#214063"
      />
      <path
        d="M8.52423 17.8235C8.52423 17.8297 8.51807 17.8235 8.51807 17.8174L8.52423 17.8235Z"
        fill="#214063"
      />
      <path
        d="M8.52401 17.8293H8.51807C8.52401 17.8293 8.52401 17.8233 8.52401 17.8174V17.8293Z"
        fill="#214063"
      />
      <path
        d="M8.18469 17.9873C8.18469 17.9996 8.19703 18.0181 8.19086 18.0305C8.1893 18.0315 8.18751 18.0322 8.18565 18.0324C8.18378 18.0327 8.18189 18.0325 8.1801 18.0319C8.17831 18.0313 8.17669 18.0303 8.17535 18.029C8.17401 18.0277 8.17299 18.0261 8.17236 18.0243C8.17236 18.012 8.18469 17.9996 8.18469 17.9873Z"
        fill="#214063"
      />
      <path
        d="M7.94553 18.1258C7.94553 18.1321 7.94554 18.1383 7.93932 18.1383C7.93311 18.1383 7.93311 18.1383 7.93311 18.1321C7.93311 18.1258 7.93311 18.1258 7.93311 18.1196H7.94553V18.1258Z"
        fill="#214063"
      />
      <path
        d="M8.36682 18.031C8.36682 18.031 8.36682 18.0433 8.36066 18.0433H8.35449V18.0248C8.36682 18.0125 8.36682 18.0248 8.36682 18.031Z"
        fill="#214063"
      />
      <path
        d="M7.91357 18.1443C7.91357 18.1505 7.91979 18.1443 7.91979 18.1443H7.91357Z"
        fill="#214063"
      />
      <path
        d="M8.64988 18.025C8.65597 18.0311 8.64988 18.0372 8.64988 18.0433H8.6377C8.6377 18.0311 8.64379 18.0128 8.64988 18.025Z"
        fill="#214063"
      />
      <path
        d="M8.52479 18.0503C8.53108 18.0566 8.53108 18.0503 8.53108 18.0503V18.0566C8.53108 18.0566 8.53737 18.0943 8.52479 18.1069H8.51221V18.0817L8.52479 18.0503Z"
        fill="#214063"
      />
      <path
        d="M8.29749 18.0877H8.29132C8.28515 18.0939 8.28515 18.0939 8.29132 18.1001C8.29749 18.1062 8.29749 18.0939 8.30365 18.0877C8.30982 18.0816 8.30982 18.1124 8.29749 18.1186C8.28516 18.1247 8.29132 18.1124 8.28516 18.1062V18.0939C8.28516 18.0939 8.29132 18.0877 8.29132 18.0939H8.29749C8.29749 18.0939 8.29132 18.0877 8.29749 18.0877Z"
        fill="#214063"
      />
      <path
        d="M7.75044 18.2011C7.75044 18.2027 7.74979 18.2043 7.74863 18.2055C7.74748 18.2066 7.74591 18.2073 7.74427 18.2073C7.74264 18.2073 7.74107 18.2066 7.73991 18.2055C7.73876 18.2043 7.73811 18.2027 7.73811 18.2011C7.73194 18.1949 7.74427 18.1888 7.73811 18.1826L7.75044 18.2011Z"
        fill="#214063"
      />
      <path
        d="M7.72555 18.805H7.73184C7.73184 18.805 7.71296 18.8176 7.73184 18.8176C7.75071 18.8176 7.71296 18.8428 7.70038 18.8428C7.70103 18.8477 7.70018 18.8528 7.69794 18.8573C7.69569 18.8617 7.69217 18.8654 7.6878 18.8679C7.68698 18.8679 7.68616 18.8678 7.68539 18.8674C7.68463 18.8671 7.68394 18.8667 7.68335 18.8661C7.68277 18.8655 7.6823 18.8648 7.68199 18.864C7.68167 18.8633 7.68151 18.8624 7.68151 18.8616C7.67522 18.8427 7.70667 18.8365 7.6878 18.8176C7.68823 18.806 7.69268 18.7948 7.70038 18.7861C7.70038 18.7924 7.71296 18.7924 7.71296 18.7924H7.72555C7.72388 18.7924 7.72228 18.7931 7.7211 18.7943C7.71992 18.7954 7.71926 18.797 7.71926 18.7987C7.71926 18.8004 7.71992 18.802 7.7211 18.8032C7.72228 18.8043 7.72388 18.805 7.72555 18.805Z"
        fill="#214063"
      />
      <path
        d="M7.90781 18.2204C7.90781 18.2204 7.9078 18.2328 7.90159 18.2328C7.89538 18.2328 7.89537 18.2266 7.88916 18.2204H7.89538C7.89538 18.2204 7.90781 18.2079 7.90781 18.2204Z"
        fill="#214063"
      />
      <path
        d="M8.4801 18.1446V18.1693C8.47393 18.1693 8.47393 18.1755 8.47393 18.1693C8.47393 18.1631 8.46777 18.157 8.47393 18.1446C8.4801 18.1323 8.47393 18.1446 8.4801 18.1446Z"
        fill="#214063"
      />
      <path
        d="M7.83887 18.2767C7.84508 18.2705 7.84508 18.2767 7.84508 18.2767C7.84673 18.2767 7.84831 18.2774 7.84948 18.2785C7.85064 18.2797 7.8513 18.2813 7.8513 18.2829C7.8513 18.2846 7.85064 18.2862 7.84948 18.2873C7.84831 18.2885 7.84673 18.2892 7.84508 18.2892C7.84427 18.2892 7.84346 18.289 7.8427 18.2887C7.84195 18.2884 7.84126 18.2879 7.84069 18.2873C7.84011 18.2868 7.83965 18.2861 7.83934 18.2853C7.83903 18.2846 7.83887 18.2838 7.83887 18.2829V18.2705V18.2767Z"
        fill="#214063"
      />
      <path
        d="M7.84582 18.2769V18.2838L7.83887 18.2769H7.84582Z"
        fill="white"
      />
      <path
        d="M7.8512 18.3714C7.85283 18.3714 7.8544 18.372 7.85556 18.3732C7.85671 18.3744 7.85736 18.3759 7.85736 18.3776C7.85736 18.3792 7.85671 18.3808 7.85556 18.3819C7.8544 18.3831 7.85283 18.3837 7.8512 18.3837V18.3961C7.83887 18.3899 7.84503 18.3776 7.83887 18.3714C7.84503 18.3714 7.84503 18.3714 7.84503 18.3652L7.8512 18.3714Z"
        fill="#214063"
      />
      <path
        d="M7.65607 18.3525H7.66223C7.66223 18.3587 7.6684 18.371 7.66223 18.3772C7.65896 18.3772 7.65583 18.3759 7.65351 18.3736C7.6512 18.3713 7.6499 18.3681 7.6499 18.3649C7.65029 18.3601 7.6525 18.3557 7.65607 18.3525Z"
        fill="#214063"
      />
      <path
        d="M8.50496 18.2897C8.50799 18.2931 8.50967 18.2974 8.50967 18.302C8.50967 18.3065 8.50799 18.3109 8.50496 18.3143C8.50496 18.3176 8.50366 18.3207 8.50135 18.323C8.49903 18.3254 8.4959 18.3267 8.49263 18.3267C8.48646 18.3267 8.48646 18.3205 8.4803 18.3143C8.47413 18.3082 8.48646 18.302 8.4803 18.2958C8.47413 18.2897 8.48646 18.2835 8.49263 18.2897H8.49879C8.49879 18.2897 8.49879 18.2897 8.50496 18.2897Z"
        fill="#214063"
      />
      <path
        d="M7.78866 18.3896C7.78866 18.3959 7.79488 18.4083 7.78245 18.4083C7.77002 18.4083 7.77002 18.4021 7.77002 18.3959H7.78866V18.3896Z"
        fill="#214063"
      />
      <path
        d="M8.33002 18.3208C8.32373 18.3208 8.32373 18.3145 8.32373 18.3083V18.2957H8.33002C8.32835 18.2957 8.32675 18.2963 8.32557 18.2975C8.32439 18.2987 8.32373 18.3003 8.32373 18.302H8.33002C8.33631 18.2957 8.33002 18.2894 8.33002 18.2831V18.2705C8.33516 18.2779 8.33792 18.2867 8.33792 18.2957C8.33792 18.3047 8.33516 18.3134 8.33002 18.3208Z"
        fill="#214063"
      />
      <path
        d="M7.88332 18.5162C7.87669 18.5096 7.88332 18.5096 7.88332 18.5162V18.5162Z"
        fill="#214063"
      />
      <path
        d="M8.19085 18.6474C8.19701 18.6474 8.19085 18.6412 8.19085 18.6351C8.19701 18.6412 8.19085 18.6474 8.19085 18.6536H8.18468C8.17852 18.6412 8.18468 18.6351 8.19085 18.6289V18.6474Z"
        fill="#214063"
      />
      <path
        d="M7.80042 18.7231C7.80042 18.7247 7.79977 18.7263 7.79861 18.7274C7.79745 18.7286 7.79589 18.7293 7.79425 18.7293C7.79262 18.7293 7.79105 18.7286 7.78989 18.7274C7.78874 18.7263 7.78809 18.7247 7.78809 18.7231V18.7108C7.78809 18.7108 7.79425 18.7169 7.79425 18.7108C7.79344 18.7108 7.79264 18.7106 7.79189 18.7103C7.79114 18.71 7.79046 18.7095 7.78989 18.7089C7.78932 18.7084 7.78887 18.7077 7.78856 18.7069C7.78825 18.7062 7.78809 18.7054 7.78809 18.7046H7.80042C7.80042 18.7108 7.80658 18.7169 7.80042 18.7231Z"
        fill="#214063"
      />
      <path
        d="M8.05902 18.7171C8.05902 18.7233 8.05902 18.7356 8.04669 18.7356C8.04313 18.7324 8.04092 18.728 8.04053 18.7233V18.7109H8.05286L8.05902 18.7171Z"
        fill="#214063"
      />
      <path
        d="M8.05309 18.7292H8.0593C8.05309 18.7354 8.05309 18.7292 8.04688 18.7292C8.05047 18.726 8.0527 18.7216 8.05309 18.7168C8.05309 18.723 8.0593 18.7168 8.05309 18.7292Z"
        fill="white"
      />
      <path
        d="M7.7888 18.6667H7.78258C7.78093 18.6667 7.77935 18.6661 7.77819 18.6649C7.77702 18.6637 7.77637 18.6622 7.77637 18.6605C7.77637 18.6589 7.77702 18.6573 7.77819 18.6561C7.77935 18.655 7.78093 18.6543 7.78258 18.6543H7.7888C7.7888 18.6605 7.79501 18.6667 7.7888 18.6667Z"
        fill="#214063"
      />
      <path
        d="M8.07764 18.7795H8.08358V18.7676C8.08277 18.772 8.08071 18.7761 8.07764 18.7795Z"
        fill="#214063"
      />
      <path
        d="M7.41111 19.0756C7.4174 19.0819 7.4174 19.0693 7.4174 19.0693C7.4174 19.0693 7.41111 19.0756 7.4174 19.0819H7.42369C7.42369 19.0882 7.41111 19.0882 7.4174 19.1008H7.42369V19.1197C7.42369 19.126 7.4174 19.1322 7.41111 19.1385C7.40482 19.1448 7.40482 19.1448 7.41111 19.1511H7.39853C7.39769 19.1545 7.39557 19.1573 7.39262 19.1591C7.38967 19.1609 7.38614 19.1614 7.3828 19.1606C7.37946 19.1597 7.3766 19.1576 7.37483 19.1546C7.37306 19.1517 7.37253 19.1482 7.37337 19.1448L7.36078 19.1322C7.35449 19.126 7.35449 19.1197 7.36078 19.1197H7.35449C7.36078 19.1071 7.36707 19.1008 7.36707 19.0882H7.37337C7.37966 19.0882 7.37966 19.0756 7.38595 19.0756C7.39224 19.0756 7.39224 19.0882 7.39853 19.0819H7.40482C7.40761 19.0807 7.40985 19.0784 7.41111 19.0756Z"
        fill="#214063"
      />
      <path
        d="M8.02071 18.8239C8.01714 18.827 8.01493 18.8314 8.01454 18.8362C8.00221 18.8362 8.00838 18.8239 8.00838 18.8239L8.02071 18.8115V18.8239Z"
        fill="#214063"
      />
      <path
        d="M7.96407 18.8993C7.95791 18.9055 7.95174 18.9055 7.95174 18.8993C7.95174 18.8931 7.94557 18.8993 7.94557 18.8931C7.94557 18.887 7.93325 18.9055 7.92708 18.8993C7.92092 18.8931 7.95174 18.8685 7.95791 18.8623H7.96407C7.96732 18.8679 7.96903 18.8743 7.96903 18.8808C7.96903 18.8873 7.96732 18.8937 7.96407 18.8993Z"
        fill="#214063"
      />
      <path
        d="M7.32278 19.56V19.5726H7.32907C7.32907 19.5789 7.31649 19.5789 7.32278 19.5852H7.32907C7.31649 19.5852 7.32278 19.5977 7.3102 19.604C7.29762 19.6103 7.29133 19.6103 7.28503 19.6166C7.28503 19.615 7.28437 19.6134 7.28319 19.6122C7.28201 19.611 7.28041 19.6103 7.27875 19.6103L7.26616 19.5915V19.5789H7.24729C7.23471 19.5726 7.24729 19.5663 7.24729 19.5537H7.25987C7.25987 19.5663 7.27245 19.5537 7.27875 19.5537H7.32278C7.32278 19.5537 7.3102 19.56 7.32278 19.56Z"
        fill="#214063"
      />
      <path
        d="M7.6127 18.9437C7.6127 18.95 7.61899 18.9626 7.6127 18.9688L7.59383 18.9814C7.58125 18.9751 7.58125 18.9688 7.57496 18.9563C7.56867 18.9437 7.58125 18.9437 7.58754 18.9374L7.60012 18.9248C7.60012 18.9374 7.60641 18.9374 7.6127 18.9437Z"
        fill="#214063"
      />
      <path
        d="M7.83136 18.9812C7.83752 18.9935 7.81286 18.9874 7.81902 19.0058C7.82519 19.0243 7.80053 19.0182 7.79436 19.012C7.7882 19.0058 7.78203 18.9997 7.7882 18.9935V18.9812C7.79436 18.9874 7.79436 18.9812 7.79436 18.9812H7.82519C7.83135 18.975 7.82519 18.975 7.83136 18.9812Z"
        fill="#214063"
      />
      <path
        d="M7.62421 19.2332C7.62421 19.2332 7.61805 19.2394 7.62421 19.2394C7.61805 19.2455 7.63038 19.2579 7.61805 19.2579C7.60572 19.2579 7.60571 19.264 7.60571 19.2702C7.60093 19.2702 7.59621 19.2691 7.59193 19.2669C7.58765 19.2648 7.58393 19.2617 7.58105 19.2579V19.2455C7.58722 19.2517 7.58106 19.2394 7.58722 19.2394C7.59339 19.2394 7.58722 19.2332 7.59339 19.2332H7.61188C7.62421 19.227 7.61188 19.2332 7.62421 19.2332Z"
        fill="#214063"
      />
      <path
        d="M7.31663 19.2013H7.3042V19.1888C7.30585 19.1888 7.30743 19.1882 7.30859 19.187C7.30976 19.1858 7.31041 19.1843 7.31041 19.1826H7.32284L7.31663 19.2013Z"
        fill="#214063"
      />
      <path
        d="M7.11497 19.0065C7.10875 19.0065 7.10254 19.0065 7.10254 18.9941C7.10254 18.9817 7.10254 18.9879 7.10254 18.9879C7.10254 18.9879 7.12118 19.0003 7.11497 19.0065Z"
        fill="#214063"
      />
      <path
        d="M7.27903 19.39H7.28524C7.28524 19.3962 7.27903 19.3962 7.27282 19.3962C7.2666 19.3962 7.2666 19.39 7.2666 19.3838H7.27903V19.39Z"
        fill="#214063"
      />
      <path
        d="M7.22266 19.1886V19.1826C7.22266 19.1826 7.2286 19.1826 7.22266 19.1886Z"
        fill="#214063"
      />
      <path
        d="M7.22918 19.1895C7.22219 19.1965 7.22918 19.1825 7.22918 19.1895V19.1895Z"
        fill="white"
      />
      <path
        d="M7.09577 19.1823H7.10193C7.09577 19.1823 7.10193 19.1884 7.09577 19.1946H7.10193C7.09577 19.1946 7.10193 19.2007 7.09577 19.2007H7.10193C7.0896 19.2069 7.08344 19.2254 7.06494 19.2131V19.1946V19.1699H7.07727C7.08344 19.1699 7.07727 19.1699 7.07727 19.1761C7.07891 19.1761 7.08048 19.1754 7.08163 19.1743C7.08279 19.1731 7.08344 19.1716 7.08344 19.1699C7.08344 19.1761 7.0896 19.1761 7.09577 19.1823H7.10193C7.10193 19.1761 7.0896 19.1761 7.09577 19.1823Z"
        fill="#214063"
      />
      <path
        d="M7.18438 19.3523C7.17809 19.3586 7.18438 19.3586 7.18438 19.3586C7.18438 19.3649 7.19067 19.3586 7.18438 19.3586C7.18438 19.3523 7.18438 19.3712 7.17809 19.3712C7.1718 19.3712 7.18438 19.3712 7.18438 19.3775C7.18438 19.3837 7.17809 19.3712 7.17809 19.3775C7.17809 19.3837 7.15921 19.3837 7.15921 19.39H7.13405C7.13238 19.39 7.13078 19.3894 7.1296 19.3882C7.12842 19.387 7.12776 19.3854 7.12776 19.3837H7.12147C7.12147 19.3712 7.10889 19.3775 7.11518 19.3712C7.12147 19.3649 7.10889 19.3712 7.10889 19.3649H7.11518C7.1026 19.3586 7.11518 19.3523 7.10889 19.346C7.11056 19.346 7.11216 19.3453 7.11333 19.3442C7.11451 19.343 7.11518 19.3414 7.11518 19.3397H7.10889C7.11518 19.3397 7.11518 19.3334 7.11518 19.3271C7.11518 19.3208 7.13405 19.3334 7.12776 19.3208C7.12147 19.3083 7.14034 19.3271 7.14663 19.3208C7.14663 19.3208 7.14034 19.3271 7.14663 19.3271H7.15292C7.15292 19.3271 7.15292 19.3397 7.15921 19.3397H7.1655V19.3523H7.1718V19.3649H7.18438C7.17809 19.3397 7.18438 19.346 7.18438 19.3523Z"
        fill="#214063"
      />
      <path
        d="M6.93916 19.3151H6.94545V19.334C6.93916 19.334 6.94545 19.3465 6.93916 19.3465C6.93287 19.3465 6.93916 19.3591 6.93287 19.3528C6.93287 19.3537 6.93303 19.3545 6.93335 19.3552C6.93367 19.356 6.93413 19.3567 6.93471 19.3573C6.9353 19.3579 6.93599 19.3583 6.93675 19.3586C6.93752 19.359 6.93834 19.3591 6.93916 19.3591H6.914C6.90771 19.3591 6.90771 19.3465 6.90142 19.3528L6.88884 19.3403V19.3214C6.88884 19.3151 6.89513 19.3151 6.88884 19.3088C6.88255 19.3025 6.88884 19.3025 6.89513 19.2962H6.90142V19.2836C6.90142 19.2828 6.90158 19.282 6.9019 19.2812C6.90221 19.2805 6.90268 19.2798 6.90326 19.2792C6.90384 19.2786 6.90454 19.2781 6.9053 19.2778C6.90606 19.2775 6.90688 19.2773 6.90771 19.2773C6.914 19.2836 6.914 19.2773 6.92029 19.2773C6.92658 19.2773 6.914 19.2836 6.92029 19.2836H6.92658C6.93287 19.2899 6.93287 19.2773 6.93287 19.2773C6.93287 19.2773 6.94545 19.3088 6.93916 19.3151Z"
        fill="#214063"
      />
      <path
        d="M7.15243 19.5909C7.15085 19.5909 7.14934 19.5903 7.14823 19.5892C7.14711 19.588 7.14648 19.5865 7.14648 19.585H7.15837L7.15243 19.5909Z"
        fill="#214063"
      />
      <path
        d="M7.19051 19.8107H7.18457C7.18457 19.8048 7.19051 19.8048 7.19051 19.7988H7.19646C7.19646 19.8048 7.19645 19.8107 7.19051 19.8107Z"
        fill="#214063"
      />
      <path
        d="M6.93905 19.4211H6.93311V19.4092H6.93905C6.93905 19.4092 6.9331 19.4151 6.93905 19.4151C6.93905 19.4151 6.94499 19.4151 6.93905 19.4211Z"
        fill="#214063"
      />
      <path
        d="M6.99557 19.598C7.00174 19.598 7.00174 19.6041 7.00174 19.6103L6.98324 19.6226L6.96475 19.6041C6.95858 19.6041 6.97091 19.598 6.95858 19.598C6.94625 19.598 6.97091 19.5918 6.96475 19.5918H6.99557V19.598Z"
        fill="#214063"
      />
      <path
        d="M6.96414 19.5727C6.96414 19.579 6.95785 19.579 6.95785 19.5853C6.95156 19.579 6.95156 19.5853 6.95156 19.5853C6.95156 19.579 6.95156 19.5853 6.94527 19.579C6.9436 19.579 6.942 19.5784 6.94082 19.5772C6.93964 19.576 6.93898 19.5744 6.93898 19.5727C6.93269 19.5853 6.9264 19.5727 6.92011 19.5727C6.92011 19.5719 6.91994 19.5711 6.91963 19.5703C6.91931 19.5696 6.91885 19.5689 6.91826 19.5683C6.91768 19.5677 6.91699 19.5672 6.91622 19.5669C6.91546 19.5666 6.91464 19.5664 6.91381 19.5664C6.91381 19.5539 6.90123 19.5539 6.90752 19.535C6.91381 19.535 6.90752 19.5287 6.90752 19.5287H6.91381C6.91381 19.5224 6.9264 19.5224 6.9264 19.5161H6.93898C6.94527 19.5224 6.94527 19.5287 6.95156 19.5287C6.96414 19.5539 6.95785 19.5727 6.96414 19.5727Z"
        fill="#214063"
      />
      <path
        d="M6.83221 19.5414C6.83221 19.5431 6.83288 19.5447 6.83406 19.5459C6.83523 19.5471 6.83683 19.5477 6.8385 19.5477C6.84479 19.554 6.84479 19.5477 6.84479 19.5477C6.84479 19.5494 6.84413 19.551 6.84295 19.5522C6.84177 19.5534 6.84017 19.554 6.8385 19.554H6.84479C6.8385 19.554 6.83221 19.5603 6.8385 19.5666C6.83221 19.5729 6.84479 19.5792 6.83221 19.5792C6.83449 19.5817 6.83622 19.5847 6.8373 19.588C6.83838 19.5912 6.83879 19.5946 6.8385 19.5981C6.83221 19.5981 6.8385 19.6043 6.83221 19.6043C6.83221 19.6106 6.82592 19.6043 6.82592 19.6106H6.81334C6.81334 19.609 6.81268 19.6074 6.8115 19.6062C6.81032 19.605 6.80872 19.6043 6.80705 19.6043C6.80076 19.6043 6.80705 19.6106 6.80705 19.6169C6.80705 19.6232 6.80076 19.5981 6.79447 19.6043H6.7693C6.7693 19.5981 6.7693 19.5981 6.76301 19.5981V19.5855C6.75672 19.5918 6.76301 19.5792 6.75672 19.5792C6.75043 19.5792 6.75043 19.5729 6.75043 19.5729C6.75043 19.5666 6.75043 19.5666 6.74414 19.5603C6.74414 19.5603 6.75043 19.554 6.74414 19.554C6.74414 19.5523 6.7448 19.5507 6.74598 19.5496C6.74716 19.5484 6.74876 19.5477 6.75043 19.5477V19.5351H6.75672C6.76301 19.5289 6.75043 19.51 6.76301 19.51H6.7693C6.7756 19.51 6.7756 19.5037 6.78189 19.4974C6.78818 19.4911 6.79447 19.51 6.79447 19.5037C6.79447 19.4974 6.79447 19.4974 6.80076 19.4974C6.80705 19.4974 6.79447 19.51 6.80076 19.51H6.80705V19.5226H6.82592C6.82592 19.5163 6.82592 19.5289 6.83221 19.5289V19.5414Z"
        fill="#214063"
      />
      <path
        d="M7.53653 19.4469C7.53037 19.4469 7.53037 19.4592 7.51804 19.4531C7.50571 19.4469 7.50571 19.4346 7.51804 19.4346H7.53037C7.53037 19.4407 7.53653 19.4346 7.53653 19.4469C7.53653 19.4592 7.53037 19.4407 7.53653 19.4469Z"
        fill="#214063"
      />
      <path
        d="M7.48633 19.4777L7.49227 19.4658H7.49821L7.48633 19.4777Z"
        fill="#214063"
      />
      <path
        d="M7.48679 19.4909H7.49308V19.5035H7.49938L7.47421 19.5286C7.46792 19.5286 7.45534 19.5224 7.45534 19.5349H7.44905L7.43018 19.5224C7.43647 19.5161 7.43018 19.5161 7.43018 19.5098C7.43018 19.5035 7.43647 19.4972 7.43018 19.4972H7.43647C7.43647 19.4909 7.43018 19.4909 7.43018 19.4846H7.43647C7.43647 19.4783 7.44276 19.4783 7.44905 19.472C7.45534 19.4657 7.45534 19.4594 7.45534 19.4532C7.45534 19.4469 7.46163 19.472 7.46792 19.472C7.4805 19.472 7.46792 19.4846 7.4805 19.4846V19.4657C7.47421 19.472 7.47421 19.4846 7.48679 19.4909Z"
        fill="#214063"
      />
      <path
        d="M7.41113 19.4722L7.41809 19.4791L7.41113 19.4722Z"
        fill="#214063"
      />
      <path
        d="M12.1612 19.4098L12.1543 19.4028H12.1612V19.4098Z"
        fill="white"
      />
      <path
        d="M13.6573 19.271C13.6573 19.2772 13.6573 19.2833 13.6634 19.2833C13.6696 19.2833 13.6511 19.2957 13.6449 19.2957C13.6388 19.2957 13.6326 19.2772 13.6388 19.271H13.6573Z"
        fill="#214063"
      />
      <path
        d="M13.7081 19.2834H13.6957C13.6921 19.2802 13.6898 19.2758 13.6895 19.271C13.6957 19.271 13.7143 19.271 13.7081 19.2834Z"
        fill="#214063"
      />
      <path
        d="M12.242 17.7547H12.2358C12.2358 17.7547 12.2482 17.7485 12.242 17.7547Z"
        fill="#214063"
      />
      <path
        d="M12.2798 17.7607C12.2798 17.7666 12.2798 17.7666 12.2739 17.7666C12.2681 17.7666 12.2681 17.7607 12.2739 17.7607H12.2798Z"
        fill="#214063"
      />
      <path
        d="M12.9532 18.8423H12.947C12.9443 18.8377 12.9429 18.8323 12.9429 18.8269C12.9429 18.8215 12.9443 18.8162 12.947 18.8115C12.947 18.8239 12.9593 18.8362 12.9532 18.8423Z"
        fill="#214063"
      />
      <path
        d="M12.2795 17.8552C12.2733 17.8614 12.267 17.8676 12.2608 17.8614C12.2605 17.858 12.2609 17.8547 12.262 17.8515C12.2631 17.8482 12.2648 17.8453 12.267 17.8428C12.2703 17.8428 12.2735 17.8441 12.2758 17.8464C12.2782 17.8487 12.2795 17.8519 12.2795 17.8552Z"
        fill="#214063"
      />
      <path
        d="M12.4873 17.3076C12.4996 17.3138 12.5181 17.3261 12.512 17.3446C12.5058 17.3631 12.5058 17.3384 12.4996 17.3384C12.4935 17.3384 12.4935 17.3138 12.4873 17.3076Z"
        fill="#214063"
      />
      <path
        d="M13.3249 19.9628H13.3312V19.9753C13.3438 19.9628 13.3375 19.9879 13.3501 19.9879C13.3506 19.9938 13.3497 19.9997 13.3475 20.0051C13.3454 20.0106 13.3419 20.0155 13.3375 20.0194H13.3124C13.3124 20.0068 13.2872 20.0194 13.2935 20.0005C13.2998 19.9816 13.2935 19.9879 13.2935 19.9753C13.2935 19.9628 13.2998 19.9753 13.2998 19.969C13.3061 19.9753 13.3124 19.969 13.3187 19.9628C13.3249 19.9565 13.3249 19.9628 13.3249 19.9628Z"
        fill="#214063"
      />
      <path
        d="M12.5319 17.4147C12.5323 17.4194 12.5345 17.4238 12.538 17.427C12.5319 17.4332 12.5257 17.4208 12.5195 17.4147V17.4023C12.5228 17.4023 12.5259 17.4036 12.5282 17.406C12.5306 17.4083 12.5319 17.4114 12.5319 17.4147Z"
        fill="#214063"
      />
      <path
        d="M12.5883 17.4394C12.576 17.4333 12.576 17.4209 12.5698 17.4086C12.5637 17.3963 12.5883 17.4271 12.5883 17.4394Z"
        fill="#214063"
      />
      <path
        d="M12.5827 17.4347C12.5827 17.4347 12.5757 17.4347 12.5827 17.4277V17.4347Z"
        fill="white"
      />
      <path
        d="M12.7638 18.0876H12.752C12.7579 18.0876 12.7579 18.0817 12.7638 18.0876Z"
        fill="#214063"
      />
      <path
        d="M13.0787 18.0564C13.079 18.0597 13.0786 18.0631 13.0775 18.0663C13.0764 18.0694 13.0748 18.0724 13.0725 18.0749H13.054C13.0479 18.0687 13.0602 18.0625 13.054 18.0564C13.0479 18.0502 13.0725 18.0502 13.0787 18.0564Z"
        fill="#214063"
      />
      <path
        d="M13.004 18.0881C13.004 18.0881 12.9971 18.095 12.9971 18.0881C12.9971 18.0811 12.9971 18.0881 13.004 18.0881Z"
        fill="#214063"
      />
      <path
        d="M12.8389 18.2204H12.8273C12.8215 18.2204 12.8331 18.2146 12.8389 18.2204Z"
        fill="#214063"
      />
      <path
        d="M12.5636 17.7618L12.5566 17.7549L12.5636 17.7618Z"
        fill="#214063"
      />
      <path
        d="M12.5754 17.817C12.5754 17.8231 12.5816 17.8293 12.5754 17.8293C12.5693 17.8293 12.5569 17.8108 12.5508 17.8046H12.5569C12.5446 17.7923 12.5631 17.7923 12.5508 17.7861C12.5625 17.793 12.5713 17.804 12.5754 17.817Z"
        fill="#214063"
      />
      <path
        d="M13.0097 18.1636C13.0155 18.1694 13.0097 18.1694 13.0097 18.1752C13.0097 18.181 13.0039 18.1694 13.0039 18.1636H13.0097Z"
        fill="#214063"
      />
      <path
        d="M12.8898 18.2701C12.8882 18.2701 12.8867 18.2707 12.8856 18.2718C12.8845 18.273 12.8839 18.2745 12.8839 18.276C12.8835 18.2715 12.8814 18.2672 12.8779 18.2642C12.8839 18.2642 12.8898 18.2642 12.8898 18.2701Z"
        fill="#214063"
      />
      <path
        d="M12.9596 18.2454H12.9534C12.9534 18.2454 12.9473 18.2393 12.9534 18.2393C12.9596 18.2393 12.9534 18.2454 12.9596 18.2454Z"
        fill="#214063"
      />
      <path
        d="M12.9024 18.2769C12.9024 18.2831 12.9148 18.2955 12.9024 18.2955C12.89 18.2955 12.89 18.2831 12.8962 18.2769H12.9024Z"
        fill="#214063"
      />
      <path
        d="M12.6516 17.8994H12.6704C12.6767 17.9246 12.6956 17.9435 12.683 17.9686H12.6704C12.6641 17.9623 12.6641 17.956 12.6579 17.956C12.6516 17.956 12.639 17.9372 12.6453 17.9246V17.8994H12.6516Z"
        fill="#214063"
      />
      <path
        d="M12.594 17.993C12.5755 18.0054 12.5755 17.9807 12.5693 17.9745V17.9561C12.5764 17.9594 12.5825 17.9646 12.5868 17.9711C12.5911 17.9776 12.5936 17.9852 12.594 17.993Z"
        fill="#214063"
      />
      <path
        d="M12.5876 17.9806H12.5757L12.5816 17.9746L12.5757 17.9806H12.5876Z"
        fill="white"
      />
      <path
        d="M12.9725 19.2581H12.9662C12.9474 19.2455 12.9536 19.2141 12.9536 19.1952V19.1826C12.9628 19.1926 12.9693 19.2048 12.9726 19.218C12.9759 19.2312 12.9759 19.2449 12.9725 19.2581Z"
        fill="#214063"
      />
      <path
        d="M12.6135 18.088V18.1006C12.6073 18.1006 12.601 18.1006 12.601 18.0943C12.601 18.088 12.5884 18.0755 12.5884 18.0629H12.5947V18.0503C12.6056 18.06 12.6124 18.0735 12.6135 18.088Z"
        fill="#214063"
      />
      <path
        d="M12.6071 18.1256C12.6132 18.1256 12.6194 18.1441 12.6194 18.1503C12.6194 18.1564 12.6194 18.1626 12.6132 18.1626L12.5947 18.1379C12.6009 18.1318 12.5947 18.1256 12.5947 18.1194C12.5947 18.1133 12.6009 18.1318 12.6071 18.1256Z"
        fill="#214063"
      />
      <path
        d="M12.6144 18.1318L12.6074 18.1388L12.6144 18.1318Z"
        fill="white"
      />
      <path
        d="M12.3743 18.377C12.3743 18.3778 12.3741 18.3786 12.3738 18.3793C12.3735 18.3801 12.373 18.3807 12.3725 18.3813C12.3719 18.3819 12.3712 18.3823 12.3705 18.3827C12.3697 18.383 12.3689 18.3831 12.3681 18.3831C12.3558 18.3831 12.3558 18.3708 12.3558 18.3646C12.3558 18.3585 12.3496 18.3585 12.3496 18.3523C12.3496 18.3461 12.3681 18.3646 12.3743 18.377Z"
        fill="#214063"
      />
      <path
        d="M13.4309 18.0505C13.4183 18.0631 13.412 18.0442 13.4057 18.0316C13.3994 18.019 13.4057 17.9939 13.3994 17.975V17.9624C13.4057 17.9876 13.4435 18.019 13.4309 18.0505Z"
        fill="#214063"
      />
      <path
        d="M12.6696 18.541C12.6696 18.5426 12.6689 18.5442 12.6677 18.5453C12.6666 18.5465 12.665 18.5471 12.6634 18.5471C12.6618 18.5471 12.6602 18.5465 12.659 18.5453C12.6579 18.5442 12.6572 18.5426 12.6572 18.541V18.5225C12.661 18.5238 12.6643 18.5263 12.6665 18.5296C12.6687 18.533 12.6698 18.537 12.6696 18.541Z"
        fill="#214063"
      />
      <path
        d="M12.6144 18.4161L12.6074 18.4092H12.6144V18.4161Z"
        fill="white"
      />
      <path
        d="M12.72 18.6793H12.7262C12.7262 18.6777 12.7255 18.6761 12.7244 18.675C12.7232 18.6738 12.7217 18.6732 12.72 18.6732C12.7324 18.6732 12.7324 18.6793 12.7447 18.6917C12.757 18.704 12.7447 18.704 12.7324 18.7101C12.72 18.7163 12.7262 18.704 12.72 18.704C12.7139 18.704 12.72 18.6917 12.7139 18.6855V18.667L12.72 18.6793Z"
        fill="#214063"
      />
      <path
        d="M13.2877 18.2462C13.2859 18.2462 13.2841 18.2455 13.2828 18.2442C13.2815 18.2429 13.2808 18.2411 13.2808 18.2393L13.2877 18.2462Z"
        fill="#214063"
      />
      <path
        d="M13.2866 18.2511C13.2882 18.2511 13.2897 18.2505 13.2908 18.2494C13.2919 18.2483 13.2926 18.2468 13.2926 18.2452C13.2926 18.2436 13.2919 18.2421 13.2908 18.241C13.2897 18.2399 13.2882 18.2393 13.2866 18.2393V18.2511Z"
        fill="#214063"
      />
      <path
        d="M12.9409 18.5469C12.9472 18.5657 12.9661 18.5783 12.9598 18.5972C12.9535 18.6161 12.9409 18.6035 12.9409 18.5972C12.9377 18.5827 12.9377 18.5677 12.9409 18.5532V18.5469Z"
        fill="#214063"
      />
      <path
        d="M12.7137 18.805C12.7137 18.811 12.7198 18.8171 12.7137 18.8232H12.7015C12.6993 18.8208 12.6976 18.8179 12.6966 18.8147C12.6955 18.8116 12.6951 18.8083 12.6954 18.805H12.7015C12.7076 18.805 12.7076 18.7989 12.7137 18.805Z"
        fill="#214063"
      />
      <path
        d="M13.1726 18.5223C13.1735 18.531 13.1713 18.5397 13.1664 18.5469H13.1541C13.1541 18.5346 13.1479 18.5284 13.1541 18.5223C13.1603 18.5161 13.1664 18.5223 13.1726 18.5223Z"
        fill="#214063"
      />
      <path
        d="M12.6826 18.8429C12.6843 18.8429 12.6858 18.8422 12.687 18.841C12.6882 18.8399 12.6888 18.8383 12.6888 18.8366C12.6852 18.8335 12.683 18.829 12.6826 18.8242V18.8429Z"
        fill="#214063"
      />
      <path
        d="M13.5011 18.4087C13.5033 18.4112 13.505 18.4141 13.5061 18.4173C13.5071 18.4205 13.5075 18.4238 13.5073 18.4272C13.5011 18.4333 13.4888 18.4333 13.4888 18.4272C13.4888 18.421 13.4949 18.3963 13.5011 18.4087Z"
        fill="#214063"
      />
      <path
        d="M13.362 18.4911C13.3636 18.4911 13.3652 18.4904 13.3664 18.4893C13.3676 18.4881 13.3683 18.4865 13.3683 18.4848C13.3745 18.4848 13.3683 18.4911 13.3683 18.4974C13.3758 18.5031 13.3816 18.5109 13.385 18.5198C13.3883 18.5287 13.3891 18.5384 13.3871 18.5477C13.3808 18.554 13.3683 18.5477 13.3683 18.5477L13.3557 18.5163C13.3548 18.5034 13.3569 18.4904 13.362 18.4785V18.4911Z"
        fill="#214063"
      />
      <path
        d="M13.1105 18.6162C13.1088 18.6162 13.1073 18.6169 13.1061 18.618C13.105 18.6192 13.1043 18.6207 13.1043 18.6224H13.0981C13.0981 18.6285 13.0981 18.6347 13.1043 18.6347C13.1105 18.6347 13.1166 18.6285 13.1166 18.6224C13.1192 18.6241 13.1213 18.6264 13.1227 18.629C13.1242 18.6317 13.1249 18.6347 13.1249 18.6378C13.1249 18.6408 13.1242 18.6438 13.1227 18.6465C13.1213 18.6492 13.1192 18.6515 13.1166 18.6532H13.1043C13.1043 18.647 13.0981 18.6409 13.0981 18.6347C13.0981 18.6347 13.0981 18.6285 13.1043 18.6347V18.6224C13.1043 18.6162 13.1043 18.6162 13.1105 18.6162Z"
        fill="#214063"
      />
      <path
        d="M12.519 18.9868C12.519 18.9885 12.5183 18.99 12.5172 18.9912C12.516 18.9923 12.5145 18.993 12.5128 18.993C12.5112 18.993 12.5096 18.9923 12.5085 18.9912C12.5073 18.99 12.5067 18.9885 12.5067 18.9868C12.5005 18.9807 12.5067 18.9683 12.5005 18.9622C12.4943 18.956 12.519 18.9745 12.519 18.9868Z"
        fill="#214063"
      />
      <path
        d="M13.1163 18.6289C13.1163 18.6348 13.1104 18.6348 13.1104 18.6408H13.1163V18.6289Z"
        fill="white"
      />
      <path
        d="M12.8398 19.7357H12.8461C12.8524 19.7357 12.8398 19.7608 12.8587 19.7545C12.8775 19.7483 12.8587 19.7923 12.8398 19.8049H12.8461C12.8524 19.8175 12.865 19.83 12.8587 19.8363H12.8461C12.8209 19.8237 12.8524 19.7923 12.8209 19.7797C12.7895 19.7671 12.8084 19.7545 12.8084 19.742V19.7294C12.8146 19.7357 12.8209 19.7294 12.8272 19.7294H12.8335V19.7168C12.8332 19.7202 12.8336 19.7236 12.8347 19.7269C12.8358 19.7301 12.8375 19.7331 12.8398 19.7357Z"
        fill="#214063"
      />
      <path
        d="M12.7079 18.931C12.7079 18.9371 12.7141 18.9495 12.7079 18.9556C12.7018 18.9618 12.6956 18.9495 12.6895 18.9433C12.6911 18.9433 12.6927 18.9426 12.6938 18.9415C12.695 18.9403 12.6956 18.9388 12.6956 18.9371C12.6956 18.9355 12.695 18.9339 12.6938 18.9328C12.6927 18.9316 12.6911 18.931 12.6895 18.931C12.6956 18.931 12.7079 18.9248 12.7079 18.931Z"
        fill="#214063"
      />
      <path
        d="M13.3431 18.61C13.3469 18.6128 13.35 18.6166 13.3522 18.6208C13.3543 18.6251 13.3554 18.6298 13.3554 18.6346H13.3492C13.3369 18.6346 13.3369 18.6223 13.3369 18.61C13.3369 18.5976 13.3431 18.61 13.3431 18.61Z"
        fill="#214063"
      />
      <path
        d="M12.6572 19.0316C12.6572 19.0254 12.6634 19.0316 12.6634 19.0316C12.6634 19.0316 12.6759 19.0378 12.6697 19.044H12.6572V19.0316Z"
        fill="#214063"
      />
      <path
        d="M12.6642 19.0317V19.0387H12.6572V19.0317H12.6642Z"
        fill="white"
      />
      <path
        d="M12.7202 19.1445C12.7219 19.1452 12.7235 19.1462 12.7249 19.1475C12.7262 19.1489 12.7272 19.1505 12.7278 19.1523C12.7284 19.1541 12.7285 19.156 12.7283 19.1578C12.728 19.1597 12.7274 19.1615 12.7263 19.163C12.7263 19.163 12.7263 19.1754 12.7202 19.1754C12.714 19.1754 12.7078 19.163 12.7017 19.1569C12.7078 19.1507 12.7017 19.1507 12.7078 19.1445H12.7202Z"
        fill="#214063"
      />
      <path
        d="M12.4935 19.2207C12.4996 19.233 12.512 19.2392 12.5058 19.2515C12.4996 19.2639 12.4935 19.2515 12.4873 19.2454V19.2207H12.4935Z"
        fill="#214063"
      />
      <path
        d="M13.4309 18.749C13.4371 18.749 13.4432 18.7614 13.4432 18.7737C13.4432 18.786 13.4432 18.786 13.4309 18.7922H13.4124C13.4127 18.7888 13.4123 18.7855 13.4112 18.7823C13.4102 18.7791 13.4085 18.7762 13.4062 18.7737C13.4247 18.7737 13.4062 18.7552 13.4186 18.7614H13.4309V18.749Z"
        fill="#214063"
      />
      <path
        d="M13.2296 18.8302H13.2236V18.8184C13.2236 18.8184 13.2236 18.8302 13.2296 18.8302Z"
        fill="#214063"
      />
      <path
        d="M12.657 19.2014C12.657 19.2137 12.6693 19.2261 12.657 19.2384C12.6447 19.2507 12.6447 19.2322 12.6385 19.2261C12.6323 19.2199 12.6323 19.2199 12.6323 19.2137H12.6447C12.6447 19.2014 12.657 19.1891 12.657 19.2014Z"
        fill="#214063"
      />
      <path
        d="M13.2361 18.8612H13.23V18.8427H13.2361C13.23 18.8427 13.2361 18.8489 13.2361 18.8489C13.2361 18.8489 13.2423 18.855 13.2423 18.8489C13.2423 18.8427 13.2423 18.8365 13.2361 18.8365H13.2423V18.8242C13.2361 18.8365 13.2485 18.8489 13.2361 18.8612Z"
        fill="#214063"
      />
      <path
        d="M12.8272 19.2951H12.8213C12.8213 19.301 12.8272 19.2951 12.8272 19.2892C12.8272 19.2834 12.8272 19.2951 12.8272 19.2951Z"
        fill="#214063"
      />
      <path
        d="M13.2424 19.277H13.2486C13.2547 19.2708 13.2486 19.2708 13.2424 19.2646C13.2486 19.2708 13.2486 19.277 13.2547 19.2893H13.2424C13.2363 19.2831 13.2363 19.277 13.2424 19.2646V19.277Z"
        fill="#214063"
      />
      <path
        d="M13.2368 19.2832H13.2438V19.2902L13.2368 19.2832Z"
        fill="white"
      />
      <path
        d="M12.8709 19.5911C12.8709 19.5972 12.8585 19.5972 12.8524 19.5972C12.8462 19.5972 12.8462 19.5911 12.8462 19.5849C12.8462 19.5787 12.8585 19.5849 12.8524 19.5787H12.8462C12.8478 19.5787 12.8494 19.5781 12.8506 19.5769C12.8517 19.5758 12.8524 19.5742 12.8524 19.5726C12.8524 19.5709 12.8517 19.5694 12.8506 19.5682C12.8494 19.5671 12.8478 19.5664 12.8462 19.5664H12.8585C12.8585 19.5726 12.8709 19.5787 12.8709 19.5911Z"
        fill="#214063"
      />
      <path
        d="M13.1411 19.4215C13.1411 19.4277 13.1534 19.44 13.1411 19.4462C13.1287 19.4523 13.1287 19.4462 13.1226 19.44V19.4215V19.4092H13.1287C13.1349 19.4215 13.1349 19.4215 13.1411 19.4215Z"
        fill="#214063"
      />
      <path
        d="M13.1413 19.4343C13.1413 19.4405 13.1351 19.4343 13.1351 19.4343C13.1351 19.4343 13.1289 19.4281 13.1289 19.4219C13.1289 19.4157 13.1351 19.4219 13.1413 19.4343Z"
        fill="white"
      />
      <path
        d="M12.8147 19.5349H12.8085C12.8022 19.5349 12.8022 19.5287 12.8022 19.5225C12.8022 19.5241 12.8029 19.5257 12.8041 19.5269C12.8052 19.528 12.8068 19.5287 12.8085 19.5287C12.8147 19.5225 12.8209 19.5287 12.8147 19.5349Z"
        fill="#214063"
      />
      <path
        d="M13.1984 19.4714H13.186C13.1922 19.4653 13.186 19.4653 13.186 19.4653H13.1984V19.4468C13.1984 19.4591 13.2045 19.4653 13.1984 19.4714Z"
        fill="#214063"
      />
      <path
        d="M12.7329 20.2836C12.7455 20.2836 12.7392 20.271 12.7392 20.271C12.7392 20.271 12.7392 20.2773 12.7455 20.2836C12.7518 20.2899 12.7518 20.271 12.7455 20.271C12.7518 20.2773 12.7455 20.2962 12.7581 20.3025H12.7707C12.7707 20.315 12.777 20.315 12.7833 20.3276C12.7896 20.3339 12.7833 20.3465 12.7833 20.3528C12.7833 20.3591 12.7896 20.3717 12.7959 20.3717C12.8021 20.3717 12.7833 20.3779 12.7896 20.3842C12.7867 20.3906 12.7824 20.3962 12.7769 20.4006C12.7714 20.405 12.765 20.408 12.7581 20.4094H12.7392C12.7329 20.4094 12.7329 20.4031 12.7267 20.4094C12.7204 20.4157 12.7267 20.3968 12.7204 20.3968C12.717 20.3968 12.7138 20.3955 12.7115 20.3931C12.7091 20.3908 12.7078 20.3876 12.7078 20.3842H12.7015C12.7002 20.3709 12.6959 20.3579 12.6889 20.3465H12.6826C12.6889 20.3465 12.6952 20.3528 12.7015 20.3465V20.3339H12.7078C12.7141 20.3276 12.7015 20.3213 12.7078 20.315C12.7141 20.3087 12.7204 20.3213 12.7267 20.315V20.2962C12.7204 20.271 12.7267 20.2836 12.7329 20.2836Z"
        fill="#214063"
      />
      <path
        d="M13.1671 19.5599C13.1671 19.5583 13.1665 19.5567 13.1653 19.5556C13.1642 19.5544 13.1626 19.5537 13.161 19.5537C13.1593 19.5537 13.1577 19.5544 13.1566 19.5556C13.1554 19.5567 13.1548 19.5583 13.1548 19.5599C13.1548 19.5615 13.1554 19.5631 13.1566 19.5643C13.1577 19.5654 13.1593 19.5661 13.161 19.5661C13.1671 19.5661 13.1609 19.5661 13.1671 19.5599C13.1733 19.5537 13.1671 19.5722 13.1671 19.5784C13.1671 19.5846 13.1548 19.5722 13.1548 19.5661C13.1548 19.5599 13.161 19.5537 13.161 19.5476C13.161 19.5414 13.1671 19.5537 13.1671 19.5599Z"
        fill="#214063"
      />
      <path
        d="M13.1545 19.6667C13.1545 19.6729 13.1482 19.6855 13.1419 19.6792C13.1356 19.6729 13.1356 19.6792 13.1293 19.6792C13.123 19.6792 13.1293 19.6981 13.1167 19.6918C13.1041 19.6855 13.1167 19.6478 13.123 19.6289H13.1293C13.1335 19.6297 13.1374 19.6312 13.141 19.6336C13.1445 19.6359 13.1476 19.6389 13.1499 19.6424C13.1523 19.6459 13.1539 19.6499 13.1547 19.6541C13.1554 19.6582 13.1554 19.6625 13.1545 19.6667Z"
        fill="#214063"
      />
      <path
        d="M13.0918 20.8057L13.1044 20.8182C13.1044 20.8245 13.1044 20.8308 13.1107 20.8308C13.1107 20.8497 13.1233 20.8497 13.117 20.8623C13.1107 20.8749 13.1107 20.8874 13.1107 20.9C13.1107 20.9126 13.1044 20.9 13.1044 20.9063H13.073C13.073 20.9 13.0667 20.9 13.0604 20.8937L13.0415 20.9063C13.0289 20.9126 13.0289 20.8937 13.0163 20.8937C13.0038 20.8937 13.0163 20.8749 13.0163 20.8686C13.0226 20.8749 13.0226 20.856 13.0289 20.8497C13.0289 20.856 13.0289 20.856 13.0352 20.856H13.0541C13.0541 20.8497 13.0541 20.8434 13.0604 20.8497V20.8308H13.073C13.0855 20.7994 13.0855 20.812 13.0918 20.8057Z"
        fill="#214063"
      />
      <path
        d="M12.8215 19.9688H12.8278C12.8278 19.975 12.8467 19.9813 12.8467 19.9939C12.8477 20.0048 12.8455 20.0157 12.8404 20.0254L12.8027 20.0128C12.809 20.0065 12.7964 19.9939 12.7964 19.9876H12.8027V19.9688H12.8215Z"
        fill="#214063"
      />
      <path
        d="M13.0726 19.7864H13.0664C13.0726 19.7864 13.0787 19.7803 13.0726 19.7803C13.0664 19.7803 13.0787 19.7864 13.0726 19.7864Z"
        fill="#214063"
      />
      <path
        d="M13.0725 19.8432H13.0788C13.0913 19.8558 13.0599 19.8621 13.0788 19.881C13.0976 19.8998 13.0788 19.8998 13.0662 19.9061C13.0536 19.9124 13.0473 19.8998 13.041 19.8872V19.8747C13.0536 19.8747 13.041 19.8621 13.0473 19.8558C13.0599 19.8495 13.0536 19.8432 13.0599 19.8369H13.0725V19.8432Z"
        fill="#214063"
      />
      <path
        d="M13.0604 20.2523C13.0666 20.246 13.0666 20.2586 13.0666 20.2523C13.0666 20.246 13.0792 20.2586 13.0792 20.2649C13.0729 20.2775 13.0981 20.2712 13.0855 20.29C13.0729 20.3089 13.0792 20.3026 13.0792 20.3089C13.0792 20.3152 13.0666 20.3215 13.0541 20.3152L13.0352 20.3026C13.0415 20.3026 13.0226 20.2963 13.0352 20.29V20.2775H13.0415V20.2649H13.0478V20.2523C13.0478 20.254 13.0484 20.2556 13.0496 20.2568C13.0508 20.2579 13.0524 20.2586 13.0541 20.2586C13.0541 20.246 13.0541 20.2649 13.0604 20.2523Z"
        fill="#214063"
      />
      <path
        d="M12.7579 20.5035H12.7641C12.7657 20.5035 12.7673 20.5042 12.7685 20.5053C12.7696 20.5065 12.7703 20.5081 12.7703 20.5097C12.7703 20.5159 12.7703 20.5282 12.7641 20.5282H12.7456C12.7472 20.5282 12.7488 20.5276 12.75 20.5264C12.7511 20.5252 12.7518 20.5237 12.7518 20.522C12.7518 20.5204 12.7511 20.5188 12.75 20.5177C12.7488 20.5165 12.7472 20.5159 12.7456 20.5159V20.5035L12.7579 20.4912C12.7518 20.4974 12.7579 20.5035 12.7579 20.5035Z"
        fill="#214063"
      />
      <path
        d="M12.4054 20.5162C12.4054 20.5224 12.3991 20.5286 12.3867 20.5224V20.5099C12.3929 20.5037 12.4116 20.5037 12.4054 20.5162Z"
        fill="#214063"
      />
      <path
        d="M12.9028 20.7051H12.9089C12.9089 20.7112 12.9089 20.7236 12.9028 20.7236C12.8966 20.7236 12.8966 20.7297 12.8904 20.7236C12.8843 20.7174 12.8904 20.7174 12.8843 20.7112L12.9028 20.7051Z"
        fill="#214063"
      />
      <path
        d="M12.6759 20.5728C12.6793 20.5758 12.6814 20.5801 12.6818 20.5846H12.6699V20.5728H12.6759Z"
        fill="#214063"
      />
      <path
        d="M12.6699 20.5797C12.6769 20.5797 12.663 20.5728 12.6769 20.5728L12.6699 20.5797Z"
        fill="white"
      />
      <path
        d="M12.5571 20.7172H12.5634C12.5571 20.7235 12.5634 20.7235 12.5634 20.7298H12.5697C12.5697 20.7306 12.5699 20.7315 12.5702 20.7322C12.5705 20.733 12.571 20.7337 12.5716 20.7343C12.5721 20.7348 12.5728 20.7353 12.5736 20.7356C12.5744 20.7359 12.5752 20.7361 12.576 20.7361H12.5823C12.576 20.7487 12.5823 20.7738 12.5571 20.7801H12.5383C12.5257 20.7738 12.5257 20.7676 12.5194 20.7613C12.5131 20.755 12.5257 20.7613 12.5194 20.755V20.7424C12.5257 20.7424 12.5257 20.7361 12.5194 20.7361L12.5446 20.7235V20.7109C12.5571 20.7109 12.5508 20.7172 12.5571 20.7172Z"
        fill="#214063"
      />
      <path
        d="M12.7837 20.7742H12.7899C12.7962 20.7805 12.8025 20.7805 12.8025 20.7868H12.8088C12.8088 20.7931 12.8025 20.7931 12.8025 20.7994C12.8025 20.8056 12.7962 20.8182 12.8025 20.8245C12.8088 20.8308 12.8025 20.8371 12.7962 20.8308H12.8025C12.7962 20.8371 12.7837 20.8371 12.7837 20.8434H12.7648C12.7585 20.8371 12.7522 20.856 12.7522 20.8434C12.7522 20.8308 12.7459 20.8434 12.7459 20.8497V20.8371C12.7333 20.8497 12.7333 20.8245 12.7207 20.8308C12.7082 20.8371 12.7207 20.8245 12.7207 20.8245H12.7145C12.7207 20.8182 12.7145 20.8119 12.7145 20.8056C12.7145 20.7993 12.727 20.7931 12.7145 20.7805C12.7019 20.7679 12.7333 20.7805 12.7207 20.7679C12.727 20.7679 12.727 20.7805 12.727 20.7742C12.727 20.7679 12.727 20.7679 12.727 20.7616C12.727 20.7553 12.7396 20.7742 12.7396 20.7616H12.7522C12.7585 20.7616 12.7522 20.749 12.7585 20.7553C12.7585 20.7561 12.7587 20.757 12.759 20.7577C12.7593 20.7585 12.7598 20.7592 12.7603 20.7598C12.7609 20.7603 12.7616 20.7608 12.7624 20.7611C12.7631 20.7614 12.764 20.7616 12.7648 20.7616V20.749C12.7711 20.7742 12.7837 20.7679 12.7837 20.7742Z"
        fill="#214063"
      />
      <path
        d="M13.166 20.5166C13.1666 20.5215 13.1658 20.5264 13.1636 20.5308C13.1614 20.5352 13.158 20.5388 13.1537 20.5413C13.1475 20.5351 13.129 20.5351 13.1414 20.5228C13.1475 20.5289 13.1537 20.5166 13.1599 20.5228C13.166 20.5289 13.1598 20.5228 13.166 20.5166Z"
        fill="#214063"
      />
      <path
        d="M13.1551 20.5855L13.1489 20.5731V20.5669H13.1551V20.5855Z"
        fill="#214063"
      />
      <path
        d="M13.1677 20.6045C13.1677 20.6108 13.1677 20.6108 13.174 20.6108C13.174 20.6141 13.1753 20.6173 13.1777 20.6197C13.18 20.622 13.1832 20.6234 13.1866 20.6234C13.1916 20.6353 13.1938 20.6482 13.1929 20.6611L13.174 20.6863C13.1677 20.6926 13.174 20.68 13.1677 20.6863H13.1425C13.1425 20.68 13.1362 20.68 13.1237 20.68C13.1111 20.68 13.1237 20.6674 13.1174 20.6674C13.1124 20.66 13.1101 20.6511 13.1111 20.6422C13.1174 20.6359 13.1111 20.6297 13.1048 20.6234C13.0985 20.6171 13.1174 20.6297 13.1237 20.6234C13.1299 20.6171 13.1362 20.6359 13.1425 20.6297L13.1299 20.6108C13.1425 20.5982 13.1488 20.6108 13.1677 20.6045Z"
        fill="#214063"
      />
      <path
        d="M13.085 20.6554V20.6484H13.0919L13.085 20.6554Z"
        fill="#214063"
      />
      <path
        d="M8.4864 18.805C8.4864 18.8112 8.48023 18.8112 8.48023 18.8173C8.48023 18.8235 8.4679 18.8235 8.4679 18.8173C8.46686 18.8158 8.46618 18.814 8.46593 18.8121C8.46568 18.8102 8.46586 18.8083 8.46645 18.8066C8.46705 18.8048 8.46804 18.8032 8.46936 18.8018C8.47068 18.8005 8.47229 18.7995 8.47407 18.7988L8.4864 18.805Z"
        fill="#214063"
      />
      <path
        d="M8.51256 18.8366C8.51256 18.8429 8.50635 18.8366 8.50635 18.8366V18.8242C8.51256 18.818 8.52499 18.8242 8.51256 18.8366Z"
        fill="#214063"
      />
      <path
        d="M7.76872 17.2388H7.75684C7.76278 17.2329 7.76872 17.2329 7.76872 17.2388Z"
        fill="#214063"
      />
      <path
        d="M7.79504 17.2451C7.79504 17.2521 7.79504 17.2521 7.78809 17.2521H7.79504V17.2451Z"
        fill="#214063"
      />
      <path
        d="M8.11559 18.2198H8.10938C8.10938 18.2136 8.11559 18.2012 8.1218 18.2012C8.12802 18.2012 8.1218 18.2136 8.11559 18.2198Z"
        fill="#214063"
      />
      <path
        d="M7.78825 17.3203C7.78231 17.3263 7.77637 17.3263 7.77637 17.3203H7.78825Z"
        fill="#214063"
      />
      <path
        d="M7.98389 16.8865C7.99622 16.8927 8.00855 16.905 8.00238 16.9174C7.99622 16.9297 7.99622 16.9174 7.99005 16.9112C7.98389 16.905 7.99005 16.8927 7.98389 16.8804V16.8865Z"
        fill="#214063"
      />
      <path
        d="M7.93953 19.1824H7.94582V19.1949C7.95211 19.1949 7.93953 19.2075 7.94582 19.2075C7.95211 19.2075 7.93324 19.2264 7.92066 19.2264H7.90808C7.90808 19.2201 7.8892 19.2138 7.90179 19.2075C7.91437 19.2012 7.90808 19.1949 7.91437 19.1886C7.92066 19.1824 7.92066 19.1886 7.92066 19.1886H7.93953C7.93324 19.1761 7.93953 19.1761 7.93953 19.1824Z"
        fill="#214063"
      />
      <path
        d="M8.02063 16.9806V16.9929C8.01447 16.9929 8.0083 16.9806 8.0083 16.9806V16.9683L8.02063 16.9806Z"
        fill="#214063"
      />
      <path
        d="M8.06486 17.0056C8.05869 16.9995 8.05869 16.9871 8.05253 16.981C8.04636 16.9748 8.06486 16.9995 8.06486 17.0056Z"
        fill="#214063"
      />
      <path
        d="M8.14172 17.5786H8.13477C8.13582 17.578 8.13702 17.5776 8.13824 17.5776C8.13946 17.5776 8.14066 17.578 8.14172 17.5786Z"
        fill="#214063"
      />
      <path
        d="M8.31115 17.6232C8.31024 17.6232 8.30934 17.623 8.30849 17.6226C8.30765 17.6223 8.30688 17.6218 8.30624 17.6211C8.30559 17.6205 8.30508 17.6197 8.30473 17.6189C8.30438 17.618 8.3042 17.6171 8.3042 17.6162L8.31115 17.6232Z"
        fill="#214063"
      />
      <path
        d="M8.39838 17.6158C8.39838 17.6158 8.39838 17.6282 8.39221 17.6282C8.38605 17.6282 8.37988 17.6282 8.37988 17.6158C8.37988 17.6035 8.37988 17.6097 8.37988 17.6035L8.39838 17.6158Z"
        fill="#214063"
      />
      <path
        d="M8.32989 17.6287C8.32989 17.6287 8.33606 17.6287 8.32989 17.6348H8.32373C8.32373 17.6348 8.32989 17.6225 8.32989 17.6287Z"
        fill="#214063"
      />
      <path
        d="M8.17733 17.6977C8.17153 17.6977 8.17153 17.7035 8.16573 17.6977C8.15994 17.6919 8.17733 17.6919 8.17733 17.6977Z"
        fill="#214063"
      />
      <path
        d="M8.0216 17.2775L8.01465 17.2705H8.0216V17.2775Z"
        fill="#214063"
      />
      <path
        d="M8.0268 17.3206C8.0268 17.3267 8.03296 17.3329 8.0268 17.3329C8.02063 17.3329 8.01447 17.3144 8.0083 17.3082H8.01447C8.0083 17.3021 8.02063 17.3021 8.01447 17.2959C8.02084 17.3028 8.02512 17.3113 8.0268 17.3206Z"
        fill="#214063"
      />
      <path
        d="M8.20915 17.7485C8.20915 17.7501 8.20853 17.7516 8.20741 17.7527C8.2063 17.7539 8.20479 17.7545 8.20321 17.7545C8.19727 17.7545 8.20321 17.7485 8.19727 17.7485H8.20915Z"
        fill="#214063"
      />
      <path
        d="M8.26721 17.7485C8.26721 17.7485 8.26025 17.7555 8.26025 17.7485H8.26721Z"
        fill="#214063"
      />
      <path
        d="M8.21554 17.7611C8.21554 17.7673 8.22175 17.7735 8.20932 17.7735C8.1969 17.7735 8.20311 17.7611 8.20932 17.7549L8.21554 17.7611Z"
        fill="#214063"
      />
      <path
        d="M8.07788 17.4023H8.09046C8.09675 17.4212 8.10933 17.4464 8.09675 17.459H8.08417C8.08053 17.4557 8.07827 17.4512 8.07788 17.4464C8.07788 17.4401 8.06529 17.4338 8.07159 17.4212C8.0713 17.4178 8.07171 17.4144 8.07279 17.4111C8.07387 17.4079 8.0756 17.4049 8.07788 17.4023Z"
        fill="#214063"
      />
      <path
        d="M8.02142 17.4706C8.00909 17.4767 8.00909 17.4583 8.00293 17.4521V17.4336C8.012 17.4442 8.01835 17.4569 8.02142 17.4706Z"
        fill="#214063"
      />
      <path
        d="M8.01525 17.4601H8.0083L8.01525 17.4531L8.0083 17.4601H8.01525Z"
        fill="white"
      />
      <path
        d="M8.00222 18.5347H7.99593C7.98335 18.5221 8.00222 18.497 8.00851 18.4844H8.0148C8.01641 18.4932 8.01611 18.5022 8.01394 18.5109C8.01177 18.5196 8.00778 18.5277 8.00222 18.5347Z"
        fill="#214063"
      />
      <path
        d="M8.02142 17.5468V17.5591H8.00909C8.00292 17.553 8.00909 17.5406 8.00909 17.5345C8.01525 17.5345 8.00909 17.5345 8.00909 17.5283C8.01455 17.5335 8.01877 17.5398 8.02142 17.5468Z"
        fill="#214063"
      />
      <path
        d="M8.0153 17.5416C8.00834 17.5416 8.0153 17.5416 8.0153 17.5347V17.5416Z"
        fill="white"
      />
      <path
        d="M8.00909 17.5784L8.02142 17.6031C8.01526 17.6093 8.01526 17.6154 8.00909 17.6093C8.00293 17.6031 8.00293 17.5969 8.00293 17.5846V17.5723C8.00293 17.5723 8.00293 17.5846 8.00909 17.5784Z"
        fill="#214063"
      />
      <path d="M8.01525 17.585L8.0083 17.5919V17.585H8.01525Z" fill="white" />
      <path
        d="M7.78235 17.7356H7.77619C7.77002 17.7356 7.77002 17.7233 7.77002 17.7171C7.77002 17.7109 7.77002 17.7171 7.77002 17.7109C7.77385 17.7138 7.77696 17.7175 7.7791 17.7218C7.78124 17.7261 7.78235 17.7308 7.78235 17.7356Z"
        fill="#214063"
      />
      <path
        d="M8.67594 17.6917C8.66335 17.698 8.66336 17.6854 8.65706 17.6728C8.65077 17.6602 8.66965 17.6414 8.66336 17.6162H8.66965C8.66965 17.6351 8.69481 17.6728 8.67594 17.6917Z"
        fill="#214063"
      />
      <path
        d="M7.983 17.9177H7.97678C7.97678 17.9239 7.97057 17.9239 7.97057 17.9177C7.97057 17.9115 7.97057 17.9053 7.96436 17.9053H7.97057C7.983 17.8991 7.983 17.9053 7.983 17.9177Z"
        fill="#214063"
      />
      <path d="M7.96545 17.8058L7.9585 17.7988H7.96545V17.8058Z" fill="white" />
      <path
        d="M7.98304 18.0317H7.98921C7.99144 18.0342 7.99314 18.0372 7.9942 18.0403C7.99526 18.0435 7.99566 18.0469 7.99537 18.0502C7.99537 18.0564 7.99537 18.0626 7.98921 18.0626H7.97688C7.97071 18.0564 7.98304 18.0502 7.97688 18.0441H7.98304V18.0317Z"
        fill="#214063"
      />
      <path
        d="M8.52423 17.8235C8.52423 17.8297 8.51807 17.8235 8.51807 17.8174L8.52423 17.8235Z"
        fill="#214063"
      />
      <path
        d="M8.52401 17.8293H8.51807C8.52401 17.8293 8.52401 17.8233 8.52401 17.8174V17.8293Z"
        fill="#214063"
      />
      <path
        d="M8.18469 17.9873C8.18469 17.9996 8.19703 18.0181 8.19086 18.0305C8.1893 18.0315 8.18751 18.0322 8.18565 18.0324C8.18378 18.0327 8.18189 18.0325 8.1801 18.0319C8.17831 18.0313 8.17669 18.0303 8.17535 18.029C8.17401 18.0277 8.17299 18.0261 8.17236 18.0243C8.17236 18.012 8.18469 17.9996 8.18469 17.9873Z"
        fill="#214063"
      />
      <path
        d="M7.94553 18.1258C7.94553 18.1321 7.94554 18.1383 7.93932 18.1383C7.93311 18.1383 7.93311 18.1383 7.93311 18.1321C7.93311 18.1258 7.93311 18.1258 7.93311 18.1196H7.94553V18.1258Z"
        fill="#214063"
      />
      <path
        d="M8.36682 18.031C8.36682 18.031 8.36682 18.0433 8.36066 18.0433H8.35449V18.0248C8.36682 18.0125 8.36682 18.0248 8.36682 18.031Z"
        fill="#214063"
      />
      <path
        d="M7.91357 18.1443C7.91357 18.1505 7.91979 18.1443 7.91979 18.1443H7.91357Z"
        fill="#214063"
      />
      <path
        d="M8.64988 18.025C8.65597 18.0311 8.64988 18.0372 8.64988 18.0433H8.6377C8.6377 18.0311 8.64379 18.0128 8.64988 18.025Z"
        fill="#214063"
      />
      <path
        d="M8.52479 18.0503C8.53108 18.0566 8.53108 18.0503 8.53108 18.0503V18.0566C8.53108 18.0566 8.53737 18.0943 8.52479 18.1069H8.51221V18.0817L8.52479 18.0503Z"
        fill="#214063"
      />
      <path
        d="M8.29749 18.0877H8.29132C8.28515 18.0939 8.28515 18.0939 8.29132 18.1001C8.29749 18.1062 8.29749 18.0939 8.30365 18.0877C8.30982 18.0816 8.30982 18.1124 8.29749 18.1186C8.28516 18.1247 8.29132 18.1124 8.28516 18.1062V18.0939C8.28516 18.0939 8.29132 18.0877 8.29132 18.0939H8.29749C8.29749 18.0939 8.29132 18.0877 8.29749 18.0877Z"
        fill="#214063"
      />
      <path
        d="M7.75044 18.2011C7.75044 18.2027 7.74979 18.2043 7.74863 18.2055C7.74748 18.2066 7.74591 18.2073 7.74427 18.2073C7.74264 18.2073 7.74107 18.2066 7.73991 18.2055C7.73876 18.2043 7.73811 18.2027 7.73811 18.2011C7.73194 18.1949 7.74427 18.1888 7.73811 18.1826L7.75044 18.2011Z"
        fill="#214063"
      />
      <path
        d="M7.72555 18.805H7.73184C7.73184 18.805 7.71296 18.8176 7.73184 18.8176C7.75071 18.8176 7.71296 18.8428 7.70038 18.8428C7.70103 18.8477 7.70018 18.8528 7.69794 18.8573C7.69569 18.8617 7.69217 18.8654 7.6878 18.8679C7.68698 18.8679 7.68616 18.8678 7.68539 18.8674C7.68463 18.8671 7.68394 18.8667 7.68335 18.8661C7.68277 18.8655 7.6823 18.8648 7.68199 18.864C7.68167 18.8633 7.68151 18.8624 7.68151 18.8616C7.67522 18.8427 7.70667 18.8365 7.6878 18.8176C7.68823 18.806 7.69268 18.7948 7.70038 18.7861C7.70038 18.7924 7.71296 18.7924 7.71296 18.7924H7.72555C7.72388 18.7924 7.72228 18.7931 7.7211 18.7943C7.71992 18.7954 7.71926 18.797 7.71926 18.7987C7.71926 18.8004 7.71992 18.802 7.7211 18.8032C7.72228 18.8043 7.72388 18.805 7.72555 18.805Z"
        fill="#214063"
      />
      <path
        d="M7.90781 18.2204C7.90781 18.2204 7.9078 18.2328 7.90159 18.2328C7.89538 18.2328 7.89537 18.2266 7.88916 18.2204H7.89538C7.89538 18.2204 7.90781 18.2079 7.90781 18.2204Z"
        fill="#214063"
      />
      <path
        d="M8.4801 18.1446V18.1693C8.47393 18.1693 8.47393 18.1755 8.47393 18.1693C8.47393 18.1631 8.46777 18.157 8.47393 18.1446C8.4801 18.1323 8.47393 18.1446 8.4801 18.1446Z"
        fill="#214063"
      />
      <path
        d="M7.83887 18.2767C7.84508 18.2705 7.84508 18.2767 7.84508 18.2767C7.84673 18.2767 7.84831 18.2774 7.84948 18.2785C7.85064 18.2797 7.8513 18.2813 7.8513 18.2829C7.8513 18.2846 7.85064 18.2862 7.84948 18.2873C7.84831 18.2885 7.84673 18.2892 7.84508 18.2892C7.84427 18.2892 7.84346 18.289 7.8427 18.2887C7.84195 18.2884 7.84126 18.2879 7.84069 18.2873C7.84011 18.2868 7.83965 18.2861 7.83934 18.2853C7.83903 18.2846 7.83887 18.2838 7.83887 18.2829V18.2705V18.2767Z"
        fill="#214063"
      />
      <path
        d="M7.84582 18.2769V18.2838L7.83887 18.2769H7.84582Z"
        fill="white"
      />
      <path
        d="M7.8512 18.3714C7.85283 18.3714 7.8544 18.372 7.85556 18.3732C7.85671 18.3744 7.85736 18.3759 7.85736 18.3776C7.85736 18.3792 7.85671 18.3808 7.85556 18.3819C7.8544 18.3831 7.85283 18.3837 7.8512 18.3837V18.3961C7.83887 18.3899 7.84503 18.3776 7.83887 18.3714C7.84503 18.3714 7.84503 18.3714 7.84503 18.3652L7.8512 18.3714Z"
        fill="#214063"
      />
      <path
        d="M7.65607 18.3525H7.66223C7.66223 18.3587 7.6684 18.371 7.66223 18.3772C7.65896 18.3772 7.65583 18.3759 7.65351 18.3736C7.6512 18.3713 7.6499 18.3681 7.6499 18.3649C7.65029 18.3601 7.6525 18.3557 7.65607 18.3525Z"
        fill="#214063"
      />
      <path
        d="M8.50496 18.2897C8.50799 18.2931 8.50967 18.2974 8.50967 18.302C8.50967 18.3065 8.50799 18.3109 8.50496 18.3143C8.50496 18.3176 8.50366 18.3207 8.50135 18.323C8.49903 18.3254 8.4959 18.3267 8.49263 18.3267C8.48646 18.3267 8.48646 18.3205 8.4803 18.3143C8.47413 18.3082 8.48646 18.302 8.4803 18.2958C8.47413 18.2897 8.48646 18.2835 8.49263 18.2897H8.49879C8.49879 18.2897 8.49879 18.2897 8.50496 18.2897Z"
        fill="#214063"
      />
      <path
        d="M7.78866 18.3896C7.78866 18.3959 7.79488 18.4083 7.78245 18.4083C7.77002 18.4083 7.77002 18.4021 7.77002 18.3959H7.78866V18.3896Z"
        fill="#214063"
      />
      <path
        d="M8.33002 18.3208C8.32373 18.3208 8.32373 18.3145 8.32373 18.3083V18.2957H8.33002C8.32835 18.2957 8.32675 18.2963 8.32557 18.2975C8.32439 18.2987 8.32373 18.3003 8.32373 18.302H8.33002C8.33631 18.2957 8.33002 18.2894 8.33002 18.2831V18.2705C8.33516 18.2779 8.33792 18.2867 8.33792 18.2957C8.33792 18.3047 8.33516 18.3134 8.33002 18.3208Z"
        fill="#214063"
      />
      <path
        d="M7.88332 18.5162C7.87669 18.5096 7.88332 18.5096 7.88332 18.5162V18.5162Z"
        fill="#214063"
      />
      <path
        d="M8.19085 18.6474C8.19701 18.6474 8.19085 18.6412 8.19085 18.6351C8.19701 18.6412 8.19085 18.6474 8.19085 18.6536H8.18468C8.17852 18.6412 8.18468 18.6351 8.19085 18.6289V18.6474Z"
        fill="#214063"
      />
      <path
        d="M7.80042 18.7231C7.80042 18.7247 7.79977 18.7263 7.79861 18.7274C7.79745 18.7286 7.79589 18.7293 7.79425 18.7293C7.79262 18.7293 7.79105 18.7286 7.78989 18.7274C7.78874 18.7263 7.78809 18.7247 7.78809 18.7231V18.7108C7.78809 18.7108 7.79425 18.7169 7.79425 18.7108C7.79344 18.7108 7.79264 18.7106 7.79189 18.7103C7.79114 18.71 7.79046 18.7095 7.78989 18.7089C7.78932 18.7084 7.78887 18.7077 7.78856 18.7069C7.78825 18.7062 7.78809 18.7054 7.78809 18.7046H7.80042C7.80042 18.7108 7.80658 18.7169 7.80042 18.7231Z"
        fill="#214063"
      />
      <path
        d="M8.05902 18.7171C8.05902 18.7233 8.05902 18.7356 8.04669 18.7356C8.04313 18.7324 8.04092 18.728 8.04053 18.7233V18.7109H8.05286L8.05902 18.7171Z"
        fill="#214063"
      />
      <path
        d="M8.05309 18.7292H8.0593C8.05309 18.7354 8.05309 18.7292 8.04688 18.7292C8.05047 18.726 8.0527 18.7216 8.05309 18.7168C8.05309 18.723 8.0593 18.7168 8.05309 18.7292Z"
        fill="white"
      />
      <path
        d="M7.7888 18.6667H7.78258C7.78093 18.6667 7.77935 18.6661 7.77819 18.6649C7.77702 18.6637 7.77637 18.6622 7.77637 18.6605C7.77637 18.6589 7.77702 18.6573 7.77819 18.6561C7.77935 18.655 7.78093 18.6543 7.78258 18.6543H7.7888C7.7888 18.6605 7.79501 18.6667 7.7888 18.6667Z"
        fill="#214063"
      />
      <path
        d="M8.07764 18.7795H8.08358V18.7676C8.08277 18.772 8.08071 18.7761 8.07764 18.7795Z"
        fill="#214063"
      />
      <path
        d="M7.41111 19.0756C7.4174 19.0819 7.4174 19.0693 7.4174 19.0693C7.4174 19.0693 7.41111 19.0756 7.4174 19.0819H7.42369C7.42369 19.0882 7.41111 19.0882 7.4174 19.1008H7.42369V19.1197C7.42369 19.126 7.4174 19.1322 7.41111 19.1385C7.40482 19.1448 7.40482 19.1448 7.41111 19.1511H7.39853C7.39769 19.1545 7.39557 19.1573 7.39262 19.1591C7.38967 19.1609 7.38614 19.1614 7.3828 19.1606C7.37946 19.1597 7.3766 19.1576 7.37483 19.1546C7.37306 19.1517 7.37253 19.1482 7.37337 19.1448L7.36078 19.1322C7.35449 19.126 7.35449 19.1197 7.36078 19.1197H7.35449C7.36078 19.1071 7.36707 19.1008 7.36707 19.0882H7.37337C7.37966 19.0882 7.37966 19.0756 7.38595 19.0756C7.39224 19.0756 7.39224 19.0882 7.39853 19.0819H7.40482C7.40761 19.0807 7.40985 19.0784 7.41111 19.0756Z"
        fill="#214063"
      />
      <path
        d="M8.02071 18.8239C8.01714 18.827 8.01493 18.8314 8.01454 18.8362C8.00221 18.8362 8.00838 18.8239 8.00838 18.8239L8.02071 18.8115V18.8239Z"
        fill="#214063"
      />
      <path
        d="M7.96407 18.8993C7.95791 18.9055 7.95174 18.9055 7.95174 18.8993C7.95174 18.8931 7.94557 18.8993 7.94557 18.8931C7.94557 18.887 7.93325 18.9055 7.92708 18.8993C7.92092 18.8931 7.95174 18.8685 7.95791 18.8623H7.96407C7.96732 18.8679 7.96903 18.8743 7.96903 18.8808C7.96903 18.8873 7.96732 18.8937 7.96407 18.8993Z"
        fill="#214063"
      />
      <path
        d="M7.32278 19.56V19.5726H7.32907C7.32907 19.5789 7.31649 19.5789 7.32278 19.5852H7.32907C7.31649 19.5852 7.32278 19.5977 7.3102 19.604C7.29762 19.6103 7.29133 19.6103 7.28503 19.6166C7.28503 19.615 7.28437 19.6134 7.28319 19.6122C7.28201 19.611 7.28041 19.6103 7.27875 19.6103L7.26616 19.5915V19.5789H7.24729C7.23471 19.5726 7.24729 19.5663 7.24729 19.5537H7.25987C7.25987 19.5663 7.27245 19.5537 7.27875 19.5537H7.32278C7.32278 19.5537 7.3102 19.56 7.32278 19.56Z"
        fill="#214063"
      />
      <path
        d="M7.6127 18.9437C7.6127 18.95 7.61899 18.9626 7.6127 18.9688L7.59383 18.9814C7.58125 18.9751 7.58125 18.9688 7.57496 18.9563C7.56867 18.9437 7.58125 18.9437 7.58754 18.9374L7.60012 18.9248C7.60012 18.9374 7.60641 18.9374 7.6127 18.9437Z"
        fill="#214063"
      />
      <path
        d="M7.83136 18.9812C7.83752 18.9935 7.81286 18.9874 7.81902 19.0058C7.82519 19.0243 7.80053 19.0182 7.79436 19.012C7.7882 19.0058 7.78203 18.9997 7.7882 18.9935V18.9812C7.79436 18.9874 7.79436 18.9812 7.79436 18.9812H7.82519C7.83135 18.975 7.82519 18.975 7.83136 18.9812Z"
        fill="#214063"
      />
      <path
        d="M7.62421 19.2332C7.62421 19.2332 7.61805 19.2394 7.62421 19.2394C7.61805 19.2455 7.63038 19.2579 7.61805 19.2579C7.60572 19.2579 7.60571 19.264 7.60571 19.2702C7.60093 19.2702 7.59621 19.2691 7.59193 19.2669C7.58765 19.2648 7.58393 19.2617 7.58105 19.2579V19.2455C7.58722 19.2517 7.58106 19.2394 7.58722 19.2394C7.59339 19.2394 7.58722 19.2332 7.59339 19.2332H7.61188C7.62421 19.227 7.61188 19.2332 7.62421 19.2332Z"
        fill="#214063"
      />
      <path
        d="M7.31663 19.2013H7.3042V19.1888C7.30585 19.1888 7.30743 19.1882 7.30859 19.187C7.30976 19.1858 7.31041 19.1843 7.31041 19.1826H7.32284L7.31663 19.2013Z"
        fill="#214063"
      />
      <path
        d="M7.11497 19.0065C7.10875 19.0065 7.10254 19.0065 7.10254 18.9941C7.10254 18.9817 7.10254 18.9879 7.10254 18.9879C7.10254 18.9879 7.12118 19.0003 7.11497 19.0065Z"
        fill="#214063"
      />
      <path
        d="M7.27903 19.39H7.28524C7.28524 19.3962 7.27903 19.3962 7.27282 19.3962C7.2666 19.3962 7.2666 19.39 7.2666 19.3838H7.27903V19.39Z"
        fill="#214063"
      />
      <path
        d="M7.22266 19.1886V19.1826C7.22266 19.1826 7.2286 19.1826 7.22266 19.1886Z"
        fill="#214063"
      />
      <path
        d="M7.22918 19.1895C7.22219 19.1965 7.22918 19.1825 7.22918 19.1895V19.1895Z"
        fill="white"
      />
      <path
        d="M7.09577 19.1823H7.10193C7.09577 19.1823 7.10193 19.1884 7.09577 19.1946H7.10193C7.09577 19.1946 7.10193 19.2007 7.09577 19.2007H7.10193C7.0896 19.2069 7.08344 19.2254 7.06494 19.2131V19.1946V19.1699H7.07727C7.08344 19.1699 7.07727 19.1699 7.07727 19.1761C7.07891 19.1761 7.08048 19.1754 7.08163 19.1743C7.08279 19.1731 7.08344 19.1716 7.08344 19.1699C7.08344 19.1761 7.0896 19.1761 7.09577 19.1823H7.10193C7.10193 19.1761 7.0896 19.1761 7.09577 19.1823Z"
        fill="#214063"
      />
      <path
        d="M7.18438 19.3523C7.17809 19.3586 7.18438 19.3586 7.18438 19.3586C7.18438 19.3649 7.19067 19.3586 7.18438 19.3586C7.18438 19.3523 7.18438 19.3712 7.17809 19.3712C7.1718 19.3712 7.18438 19.3712 7.18438 19.3775C7.18438 19.3837 7.17809 19.3712 7.17809 19.3775C7.17809 19.3837 7.15921 19.3837 7.15921 19.39H7.13405C7.13238 19.39 7.13078 19.3894 7.1296 19.3882C7.12842 19.387 7.12776 19.3854 7.12776 19.3837H7.12147C7.12147 19.3712 7.10889 19.3775 7.11518 19.3712C7.12147 19.3649 7.10889 19.3712 7.10889 19.3649H7.11518C7.1026 19.3586 7.11518 19.3523 7.10889 19.346C7.11056 19.346 7.11216 19.3453 7.11333 19.3442C7.11451 19.343 7.11518 19.3414 7.11518 19.3397H7.10889C7.11518 19.3397 7.11518 19.3334 7.11518 19.3271C7.11518 19.3208 7.13405 19.3334 7.12776 19.3208C7.12147 19.3083 7.14034 19.3271 7.14663 19.3208C7.14663 19.3208 7.14034 19.3271 7.14663 19.3271H7.15292C7.15292 19.3271 7.15292 19.3397 7.15921 19.3397H7.1655V19.3523H7.1718V19.3649H7.18438C7.17809 19.3397 7.18438 19.346 7.18438 19.3523Z"
        fill="#214063"
      />
      <path
        d="M6.93916 19.3151H6.94545V19.334C6.93916 19.334 6.94545 19.3465 6.93916 19.3465C6.93287 19.3465 6.93916 19.3591 6.93287 19.3528C6.93287 19.3537 6.93303 19.3545 6.93335 19.3552C6.93367 19.356 6.93413 19.3567 6.93471 19.3573C6.9353 19.3579 6.93599 19.3583 6.93675 19.3586C6.93752 19.359 6.93834 19.3591 6.93916 19.3591H6.914C6.90771 19.3591 6.90771 19.3465 6.90142 19.3528L6.88884 19.3403V19.3214C6.88884 19.3151 6.89513 19.3151 6.88884 19.3088C6.88255 19.3025 6.88884 19.3025 6.89513 19.2962H6.90142V19.2836C6.90142 19.2828 6.90158 19.282 6.9019 19.2812C6.90221 19.2805 6.90268 19.2798 6.90326 19.2792C6.90384 19.2786 6.90454 19.2781 6.9053 19.2778C6.90606 19.2775 6.90688 19.2773 6.90771 19.2773C6.914 19.2836 6.914 19.2773 6.92029 19.2773C6.92658 19.2773 6.914 19.2836 6.92029 19.2836H6.92658C6.93287 19.2899 6.93287 19.2773 6.93287 19.2773C6.93287 19.2773 6.94545 19.3088 6.93916 19.3151Z"
        fill="#214063"
      />
      <path
        d="M7.15243 19.5909C7.15085 19.5909 7.14934 19.5903 7.14823 19.5892C7.14711 19.588 7.14648 19.5865 7.14648 19.585H7.15837L7.15243 19.5909Z"
        fill="#214063"
      />
      <path
        d="M7.19051 19.8107H7.18457C7.18457 19.8048 7.19051 19.8048 7.19051 19.7988H7.19646C7.19646 19.8048 7.19645 19.8107 7.19051 19.8107Z"
        fill="#214063"
      />
      <path
        d="M6.93905 19.4211H6.93311V19.4092H6.93905C6.93905 19.4092 6.9331 19.4151 6.93905 19.4151C6.93905 19.4151 6.94499 19.4151 6.93905 19.4211Z"
        fill="#214063"
      />
      <path
        d="M6.99557 19.598C7.00174 19.598 7.00174 19.6041 7.00174 19.6103L6.98324 19.6226L6.96475 19.6041C6.95858 19.6041 6.97091 19.598 6.95858 19.598C6.94625 19.598 6.97091 19.5918 6.96475 19.5918H6.99557V19.598Z"
        fill="#214063"
      />
      <path
        d="M6.96414 19.5727C6.96414 19.579 6.95785 19.579 6.95785 19.5853C6.95156 19.579 6.95156 19.5853 6.95156 19.5853C6.95156 19.579 6.95156 19.5853 6.94527 19.579C6.9436 19.579 6.942 19.5784 6.94082 19.5772C6.93964 19.576 6.93898 19.5744 6.93898 19.5727C6.93269 19.5853 6.9264 19.5727 6.92011 19.5727C6.92011 19.5719 6.91994 19.5711 6.91963 19.5703C6.91931 19.5696 6.91885 19.5689 6.91826 19.5683C6.91768 19.5677 6.91699 19.5672 6.91622 19.5669C6.91546 19.5666 6.91464 19.5664 6.91381 19.5664C6.91381 19.5539 6.90123 19.5539 6.90752 19.535C6.91381 19.535 6.90752 19.5287 6.90752 19.5287H6.91381C6.91381 19.5224 6.9264 19.5224 6.9264 19.5161H6.93898C6.94527 19.5224 6.94527 19.5287 6.95156 19.5287C6.96414 19.5539 6.95785 19.5727 6.96414 19.5727Z"
        fill="#214063"
      />
      <path
        d="M6.83221 19.5414C6.83221 19.5431 6.83288 19.5447 6.83406 19.5459C6.83523 19.5471 6.83683 19.5477 6.8385 19.5477C6.84479 19.554 6.84479 19.5477 6.84479 19.5477C6.84479 19.5494 6.84413 19.551 6.84295 19.5522C6.84177 19.5534 6.84017 19.554 6.8385 19.554H6.84479C6.8385 19.554 6.83221 19.5603 6.8385 19.5666C6.83221 19.5729 6.84479 19.5792 6.83221 19.5792C6.83449 19.5817 6.83622 19.5847 6.8373 19.588C6.83838 19.5912 6.83879 19.5946 6.8385 19.5981C6.83221 19.5981 6.8385 19.6043 6.83221 19.6043C6.83221 19.6106 6.82592 19.6043 6.82592 19.6106H6.81334C6.81334 19.609 6.81268 19.6074 6.8115 19.6062C6.81032 19.605 6.80872 19.6043 6.80705 19.6043C6.80076 19.6043 6.80705 19.6106 6.80705 19.6169C6.80705 19.6232 6.80076 19.5981 6.79447 19.6043H6.7693C6.7693 19.5981 6.7693 19.5981 6.76301 19.5981V19.5855C6.75672 19.5918 6.76301 19.5792 6.75672 19.5792C6.75043 19.5792 6.75043 19.5729 6.75043 19.5729C6.75043 19.5666 6.75043 19.5666 6.74414 19.5603C6.74414 19.5603 6.75043 19.554 6.74414 19.554C6.74414 19.5523 6.7448 19.5507 6.74598 19.5496C6.74716 19.5484 6.74876 19.5477 6.75043 19.5477V19.5351H6.75672C6.76301 19.5289 6.75043 19.51 6.76301 19.51H6.7693C6.7756 19.51 6.7756 19.5037 6.78189 19.4974C6.78818 19.4911 6.79447 19.51 6.79447 19.5037C6.79447 19.4974 6.79447 19.4974 6.80076 19.4974C6.80705 19.4974 6.79447 19.51 6.80076 19.51H6.80705V19.5226H6.82592C6.82592 19.5163 6.82592 19.5289 6.83221 19.5289V19.5414Z"
        fill="#214063"
      />
      <path
        d="M7.53653 19.4469C7.53037 19.4469 7.53037 19.4592 7.51804 19.4531C7.50571 19.4469 7.50571 19.4346 7.51804 19.4346H7.53037C7.53037 19.4407 7.53653 19.4346 7.53653 19.4469C7.53653 19.4592 7.53037 19.4407 7.53653 19.4469Z"
        fill="#214063"
      />
      <path
        d="M7.48633 19.4777L7.49227 19.4658H7.49821L7.48633 19.4777Z"
        fill="#214063"
      />
      <path
        d="M7.48679 19.4909H7.49308V19.5035H7.49938L7.47421 19.5286C7.46792 19.5286 7.45534 19.5224 7.45534 19.5349H7.44905L7.43018 19.5224C7.43647 19.5161 7.43018 19.5161 7.43018 19.5098C7.43018 19.5035 7.43647 19.4972 7.43018 19.4972H7.43647C7.43647 19.4909 7.43018 19.4909 7.43018 19.4846H7.43647C7.43647 19.4783 7.44276 19.4783 7.44905 19.472C7.45534 19.4657 7.45534 19.4594 7.45534 19.4532C7.45534 19.4469 7.46163 19.472 7.46792 19.472C7.4805 19.472 7.46792 19.4846 7.4805 19.4846V19.4657C7.47421 19.472 7.47421 19.4846 7.48679 19.4909Z"
        fill="#214063"
      />
      <path
        d="M7.41113 19.4722L7.41809 19.4791L7.41113 19.4722Z"
        fill="#214063"
      />
      <defs>
        <linearGradient
          id="paint0_linear_888_37319"
          x1="6.06592"
          y1="2.33543"
          x2="12.2391"
          y2="13.0443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#36FFF1" />
          <stop offset="0.09" stopColor="#31F0ED" />
          <stop offset="0.53" stopColor="#17A6DB" />
          <stop offset="0.84" stopColor="#0678D0" />
          <stop offset="1" stopColor="#0066CC" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WarrantyIcon;
